export default {
    "corporate": "โปรแกรมองค์กร",
    "onboarding": {
        "goal_desc": "คุณจะได้รับ %{customPoints} คะแนนจากการติดตามกิจกรรม และโบนัส %{customPoints} คะแนนเมื่อบรรลุเป้าหมายของคุณ ได้เวลาเริ่มต้นแล้ว! คุณสามารถมีเป้าหมายส่วนบุคคลได้ 3 เป้าหมายพร้อมกัน",
        "sample_task": {
            "modalActivityTitle": "หายใจลึก ๆ 3 ครั้ง",
            "rewards_featured_title": "คุณสมบัติ",
            "rewards_partners_title": "พันธมิตร",
            "header_description": "คุณจะได้รับ %{customPoints} จากการติดตามกิจกรรมและทำงาน เป้าหมาย และชาเลนจ์ให้สำเร็จ",
            "icon_text": "แตะ {icon} เพื่อติดตามการหายใจลึก ๆ",
            "activityName": "การหายใจลึก ๆ",
            "activityUnit": "การหายใจ"
        },
        "lets_get_started": "มาเริ่มกันเลย!",
        "start_description": "คุณจะได้รับ %{customPoints} จากการติดตามกิจกรรมและทำงาน เป้าหมาย และชาเลนจ์ให้สำเร็จ",
        "complete_and_earn": "สำเร็จแล้วรับ",
        "did_it": "ฉันทำได้!",
        "task_complete": "งานเสร็จสมบูรณ์แล้ว!",
        "breath_sample_task": "ดูบทแนะนำสั้น ๆ เกี่ยวกับการติดตามกิจกรรม",
        "track_a_sample_activity": "ติดตามกิจกรรมตัวอย่าง",
        "nice": "เยี่ยม!",
        "nice_one": "ทำดีมาก!",
        "nice_subtext_1": "คุณได้รับ %{points} %{customPoints}",
        "nice_subtext_2": "การรับ %{customPoints} จะช่วยให้คุณเลื่อนระดับได้ แต่ละครั้งที่คุณเลื่อนระดับ คุณจะได้รับ %{reward_currency} ซึ่งสามารถแลกรับข้อเสนอดี ๆ ได้",
        "nice_subtext_3": "คุณจะได้รับคะแนนมากขึ้นเมื่อคุณทำงานให้เสร็จมากขึ้น ติดตามกิจกรรม บรรลุเป้าหมายและชาเลนจ์",
        "progress_subtitle": "%{customPoints} และความคืบหน้าจะรีเซ็ตทุก ๆ %{frequency}",
        "skip_for_now": "ข้ามสำหรับตอนนี้",
        "loadingText": "อดทนรอในขณะที่เราคำนวณคะแนนสุขภาพของคุณ",
        "goal_title": "กำหนดเป้าหมายเฉพาะคุณ",
        "swipe_for_more": "เลื่อนดูเพิ่มเติม",
        "skip_goals": "ตอนนี้ ฉันกำหนดเป้าหมายเสร็จแล้ว",
        "complete_profile": "",
        "level": "ระดับ",
        "finish_onboarding_action": "กรุณาเริ่มต้นใช้งานให้เสร็จสิ้นก่อน",
        "vital_stats": {
            "height_ft": "ส่วนสูง ฟุต",
            "height_in": "ส่วนสูง นิ้ว"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "ความเป็นส่วนตัวของคุณเป็นสิ่งสำคัญ"
        },
        "levels": {
            "title": "ความสำเร็จและรางวัล",
            "tableTitle": "ความสำเร็จ"
        },
        "initialScreen": {
            "title": "ยินดีต้อนรับสู่ %{programName}, %{username}!",
            "getRewarded": "รับรางวัลด้วย %{rewardName}",
            "completeAgainst": "แข่งขันกับเพื่อนร่วมงานของคุณ",
            "earnPoints": "รับคะแนนจากกิจกรรมเพื่อสุขภาพ",
            "levelUp": "เลื่อนระดับและปลดล็อกเหรียญตรา"
        },
        "starterGoals": {
            "title": "เลือกเป้าหมาย",
            "subtitle": "เริ่มต้นการเดินทางเพื่อสุขภาพที่ดีของคุณด้วยนิสัยใหม่ที่ดีต่อสุขภาพ"
        }
    },
    "healthkit_not_available": "ไม่สามารถเชื่อมต่อกับ Apple Health ในแอป Health ด้านล่างแหล่งข้อมูล ตรวจสอบให้แน่ใจว่าคุณมีสิทธิ์เปิดใช้งานขั้นตอนขั้นต่ำและมีการติดตามอย่างน้อย 1 ขั้นตอน",
    "changeCover": "เปลี่ยนภาพถ่าย",
    "joiningCommunityToast": {
        "success": {
            "message": "คุณเข้าร่วม %{name} สำเร็จแล้ว",
            "title": "เข้าร่วมชุมชน"
        }
    },
    "achievement_starts_date": "เริ่ม: %{date}",
    "editChallenge": "แก้ไข %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "เลือกได้ถึง 5 กิจกรรม",
            "title": "คุณประสงค์จะทำอะไร?",
            "noActivityTitle": "การเพิ่มกิจกรรม",
            "noActivityMessage": "เลือกอย่างน้อยหนึ่งกิจกรรมหรือหมวดหมู่",
            "categoryItemDescription": "กิจกรรมทั้งหมดในหมวดหมู่ %{category}",
            "addActivityTitle": "คุณต้องการทำ %{unit} ของ %{activity} จำนวนเท่าใดต่อ %{period}",
            "addCategoryQuantityTitle": "คุณต้องการรับ %{customPoints} เท่าไรในหมวดหมู่ %{category}?",
            "subtitleCategories": "เลือกหนึ่งหมวดหมู่ กิจกรรมทั้งหมดจากหมวดหมู่นั้นจะนำไปสู่เป้าหมาย",
            "subtitleWithActivities": "%{num} จาก %{max} กิจกรรมที่เลือก",
            "selectCategoryMessage": "กิจกรรมทั้งหมดในหมวดหมู่จะถูกเลือก และกิจกรรมที่เลือกไว้ก่อนหน้านี้จะถูกยกเลิก",
            "addActivityTitleTotal": "คุณต้องการทำ %{activity} เท่าใดใน %{period}?"
        },
        "inviteDepartments": {
            "title": "เชิญแผนก"
        },
        "inviteRegions": {
            "title": "เชิญภูมิภาค"
        },
        "createInvitation": {
            "selectMore": "กรุณาเลือกอย่างน้อย 2 %{entity}!"
        },
        "visibility": {
            "title": "การมองเห็น",
            "description": "ผู้ใช้ %{programName} ทุกคนสามารถค้นหาและเข้าร่วมชาเลนจ์ทีมได้"
        },
        "highest": {
            "name": "ชนะ %{customPoints} ส่วนใหญ่",
            "description": "ไม่มีขีดจำกัด %{customPoints} สูงสุดจะครองอันดับ 1"
        },
        "compete": {
            "individual": "แข่งขันแบบเดี่ยว",
            "team": "แข่งขันแบบทีม"
        },
        "unitType": {
            "title": "เลือกวิธีที่คุณบรรลุเป้าหมายของคุณ",
            "subtitle": "เลือกจากกิจกรรมหรือหมวดหมู่"
        },
        "category": {
            "name": "กิจกรรมทั้งหมดในหมวดหมู่",
            "description": "เช่น. ติดตามกิจกรรมใด ๆ ใน 'เคลื่อนไหว'",
            "title": "เลือกหมวดหมู่",
            "subtitle": "คุณจะติดตามกิจกรรมจากหมวดหมู่ใด?"
        },
        "activities": {
            "name": "กิจกรรมที่เลือก",
            "description": "เช่น. ติดตามกิจกรรมเฉพาะ เช่น การปั่นจักรยาน",
            "title": "เลือกกิจกรรม",
            "subtitle": "เราแนะนำให้เน้นที่กิจกรรมเดียว แต่คุณสามารถเพิ่มได้มากถึง 5 กิจกรรม",
            "maxModalTitle": "เลือกกิจกรรมสูงสุดแล้ว",
            "maxModalDescription": "คุณสามารถเพิ่มได้สูงสุด 5 กิจกรรม แตะยอมรับเพื่อดำเนินการกับ 5 กิจกรรมที่คุณเลือก หรือแก้ไขเพื่อทำการเปลี่ยนแปลง",
            "warningModalTitle": "ความยากระดับสูง",
            "warningModalDescription": "คุณได้ระบุกิจกรรมจำนวนมากที่ต้องทำต่อช่วงเวลาในเป้าหมายนี้ คุณแน่ใจหรือไม่ว่าต้องการกำหนดเป้าหมายชาเลนจ์เช่นนี้?",
            "requiredPoints": "จำเป็นต้องตรงตาม %{period} %{challengeType}",
            "noActivitiesModalTitle": "การเพิ่มกิจกรรม",
            "noActivitiesModalDescription": "เลือกอย่างน้อยหนึ่งกิจกรรม"
        },
        "categoryQuantity": {
            "title": "กำหนดเป้าหมาย %{customPoints} ของคุณ",
            "subtitle": "คุณต้องการรับจาก %{category} ในแต่ละ %{period}? กี่ %{customPoints} ?",
            "subtitleTotal": "คุณต้องการรับจาก %{category} ใน %{period}? กี่ %{customPoints} ?",
            "text": "ตามแนวทางปฏิบัติ กิจกรรมปานกลางระยะเวลา 30 นาที เทียบเท่าประมาณ 105 %{customPoints}",
            "noQuantityModalTitle": "จำนวน",
            "noQuantityModalDescription": "กรอกค่า",
            "defaultCategoryTitle": "หมวดหมู่ปัจจุบัน"
        },
        "cancel": {
            "title": "ยกเลิกการสร้างชาเลนจ์",
            "message": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการสร้างชาเลนจ์?"
        },
        "createNew": "สร้างชาเลนจ์ใหม่",
        "chooseChallengeTitle": "เลือกชาเลนจ์หรือสร้างชาเลนจ์ของคุณเอง",
        "createOwn": {
            "title": "สร้างของฉันเอง"
        },
        "frequency": {
            "title": "คุณจะบรรลุเป้าหมายของคุณบ่อยเพียงใด?",
            "subtitle": "เป้าหมายรายวัน คือการสร้างนิสัยที่ดี"
        },
        "startAndDuration": {
            "title": "เลือกวันที่เริ่มต้นและระยะเวลา",
            "subtitle": "",
            "noFieldsTitle": "วันที่เริ่มต้นและระยะเวลา",
            "noFieldsMessage": "กรุณากรอกวันที่เริ่มต้นและระยะเวลา"
        },
        "finalize": {
            "title": "ตรวจสอบเป้าหมายใหม่ของคุณ",
            "subtitle": "",
            "noFieldsTitle": "ชื่อและคำแนะนำ",
            "noFieldsMessage": "กรุณากรอกชื่อและคำแนะนำ",
            "name": "เป้าหมาย %{names} %{frequency} ของฉัน",
            "instructionCategory": "รับ %{points} %{customPoints} %{frequency} จากกิจกรรม %{category} ทั้งหมด",
            "instructionActivities": "ติดตาม %{items} %{frequency} แล้วรับ %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "รับ %{customPoints} มากที่สุดจากกิจกรรม %{category} ทั้งหมดเพื่อชนะการแข่งขันนี้",
            "instructionCompetitionActivities": "รับ %{customPoints} มากที่สุดจาก %{items} เพื่อชนะการแข่งขันนี้",
            "namePlaceholder": "ตั้งชื่อการแข่งขันของคุณ",
            "titleChallenge": "จบชาเลนจ์ของคุณ"
        },
        "dailyDescription": "เช่น ดื่มน้ำวันละ 8 แก้ว",
        "weeklyDescription": "เช่น เดิน 150 นาทีในแต่ละสัปดาห์",
        "monthlyDescription": "เช่น วิ่ง 150 กม. ในแต่ละเดือน",
        "totalDescription": "เช่น ปั่นจักรยานรวม 10,000 กม.",
        "title": "ชาเลนจ์ตัวเองหรือคนอื่น ๆ?",
        "navigatorTitle": "สร้างชาเลนจ์",
        "me": {
            "name": "แค่ตัวเอง",
            "description": "ชาเลนจ์ตัวเองด้วยเป้าหมายส่วนบุคคล"
        },
        "others": {
            "name": "แข่งขันกับคนอื่น ๆ",
            "description": "แข่งขันแบบเดี่ยวหรือแบบทีม"
        },
        "one": {
            "name": "แบบเดี่ยว",
            "description": "แข่งขันแบบเดี่ยวกับผู้ใช้รายอื่น ๆ"
        },
        "team": {
            "name": "แบบทีม",
            "description": "แบ่งขันแบบทีมกับทีมอื่น ๆ"
        },
        "company": {
            "name": "ชาเลนจ์ของบริษัท",
            "description": "สร้างการแข่งขันพิเศษ"
        },
        "adminItemTitle": "ในฐานะผู้ดูแลระบบ คุณสามารถสร้าง",
        "userOrTeamTitle": "แข่งขันแบบเดี่ยวหรือแบบทีม?",
        "target": {
            "name": "กำหนดเป้าหมายเพื่อบรรลุ",
            "description": "ชาเลนจ์ที่มีขีดจำกัดบน"
        },
        "typeTitle": "เลือกประเภท %{challengeType}",
        "teamSizeTitle": "เลือกขนาดสำหรับแต่ละทีม",
        "teamSizeSubtitle": "ขนาดขั้นต่ำของทีมคือ %{min} และสูงสุดคือ %{max} %{customPoints} ของทีมคุณ คือค่าเฉลี่ยของสมาชิกทั้งหมดในทีม และคุณจะได้รับ %{customPoints} เมื่อทีมของคุณมีสมาชิกครบตามจำนวนขั้นต่ำเท่านั้น",
        "teamSize": {
            "noFieldsTitle": "ต่ำสุดและสูงสุด",
            "noFieldsMessage": "เลือกจำนวนสมาชิกต่ำสุดและสูงสุดในทีม"
        },
        "companyChallengeTitle": "ชาเลนจ์ของบริษัท",
        "companyChallengeSubtitle": "คุณเป็นผู้ดูแลระบบ คุณสามารถกำหนดชาเลนจ์ของแผนกและประเภทอื่น ๆ ได้",
        "chooseDepartmentTitle": "เลือกแผนกเพื่อแข่งขัน",
        "chooseRegionTitle": "เลือกภูมิภาคเพื่อแข่งขัน",
        "goToChallenge": "ไปยังชาเลนจ์ของฉัน",
        "additional": {
            "title": "สร้างชาเลนจ์แล้ว",
            "subtitle": "มาเริ่มกันเลย! เชิญคนอื่นเข้าร่วม",
            "makePublicName": "ทำให้เป็นสาธารณะ",
            "makePublicDescription": "ใครก็ตามสามารถเข้าร่วม",
            "toDirectoryName": "ส่งไปที่หมวดหมู่ชาเลนจ์",
            "toDirectoryDescription": "บุคคลสามารถสร้างได้แบบนี้",
            "inviteTitle": "เชิญมาชาเลนจ์",
            "titleGoal": "สร้างเป้าหมายแล้ว!"
        },
        "quantityMinimum": {
            "message": "จำนวนที่ต้องการขั้นต่ำคือ %{quantity}",
            "title": "จำนวนไม่เพียงพอ"
        },
        "toast": {
            "success": "สร้าง %{challengeType} ของคุณแล้ว"
        },
        "goToGoal": "ไปยังเป้าหมายของฉัน",
        "navigatorTitleGoal": "สร้างเป้าหมาย",
        "quantityError": {
            "wholeNumber": "ต้องเป็นจำนวนเต็ม",
            "greaterThanZero": "ต้องมากกว่า 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "คะแนนความเป็นอยู่ที่ดีของคุณคำนวณโดยการเปรียบเทียบคำตอบที่คุณให้ไว้ในแบบสำรวจสุขภาพกับคนอื่น ๆ หลายล้านคนในหมวดหมู่อายุและเพศเดียวกันกับคุณ คะแนนของคุณแสดงให้เห็นว่าคุณอยู่ในอันดับใดที่มีความสัมพันธ์กับพวกเขา คะแนนของคุณจะอัปเดตโดยอัตโนมัติในแต่ละเดือนตามการเปลี่ยนแปลงในพฤติกรรมการเคลื่อนไหว การกิน และความรู้สึกที่กรอกในแอป การกำหนดเป้าหมายที่สอดคล้องและการดำเนินการในเชิงบวกเพื่อปรับปรุงสุขภาพของคุณสามารถช่วยเพิ่มคะแนนความเป็นอยู่ที่ดีของคุณได้",
            "excellent": "คะแนนสุขภาพของคุณดีกว่า 85% ของคนที่อายุและเพศเดียวกันกับคุณ ",
            "very_good": "คะแนนสุขภาพของคุณดีกว่า 70-84% ของคนที่อายุและเพศเดียวกันกับคุณ",
            "good": "คะแนนสุขภาพของคุณดีกว่า 51-69% ของคนที่อายุและเพศเดียวกันกับคุณ",
            "fair": "คะแนนสุขภาพของคุณดีกว่า 31-50% ของคนที่อายุและเพศเดียวกันกับคุณ",
            "poor": "คะแนนสุขภาพของคุณต่ำกว่า 70% ของคนที่อายุและเพศเดียวกันกับคุณ ไม่เคยสายเกินไปที่จะเริ่มจัดลำดับความสำคัญของสุขภาพคุณ ใช้ประโยชน์จากแพลตฟอร์มของเราเพื่อช่วยให้คุณมีความคืบหน้าในด้านสุขภาพของคุณ!",
            "overall_result": "โดยรวมแล้ว คะแนนสุขภาพของคุณคือ %{status}",
            "category_result": "โดยรวมแล้ว คะแนน {category} ของคุณคือ {string}",
            "goals": "คุณไม่สามารถชนะได้หากไม่มีเป้าหมาย กำหนดเป้าหมายส่วนบุคคลสูงสุด 3 เป้าหมายและติดตามเป้าหมายเหล่านั้น เมื่อเวลาผ่านไปเมื่อคุณเปลี่ยนแปลงรูปแบบการใช้ชีวิต คุณจะเห็นคะแนนของคุณเพิ่มขึ้น"
        },
        "reminder": {
            "title": "ถึงเวลาอัปเดตแบบสำรวจสุขภาพของคุณแล้ว!",
            "updateAnswers": "อัปเดตคำตอบของฉัน"
        },
        "lastUpdated": "อัปเดตล่าสุด %{date}",
        "scoreDescription": {
            "part1": "คะแนนของคุณ คือ",
            "part2": "คะแนนของ",
            "belowAverage": "ต่ำกว่าค่าเฉลี่ย",
            "aboveAverage": "สูงกว่าค่าเฉลี่ย",
            "part3": "สำหรับคนอื่น ๆ ที่มีอายุและเพศเดียวกับคุณ"
        },
        "improveScore": {
            "description": "คะแนนของคุณคำนวณจากคำตอบแบบสำรวจด้านสุขภาพและกิจกรรมที่ติดตาม คุณสามารถอัปเดตคำตอบแบบสำรวจของคุณหรือกำหนดเป้าหมายใหม่เพื่อปรับปรุง",
            "desc1": "คะแนนของคุณสูงมากไปกว่านี้ไม่ได้แล้ว! เพื่อให้กิจวัตรของคุณน่าสนใจอยู่เสมอ ชาเลนจ์ตัวเองด้วยเป้าหมายที่เกินความสามารถปกติของคุณ และเชิญผู้อื่นให้แข่งขันกับคุณเพื่อสร้างแรงจูงใจ",
            "desc2": "หากคุณพร้อมที่จะเพิ่มระดับ ก็ถึงเวลาเพิ่มความท้าทาย ชาเลนจ์ตัวเองด้วยเป้าหมายที่เกินความสามารถปกติของคุณ และเชิญผู้อื่นให้แข่งขันกับคุณเพื่อสร้างแรงจูงใจ",
            "desc3": "กำหนดเป้าหมายส่วนบุคคลและสร้างชาเลนจ์สาธารณะเพื่อให้ตัวเองมีความรับผิดชอบและมีแรงจูงใจ อย่าลืมเลือกเป้าหมายที่ทำได้และกรอบเวลาที่เล็กลง เราขอแนะนำ 1 สัปดาห์",
            "desc4": "สิ่งสำคัญคือต้องมีความกระฉับกระเฉงทุกวัน หากคุณไม่มีการเคลื่อนไหวในชีวิตประจำวันมากนัก ให้เริ่มด้วยเป้าหมายเล็ก ๆ ที่ตรงกับความสามารถและความสนใจของคุณ อย่าลืมเลือกเป้าหมายที่ทำได้และกรอบเวลาที่เล็กลง เราขอแนะนำ 1 สัปดาห์"
        },
        "recommendedGoals": "เป้าหมายที่แนะนำ",
        "recommendedDescription": {
            "desc1": "คุณสามารถกำหนดได้ถึง ",
            "desc2": "3 เป้าหมาย ",
            "desc3": "เพื่อมุ่งเน้นการปรับปรุงสุขภาพของคุณ ในตอนนี้ คุณมี "
        },
        "categoryScore": "คะแนน %{category} ของคุณ คือ ",
        "learnMore": "เรียนรู้เพิ่มเติม",
        "youAreSet": "คุณพร้อมแล้ว!",
        "goalSetting": "การกำหนดเป้าหมาย",
        "attention": "คะแนน %{category} ไม่สามารถใช้ได้",
        "move": {
            "error": "จากคำตอบของคุณ คะแนนการเคลื่อนไหวของคุณไม่สามารถใช้ได้ "
        },
        "eat": {
            "error": "คุณระบุว่าผู้เชี่ยวชาญด้านการดูแลสุขภาพบอกคุณว่าคุณเป็นเบาหวานชนิดที่ 2 และยังไม่ได้รับการดูแล "
        },
        "feel": {
            "error": "จากคำตอบของคุณ คะแนนความรู้สึกของคุณไม่สามารถใช้ได้ "
        },
        "survey": {
            "requiredField": "* ต้องใส่ข้อมูลในช่องนี้"
        },
        "score_info_title": "คะแนนของฉันหมายถึงอะไร",
        "company_average_info": "ค่าเฉลี่ยที่บริษัทของฉัน",
        "demographic_average_info": "ค่าเฉลี่ยในกลุ่มประชากรของฉัน",
        "score": "คะแนนสุขภาพ",
        "table": {
            "what_it_means": "หมายความว่าอะไร",
            "score": "คะแนน"
        },
        "updated": "อัปเดตแล้ว",
        "label": {
            "excellent": "ดีเลิศ",
            "very_good": "ดีมาก",
            "good": "ดี",
            "fair": "พอใช้",
            "poor": "แย่"
        },
        "activity": {
            "eat": "กิจกรรมการกิน 1, กิจกรรมการกิน 2, กิจกรรมการกิน 3",
            "move": "กิจกรรมการเคลื่อนไหว 1, กิจกรรมการเคลื่อนไหว 2, กิจกรรมการเคลื่อนไหว 3",
            "feel": "กิจกรรมความรู้สึก 1, กิจกรรมความรู้สึก 2, กิจกรรมความรู้สึก 3"
        },
        "score_info_screen": "คะแนนของฉันคำนวณอย่างไร?",
        "details": "รายละเอียด",
        "activities": "กิจกรรม",
        "improveCategoryScore": "ปรับปรุงคะแนน %{category} ของฉัน",
        "meaning": {
            "heading": "การคำนวณคะแนน"
        },
        "score_button": {
            "meaning": "คะแนนนี้หมายความว่าอย่างไร?"
        },
        "improve": "ดูเป้าหมายที่แนะนำ",
        "score_text": {
            "demographic": "คะแนนเฉลี่ยสำหรับอายุและเพศของคุณ คือ",
            "company": "และคะแนนเฉลี่ยที่บริษัทของคุณ คือ"
        },
        "scoreHigher": "สูงกว่าค่าเฉลี่ยของ",
        "scoreLower": "ต่ำกว่าค่าเฉลี่ยของ",
        "settedGoals": {
            "noGoals": "ไม่ได้กำหนดเป้าหมาย",
            "one": "กำหนดเป้าหมาย 1 เป้าหมายแล้ว",
            "n": "กำหนดเป้าหมาย %{count} เป้าหมายแล้ว"
        },
        "yourScoreIsPoor": "คะแนน %{category} ของคุณอยู่ในระดับ แย่",
        "unlock": {
            "title": "ปลดล็อกคะแนนสุขภาพของคุณ",
            "description": "กรอกแบบสอบถามสั้น ๆ เพื่อเรียนรู้ว่าสุขภาพโดยรวมของคุณเป็นอย่างไร เมื่อเปรียบเทียบกับคนอื่น ๆ ในกลุ่มประชากรของคุณ"
        },
        "browseAndSet": "คุณสามารถเรียกดูและกำหนดเป้าหมายใหม่ได้ หลังจากที่เป้าหมายปัจจุบันของคุณเสร็จสิ้น",
        "excellent": {
            "desc1": "รูปแบบการใช้ชีวิตที่มีสุขภาพดีเป็นพิเศษ",
            "desc2": "ความเสี่ยงด้านสุขภาพต่ำมาก"
        },
        "veryGood": {
            "desc1": "รูปแบบการใช้ชีวิตที่มีสุขภาพดีมาก",
            "desc2": "ความเสี่ยงด้านสุขภาพต่ำ"
        },
        "good": {
            "desc1": "รูปแบบการใช้ชีวิตที่มีสุขภาพดี",
            "desc2": "ความเสี่ยงด้านสุขภาพปานกลาง"
        },
        "fair": {
            "desc1": "รูปแบบการใช้ชีวิตที่ค่อนข้างมีสุขภาพดี",
            "desc2": "ความเสี่ยงด้านสุขภาพสูงกว่าค่าเฉลี่ย"
        },
        "poor": {
            "desc1": "ความเสี่ยงด้านสุขภาพสูง",
            "desc2": "แนะนำให้เคลื่อนไหวมากขึ้นในทุก ๆ วัน",
            "desc3": "จำเป็นต้องเคลื่อนไหวมากขึ้นในทุก ๆ วัน"
        },
        "calculateScore": {
            "description": "เมื่อคุณกรอกแบบสำรวจสุขภาพเสร็ตสมบูรณ์ คำตอบของคุณจะได้รับการวิเคราะห์โดยใช้ตัวแปรข้อมูลนับพันล้านแบบจากคนที่อายุและเพศของคุณ การคำนวณยังคำนึงถึงกิจกรรมที่คุณติดตามใน %{programName}\n\nคะแนนสุขภาพของคุณอัปเดตเป็นประจำ เพื่อให้คุณเห็นการเปลี่ยนแปลงเมื่อเวลาผ่านไป"
        },
        "improveYourScore": "กำลังปรับปรุงคะแนนของคุณ"
    },
    "challengerCount": "ชาเลนเจอร์ %{num}",
    "team_name": "ชื่อทีม",
    "syncingDeviceToast": {
        "danger": {
            "message": "ขออภัย... เรามีปัญหาในการซิงค์ %{name} กรุณาลองอีกครั้ง",
            "title": "ซิงค์"
        },
        "success": {
            "title": "ซิงค์",
            "message": "ซิงค์ %{name} สำเร็จ กิจกรรมของคุณเป็นปัจจุบันแล้ว"
        }
    },
    "allCompanyMembers": "สมาชิกบริษัททั้งหมด",
    "allCompanyMembersTeam": "สมาชิกบริษัททั้งหมด (ทีม)",
    "successfullyRedeemedItemForConfirmation": "คุณแลกรายการนี้สำเร็จแล้ว และมีการส่งอีเมลยืนยันไปที่ %{email} แล้ว",
    "no_all_events_placeholder": "ดูเหมือนว่าไม่มีอีเวนต์ให้เข้าร่วมในขณะนี้ ทำไมคุณไม่สร้างขึ้นมาล่ะ?",
    "confirmDeleteAccount": "ยืนยันการลบโดยกรอกอีเมลที่เชื่อมโยงกับบัญชีของคุณ",
    "deleteAccount": "ลบบัญชี",
    "linkAccounts": "จัดการบัญชีที่เชื่อมโยง",
    "titleSlug": {
        "icon_reward_text": "สมาชิกที่มีสิทธิ์จะได้รับคะแนนเพิ่มเติมจากการช็อปปิ้งกับพันธมิตรของเรา หรือการตรวจสุขภาพที่ Members’ Choice Advantage ได้อย่างง่ายดายโดยใช้ความคุ้มครองพิเศษของพวกเขา",
        "icon_move_text": "การติดตามตัวเลือกที่ดีต่อสุขภาพทุกวัน เช่น การนอนหลับดีขึ้นหรือการกินผักสามารถทำให้คุณได้รับคะแนน Live Better",
        "icon_redeem_text": "Live Better ให้รางวัลแก่สมาชิก Medibank ที่มีความคุ้มครองจากโรงพยาบาลหรือค่ารักษาพยาบาลพิเศษเพื่อดูแลสุขภาพ ",
        "icon_phone_text": "ลงชื่อสมัครและเตรียมพร้อมในการแลกรับรางวัล เช่น บัตรของขวัญด้านสุขภาพและความเป็นอยู่ที่ดี หรือการประหยัดเงินค่าความคุ้มครองสุขภาพของคุณ ",
        "wellness": "ยินดีต้อนรับสู่โลกแห่งสุขภาพ",
        "goals": "บรรลุเป้าหมายของคุณ",
        "devices": "อยู่ในเส้นทาง",
        "challenges": "สร้างชาเลนจ์",
        "celebrate": "สุขภาพทางสังคม",
        "habits": "สร้างนิสัยที่ดีต่อสุขภาพ",
        "joinChallenge": "เข้าร่วมชาเลนจ์",
        "getSocial": "เข้าโซเชียล",
        "reward": "รับรางวัลสำหรับการใช้ชีวิตที่มีสุขภาพดีขึ้น",
        "move": "เคลื่อนไหว กิน และรู้สึกดีขึ้น",
        "phone": "ใช้ชีวิตดีขึ้น รู้สึกดีขึ้น"
    },
    "viewProgress": {
        "goal": "ดูความคืบหน้าของเป้าหมาย",
        "challenge": "ความคืบหน้าของชาเลนจ์",
        "progress": "ดูความคืบหน้า"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "การกรอกข้อมูลนี้ไม่ได้บังคับ ซึ่งมีไว้เพื่อประโยชน์ของคุณเองและเป็นส่วนตัวสำหรับคุณ"
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "โบนัส  %{potentialBonusPoints}%{customPoints} มีให้สำหรับอีเวนต์นี้!"
        },
        "modal": {
            "paragraph1": "เมื่อเข้าร่วมอีเวนต์นี้ คุณจะได้รับโบนัส %{pointsName}",
            "paragraph2": "โบนัส %{pointsName} ทั้งหมดจะแจกให้หลังจากอีเวนต์เสร็จสมบูรณ์ คุณจะไม่ได้รับเครดิตโบนัสสำหรับอีเวนต์ที่คุณไม่ได้เข้าร่วม"
        }
    },
    "EAP": {
        "contactInfo": "ข้อมูลการติดต่อ",
        "doLater": "ฉันจะทำในภายหลัง",
        "tellMore": "บอกข้อมูลฉันเพิ่มเติม",
        "contactMe": "ติดต่อฉัน",
        "title": "โครงการให้ความช่วยเหลือพนักงานและครอบครัว",
        "reachGoal": {
            "title": "พร้อมให้ความช่วยเหลือ",
            "description": "โครงการให้ความช่วยเหลือพนักงานและครอบครัว (EFAP) ของคุณ ซึ่งจัดทำโดย %{providerName} นำเสนอบริการให้คำปรึกษาด้านสุขภาพที่หลากหลายเพื่อช่วยให้คุณบรรลุเป้าหมายด้านสุขภาพ\n\nคุณต้องการให้ %{providerName} ติดต่อคุณเพื่อแจ้งข้อมูลเพิ่มเติมหรือไม่?"
        },
        "privacyPolicy": "นโยบายความเป็นส่วนตัว %{provider}"
    },
    "HRIS": {
        "disclaimer": "บางช่องจะอัปเดตโดยอัตโนมัติและไม่สามารถเปลี่ยนแปลงได้"
    },
    "settingGoals": {
        "description": "การโฟกัสไปที่เป้าหมายที่แนะนำ 3 เป้าหมายในแต่ละครั้งจะเพิ่มโอกาสในการประสบความสำเร็จ",
        "title": {
            "one": "คุณมีเป้าหมายที่กำหนดไว้ 1 เป้าหมาย"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "บัญชีเชื่อมโยงกับผู้ใช้อื่นอยู่แล้ว",
            "lastAccountMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีที่เชื่อมโยงล่าสุดของคุณ? เมื่อลบออกแล้ว คุณต้องเข้าสู่ระบบด้วยอีเมล %{email} และรหัสผ่านใหม่",
            "unlinkCorpAccountMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีที่เชื่อมโยงองค์กรของคุณ? เมื่อลบออกแล้ว คุณต้องเข้าสู่ระบบด้วยอีเมล %{email} อีกครั้ง",
            "alreadyLinked": "เชื่อมโยงบัญชีอยู่แล้ว",
            "unlinkMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีที่เชื่อมโยง?"
        },
        "sso": {
            "emailNotVerified": "อีเมลของคุณไม่ได้รับการยืนยัน"
        },
        "signIn": {
            "dontHaveAccount": "ไม่มีบัญชี?",
            "enterPIN": "กรอกหมายเลขประจำตัวโปรแกรมบริษัทของคุณ",
            "dontKnowPIN": "ไม่ทราบรหัส PIN ของคุณ?",
            "pin": "รหัส PIN",
            "register": "ลงทะเบียน",
            "pinDescription": "ติดต่อผู้ดูแลระบบโปรแกรมของคุณ หากคุณไม่แน่ใจเกี่ยวกับหมายเลขประจำตัวโปรแกรม (PIN) เฉพาะขององค์กรคุณ หากคุณมีรหัส PIN และประสบปัญหาในการดำเนินการขั้นตอนต่อไป กรุณาติดต่อ support@sproutatwork.com.",
            "keepMeTooltip": "เพื่อความสะดวกของคุณ เมื่อทำเครื่องหมายที่ช่องนี้ เซสชันของคุณจะมีผลใช้ได้ 30 วัน ในอุปกรณ์ที่ใช้ร่วมกัน เราขอแนะนำให้คุณยกเลิกการเลือกช่องนี้ และออกจากระบบเมื่อดำเนินการเสร็จสิ้น"
        },
        "signUp": {
            "backToLogin": "ย้อนกลับไปที่การลงชื่อเข้าใช้",
            "termsOfService": "ข้อกำหนดการให้บริการ",
            "privacyPolicy": "นโยบายความเป็นส่วนตัว"
        },
        "createYourAccount": "สร้างบัญชีของคุณ",
        "setYourDetails": "กำหนดรายละเอียดของคุณ",
        "ModaHybridLogin": {
            "noAccessDashboard": "ไม่มีสิทธิ์เข้าถึงแผงควบคุมสมาชิกใช่ไหม?",
            "signUpSSOButton": "ลงทะเบียนผ่าน Moda Member Dashboard",
            "noAccessDashboardWeb": "หากคุณไม่มีสิทธิ์เข้าถึงแผงควบคุมสมาชิก โปรดเข้าสู่ระบบด้วยอีเมลและรหัสผ่านของคุณด้านล่าง",
            "loginSSOButton": "เข้าสู่ระบบผ่านแผงควบคุมสมาชิก Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} ถูกลบแล้ว",
    "track_challenge": {
        "message": {
            "manually": "ติดตามด้วยตัวเอง",
            "automatically": "ติดตามอัตโนมัติด้วย %{appOrDeviceName}",
            "manuallyOrConnect": "ติดตามด้วยตัวเองหรือเชื่อมต่อแอปหรืออุปกรณ์",
            "manuallyAndBy": "ติดตามด้วยตัวเองและอัตโนมัติด้วย %{appOrDeviceName}",
            "reconnectDevice": "อุปกรณ์ที่จำเป็น กรุณาเชื่อมต่ออุปกรณ์ของคุณอีกครั้ง",
            "manualAndAuto": "ติดตามด้วยตนเองและโดยอัตโนมัติ",
            "trackedAutomatically": "ติดตามโดยอัตโนมัติ"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "ไม่สามารถสมัครได้",
            "message": "ไม่สามารถเรียกรายละเอียดผู้ใช้จากพันธมิตรได้ กรุณาลองอีกครั้งภายหลัง"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "จำเป็นต้องมีแอปหรืออุปกรณ์สำหรับ %{goalName} นี้",
            "subTitle": "กรุณาเชื่อมต่อแอปหรืออุปกรณ์"
        }
    },
    "descriptionSlug": {
        "wellness": "เข้าร่วมชุมชนด้านสุขภาพที่ช่วยให้คุณกำหนดเป้าหมาย เชื่อมต่อ และดำเนินการตามแผน",
        "goals": "บอกเราว่าคุณกำลังทำอะไรอยู่  เราจะช่วยให้คุณบรรลุเป้าหมายที่แนะนำ",
        "devices": "ซิงค์อุปกรณ์ออกกำลังกายของคุณหรือบันทึกกิจกรรมของคุณ และรักษาเป้าหมายด้านสุขภาพของคุณให้เป็นไปตามแผน",
        "challenges": "จุดประกายการแข่งขันที่เป็นมิตร  สร้างชาเลนจ์และเชิญคนอื่น ๆ มาร่วมสนุก",
        "celebrate": "ติดต่อกับเพื่อนร่วมงานและฉลองความสำเร็จของคุณด้วยกัน",
        "habits": "ติดตามกิจกรรมด้านสุขภาพเพื่อรับคะแนน เชื่อมโยงไปยังโทรศัพท์หรืออุปกรณ์สวมใส่ของคุณเพื่อรับเร็วขึ้น",
        "joinChallenge": "ดูว่าคุณเอาชนะเพื่อนร่วมงานของคุณได้อย่างไรในการแข่งขันที่เป็นมิตร",
        "getSocial": "ติดต่อกับเพื่อนร่วมงานและฉลองความสำเร็จของคุณด้วยกัน",
        "reward_text": "รับคะแนนจากการทำกิจกรรมประจำวันและชาเลนจ์ส่วนบุคคล",
        "move_text": "ไม่ว่าจะเป็นการเดินไปรอบ ๆ ตึก จดจ่อกับสมาธิห้านาที หรือทานอาหารเพื่อสุขภาพ คุณจะได้รับรางวัล",
        "phone_text": "ใช้คะแนนของคุณเป็นส่วนลดสำหรับความคุ้มครองและข้อเสนอดี ๆ โดยคุณสามารถเลือกได้",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "ไม่ได้เปิดใช้งานคุณสมบัติ",
        "checkAppVersion": {
            "message": "ดูเหมือนว่าแอปของคุณจะล้าสมัย กรุณาติดตั้งการอัปเดตล่าสุด",
            "button": "อัปเดต %{appName}"
        },
        "noConnection": {
            "title": "ไม่มีการเชื่อมต่อเครือข่าย",
            "description": "ดูเหมือนว่าคุณไม่ได้เชื่อมต่อกับอินเทอร์เน็ต คุณจะไม่สามารถใช้แอปพลิเคชันได้อย่างเต็มที่เว้นแต่ว่าคุณมีการเชื่อมต่อ",
            "button": "ลองใหม่"
        },
        "uploadPhotoText": "เพิ่มภาพถ่ายสำหรับ %{entityType} ของคุณ",
        "entities": {
            "community": "ชุมชน",
            "event": "อีเวนต์",
            "team": "ทีม",
            "goal": "เป้าหมาย",
            "challenge": "ชาเลนจ์",
            "competition": "การแข่งขัน"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "ไม่สามารถเข้าสู่ระบบ",
            "resetPasswordHeading": "จำเป็นต้องรีเซ็ตรหัสผ่าน"
        },
        "signup": {
            "corporateOrOther": "ไม่ใช่สมาชิก Medibank? หรือเป็นส่วนหนึ่งของโปรแกรมองค์กร?",
            "sign_up_here": "สมัครที่นี่ ",
            "errorHeading": "ไม่สามารถสมัครได้",
            "areYouMedibankMember": "คุณเป็นสมาชิก Medibank หรือไม่?",
            "isMedibankMember": "ฉันเป็นสมาชิก",
            "isNotMedibankMember": "ฉันไม่ได้เป็นสมาชิก"
        },
        "bpidExists": "อีเมลที่ระบุเชื่อมโยงกับผู้ใช้ที่ดีกว่าอยู่แล้ว อีเมลต้องไม่ซ้ำกัน",
        "generalError": "ไม่สามารถให้บริการได้ในขณะนี้"
    },
    "rewardsNoAvailableProducts": "ไม่มีผลิตภัณฑ์ที่พร้อมจำหน่ายในขณะนี้",
    "endedGoal": {
        "timeToTrack": {
            "yes": "คุณยังมีเวลาติดตาม!",
            "no": "%{type} ของคุณสิ้นสุดแล้ว"
        },
        "grace": "%{type} ของคุณอาจสิ้นสุดแล้ว แต่คุณมี %{n} %{text} เพื่อติดตามกิจกรรมที่ลืมใด ๆ",
        "notGrace": {
            "goal": "ขอแสดงความยินดีที่คุณบรรลุเป้าหมาย! สู้ต่อไปด้วยการกำหนดเป้าหมายใหม่เพื่อให้สอดคล้องกับสุขภาพของคุณ",
            "competition": "ขอแสดงความยินดีที่เสร็จสิ้นชาเลนจ์! รักษาโมเมนตัมของคุณด้วยการเข้าร่วมชาเลนจ์อื่นหรือสร้างชาเลนจ์ของคุณเอง"
        }
    },
    "appDeviceModal": {
        "defaultMessage": "เชื่อมต่ออุปกรณ์หรือแอปของคุณและเพลิดเพลินกับการติดตามที่ราบรื่น การพิสูจน์ตัวตนของคุณทำให้พันธมิตรเทคโนโลยี \"Sprout\" ของเราถ่ายโอนข้อมูลของคุณได้อย่างปลอดภัยจากบัญชี %{appDeviceTitle} ของคุณ"
    },
    "noTransactionsMessage": "ดูเหมือนว่าคุณยังไม่ได้ทำธุรกรรมใด ๆ",
    "noRedemptionsMessage": "ดูเหมือนว่าคุณยังไม่ได้ทำการไถ่ถอนใด ๆ",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "คุณสามารถแข่งขันชาเลนจ์แบบเดี่ยวหรือแบบทีมก็ได้",
            "prompt": "ไม่มีชาเลนจ์ให้เข้าร่วมในขณะนี้ ทำไมไม่สร้างสักชาเลนจ์ล่ะ?"
        },
        "createChallengeButton": "สร้างชาเลนจ์"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "อีเวนต์อาจเปิดเฉพาะผู้รับเชิญเท่านั้นหรือเปิดให้กับทุกคน",
            "button": "สร้างอีเวนต์"
        },
        "emptyEventsMessage": "ไม่มีอีเวนต์ที่จะเข้าร่วมในขณะนี้ ทำไมไม่สร้างสักชาเลนจ์ล่ะ?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "ความเป็นอยู่ที่ดี",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "คุณไม่ได้กำหนดเป้าหมายใด ๆ!",
            "descriptionNoSet": "ปรับปรุงคะแนนสุขภาพของคุณด้วยการกำหนดเป้าหมายบางเป้าหมาย เริ่มต้นอย่างรวดเร็วด้วยเป้าหมายที่แนะนำ เลือกจากแคตตาล็อกหรือสร้างของคุณเอง",
            "descriptionSet": "คุณสามารถกำหนดเป้าหมายที่เราแนะนำไว้สำหรับคุณโดยเฉพาะ เรียกดูแคตตาล็อกทั้งหมด หรือสร้างเป้าหมายของคุณเอง",
            "action_text": "กำหนดเป้าหมายใหม่",
            "heading_singular": "คุณสามารถกำหนดเป้าหมายได้อีก 1 เป้าหมาย",
            "heading_plural": "คุณสามารถกำหนดเป้าหมายได้อีก %{number} เป้าหมาย"
        },
        "heading": "เป้าหมายส่วนบุคคล",
        "single": "เป้าหมายส่วนบุคคล"
    },
    "settingGoal": {
        "yourGoal": "%{units} ของคุณ",
        "yourGoalDescription": "คุณกำลังเดินทาง! %{units} ต่อไปนี้จะถูกตั้งค่าและจะเริ่มทันที",
        "selectedGoals": "เป้าหมายที่เลือก",
        "recommendedDescription": {
            "maximumSet": "คุณมีจำนวนเป้าหมายที่กำหนดไว้สูงสุดแล้ว คุณสามารถเรียกดูและกำหนดเป้าหมายใหม่ได้ หลังจากที่เป้าหมายปัจจุบันของคุณเสร็จสิ้น",
            "maximumSetTitle": "คุณมีเป้าหมายที่กำหนดไว้ %{count} เป้าหมาย"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "กิจกรรมถูกลบ",
            "info": "บางอย่างผิดพลาด. กรุณาลองอีกครั้ง.",
            "danger": "บางอย่างผิดพลาด. กรุณาลองอีกครั้ง."
        },
        "plural": {
            "success": "กิจกรรมถูกลบ",
            "info": "บางอย่างผิดพลาด. กรุณาลองอีกครั้ง.",
            "danger": "บางอย่างผิดพลาด. กรุณาลองอีกครั้ง."
        },
        "success": "กิจกรรมถูกลบ",
        "info": "กิจกรรมไม่ได้ถูกลบ กรุณาลองอีกครั้ง",
        "danger": "กิจกรรมไม่ได้ถูกลบ กรุณาลองอีกครั้ง"
    },
    "participants": "ผู้เข้าร่วม",
    "members": "สมาชิก",
    "timeSittingInformationOld": "แนวทางแนะนำเพื่อ:\n- ลดเวลาที่ใช้ในการนั่งเป็นเวลานาน\n- เลิกนั่งนาน ๆ ให้ได้บ่อยที่สุด",
    "timeSittingInformation": {
        "title": "แนวทางแนะนำเพื่อ:",
        "list": "- ลดเวลาที่ใช้ในการนั่งเป็นเวลานาน\n- เลิกนั่งนาน ๆ ให้ได้บ่อยที่สุด"
    },
    "activityLevelInformationOld": "แนวทางแนะนำ:\n- ใช้งานมากที่สุด โดยเฉพาะอย่างยิ่ง ทุกวัน ทุกสัปดาห์\n- สะสมกิจกรรมทางกายที่มีความเข้มข้นปานกลางมากกว่า 150 นาทีในแต่ละสัปดาห์\n- ทำกิจกรรมเสริมสร้างกล้ามเนื้ออย่างน้อย 2 วันต่อสัปดาห์",
    "activityLevelInformation": {
        "title": "แนวทางแนะนำ:",
        "list": "ใช้งานมากที่สุด โดยเฉพาะอย่างยิ่ง ทุกวัน ทุกสัปดาห์\n- สะสมกิจกรรมทางกายที่มีความเข้มข้นปานกลางมากกว่า 150 นาทีในแต่ละสัปดาห์\n- ทำกิจกรรมเสริมสร้างกล้ามเนื้ออย่างน้อย 2 วันต่อสัปดาห์"
    },
    "viewGuidelines": "ดูแนวทาง",
    "corporateAccountLink": {
        "verification": {
            "title": "ยืนยันอีเมลที่ทำงานของคุณ",
            "description": "คุณจะต้องยืนยันอีเมลที่ทำงานเพื่อให้กระบวนการเชื่อมโยงเสร็จสมบูรณ์ กรุณาปฏิบัติตามคำแนะนำที่ส่งไปยัง:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "หาเพื่อนและครอบครัว",
        "findFriends&Family": "หาเพื่อนและครอบครัว",
        "tapToAddFriendsAndFamily": "แตะเพื่อเพิ่มเป็นเพื่อนและครอบครัว",
        "addedFriendsAndFamily": "เพิ่มเป็นเพื่อนและครอบครัวแล้ว",
        "whoYouAreLookingFor": "ไม่เห็นว่าคุณกำลังมองหาใคร?",
        "inviteWithEmail": "เชิญด้วยอีเมล",
        "sentInvitations": "ส่งคำเชิญ",
        "foundPerson": "เราพบว่าบุคคลนี้มีอีเมลที่ตรงกัน",
        "youAreBoth": "คุณอยู่ทั้งใน %{entityName}",
        "youAreBothMore": "คุณอยู่ทั้งใน %{entityName}, +%{n} more",
        "noFriendsAndFamilyAdded": "ดูเหมือนว่าคุณยังไม่มีเพื่อนหรือครอบครัวใด ๆ ที่เพิ่มเลย",
        "sendInvitation": "ส่งคำเชิญ",
        "youHaveNoSentInvitations": "คุณยังไม่ได้ส่งคำเชิญใด ๆ",
        "toast": {
            "success_title": "ส่งคำเชิญแล้ว",
            "success_description": "%{invite_email} จะเห็นคำเชิญในกล่องจดหมาย",
            "danger_title": "คำเชิญไม่สำเร็จ",
            "danger_description": "กรุณาลองอีกครั้งภายหลัง"
        },
        "email": {
            "invalid_email": "กรุณาป้อนอีเมลที่ถูกต้อง"
        },
        "inviteOthers": "เชิญคนอื่น ๆ",
        "searchForSomeone": "ค้นหาใครสักคน",
        "searchForOthersToInvite": "ค้นหาผู้อื่นเพื่อเชิญ",
        "programNameOnly": {
            "title": "%{programName} เท่านั้น",
            "description": "%{entityType} นี้ใช้ได้เฉพาะกับผู้ที่เป็นส่วนหนึ่งของ %{programName} เท่านั้น"
        },
        "domainCannotBeUsed": "โดเมนนี้ไม่สามารถใช้กับ %{programName} ได้",
        "actionSearchByEmail": "เชิญด้วยอีเมล หากคุณไม่พบคนที่คุณกำลังมองหา",
        "send": "ส่ง",
        "addEmailToList": "เพิ่มอีเมลในรายการ",
        "toBeSent": "คำเชิญที่ต้องส่ง",
        "noInvitationsToBeSent": "ไม่มีคำเชิญ",
        "removeEmailConfirmation": "คุณแน่ใจหรือไม่ว่าต้องการลบอีเมลนี้ออกจากรายการ?",
        "yes": "ใช่",
        "no": "ไม่ใช่",
        "foundByEmail": "เราพบว่าบุคคลนี้มีอีเมลที่ตรงกัน",
        "addToFriendsAndFamily": "เพิ่มเป็นเพื่อนและครอบครัว",
        "alreadyAddedEmail": "คุณได้เพิ่มอีเมลนี้ในรายการแล้ว"
    },
    "pointsCurrencyAdditionalInfo": "%{points_name} และระดับของคุณเริ่มต้นใหม่ทุก ๆ %{period} กิจกรรมที่คุณติดตามทั้งหมดมีส่วนต่อระดับโดยรวมของคุณในช่วงระยะเวลาดังกล่าว",
    "rankLabel": "อันดับ",
    "leaderboards": {
        "loadingLabel": "กำลังโหลดกระดานผู้นำ... การดำเนินการนี้อาจใช้เวลาสักครู่ ดูเหมือนว่าทุกคนจะตื่นตัวกันแล้ว!"
    },
    "feeds": {
        "emptyListHomePage": "ยังไม่มีโพสต์ที่จะแสดง ลองปรับสตรีมเพื่อแสดงโพสต์เพิ่มเติม",
        "viewingPostsFrom": "กำลังดูโพสต์จาก",
        "postActivity": "เพิ่มความคิดเห็นหรือภาพถ่ายเกี่ยวกับกิจกรรมของคุณ!",
        "indicatorLoader": {
            "defaultTitle": "กำลังรีเฟรช...",
            "successfulLoadedTitle": "ซิงค์และรีเฟรชแล้ว..."
        },
        "inapropriateTextError": {
            "message": "เนื้อหาในข้อความของคุณอาจไม่เหมาะสม กรุณาลองใช้ภาษาที่เป็นมิตรกว่านี้"
        },
        "postImageError": {
            "title": "ขออภัย เราไม่สามารถโพสต์สิ่งนี้ได้",
            "message": "รูปภาพที่คุณเพิ่มอาจไม่เหมาะสม กรุณาลองรูปภาพอื่น"
        }
    },
    "syncModal": {
        "connect": {
            "title": "กำลังเชื่อมต่อ %{name}",
            "description": "ในการเชื่อมต่อข้อมูล %{name} ของคุณกับบัญชีของคุณ ให้ปฏิบัติตามขั้นตอนต่อไปนี้:",
            "firstStep": "ดาวน์โหลดและติดตั้งแอปพลิเคชันมือถือ %{appName} จาก %{storeName}",
            "fourthStep": "เลือกเพื่อเชื่อมต่อกับ %{name}",
            "fifthStep": "เมื่อได้รับแจ้ง ให้เลือกเมตริกซ์ด้านสุขภาพที่จะซิงค์กับ %{appName} แล้วกด 'เสร็จสิ้น'",
            "additionalInfo": "โปรดทราบว่าในการทริกเกอร์การซิงค์จากแอป Health ต้องเปิด %{appName} แม้ว่าคุณไม่จำเป็นต้องเปิดแอปไว้ แต่การซิงค์อาจใช้เวลาหนึ่งชั่วโมงจึงจะเสร็จสมบูรณ์และปรากฏในบันทึกกิจกรรมของคุณ"
        },
        "title": "กำลังซิงค์ %{name}",
        "description": "ในการซิงค์ข้อมูล %{name} ของคุณกับบัญชีของคุณ ให้ปฏิบัติตามขั้นตอนต่อไปนี้:",
        "steps": {
            "one": "ลงชื่อเข้าใช้แอป %{appName} ในโทรศัพท์ของคุณ",
            "two": "เปิดส่วนแอปและอุปกรณ์ในโปรไฟล์ของคุณ",
            "three": "กดปุ่มซิงค์ถัดจาก %{name}",
            "iPhone": "ลงชื่อเข้าใช้แอป %{appName} ใน iPhone ของคุณ"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "บัญชีงาน",
            "message": "เชื่อมต่อบัญชีสำเร็จ"
        },
        "danger": {
            "message": "ข้อผิดพลาดการเชื่อมต่อบัญชี"
        },
        "conflict": {
            "message": "บัญชีถูกเชื่อมโยงกับผู้ใช้อื่นอยู่แล้ว"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "บัญชีงาน",
            "message": "ยกเลิกการเชื่อมต่อบัญชีสำเร็จแล้ว"
        },
        "danger": {
            "title": "ลิงก์บัญชี",
            "message": "เกิดข้อผิดพลาดในการยกเลิกการเชื่อมต่อบัญชี"
        }
    },
    "earnMoreWithPartners": "รับมากขึ้นกับพันธมิตร",
    "connectPartnersToEarnByShopping": "เชื่อมต่อบัญชีของคุณและรับ %{unit_type} เพิ่มขึ้นจากการช็อปปิ้งกับพันธมิตร %{program_name}",
    "viewAllPartners": "ดูพันธมิตรทั้งหมด",
    "myPartnerMemberships": "สมาชิกพันธมิตรของฉัน",
    "linkAccount": "เชื่อมโยงการเป็นสมาชิก",
    "linkToPartner": "เชื่อมโยงไปยังพันธมิตร",
    "linkingError": "เกิดปัญหาในการเชื่อมโยงบัญชีของคุณ กรุณาลองอีกครั้ง",
    "linkPending": "เชื่อมโยงรอดำเนินการ",
    "unlinkAccount": "ยกเลิกการเชื่อมโยงบัญชี",
    "linkedToPartnerName": "เชื่อมโยงไปยัง %{partner_name}",
    "linked": "เชื่อมโยงแล้ว",
    "permission": {
        "facebookTitle": "สมัครใช้งานด้วย Facebook",
        "googleTitle": "สมัครใช้งานด้วย Google",
        "facebookDescription": "เมื่อสมัครใช้งานด้วย Facebook คุณจะต้องให้สิทธิ์แก่พันธมิตรเทคโนโลยีของเรา \"Sprout\" เพื่อเข้าถึงข้อมูลประจำตัวของคุณและสร้างบัญชี %{programName} ของคุณ",
        "googleDescription": "เมื่อสมัครใช้งานด้วย Google คุณจะต้องให้สิทธิ์แก่พันธมิตรเทคโนโลยีของเรา \"Sprout\" เพื่อเข้าถึงข้อมูลประจำตัวของคุณและสร้างบัญชี %{programName} ของคุณ",
        "camera": {
            "title": "การเข้าถึงกล้อง",
            "description": "จำเป็นต้องเข้าถึงกล้องเพื่อถ่ายภาพ ในการตั้งค่า iPhone ให้แตะ %{appName} แล้วเปิดกล้อง\n\nโปรดทราบว่าคุณอาจสูญเสียการเปลี่ยนแปลงใด ๆ ที่ไม่ได้บันทึก"
        },
        "notNow": "ไม่ใช่ตอนนี้",
        "openSettings": "เปิดการตั้งค่า",
        "photos": {
            "title": "กรุณาอนุญาตการเข้าถึงภาพถ่าย",
            "description": "การทำเช่นนี้ช่วยให้คุณสามารถแชร์รูปภาพจากไลบรารี่และบันทึกรูปภาพลงในม้วนฟิล์มได้ ในการตั้งค่า iPhone ให้แตะ %{appName} แล้วสลับภาพถ่ายเป็นอ่านและเขียน\n\nโปรดทราบว่าคุณอาจสูญเสียการเปลี่ยนแปลงใด ๆ ที่ไม่ได้บันทึก"
        }
    },
    "firstNameContainsSpecialChar": "ชื่อจริงของคุณใช้ได้เฉพาะตัวอักษรภาษาอังกฤษ ยัติภังค์ และเครื่องหมายวรรคตอน",
    "lastNameContainsSpecialChar": "นามสกุลของคุณใช้ได้เฉพาะตัวอักษรภาษาอังกฤษ ยัติภังค์ และเครื่องหมายวรรคตอน",
    "goToPartnerSite": "ไปยังไซต์พันธมิตร",
    "noPartnersFound": "ไม่พบพันธมิตร",
    "noLinkedPartners": "ไม่มีพันธมิตรที่เชื่อมโยง",
    "noPartnersInCategory": "ไม่มีพันธมิตรในหมวดหมู่",
    "partnerAccountPendingVerification": "การยืนยันบัญชีรอดำเนินการ",
    "shopWithPartner": "ช็อปกับพันธมิตร",
    "shopWithPartnerName": "ช็อปกับ %{partner_name}",
    "linkToPartnerName": "เชื่อมโยงไปยัง %{partner_name}",
    "earnPartnerMembershipIdentifier": "ตัวระบุการเป็นสมาชิก",
    "earnPartnerAccountPendingAddLink": "กำลังเชื่อมโยงการเป็นสมาชิกของคุณ และอาจใช้เวลาหลายวันจึงจะเสร็จสมบูรณ์",
    "earnPartnerAccountPendingRemoveLink": "กำลังยกเลิกการเชื่อมโยงการเป็นสมาชิกของคุณ และอาจใช้เวลาหลายวันจึงจะเสร็จสมบูรณ์",
    "linkStatusUpdating": "เชื่อมโยงการอัปเดตสถานะ",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "ขอแสดงความยินดีกับการเพิ่มกิจกรรมแรกของคุณ! \n\nคุณสามารถเพิ่มกิจกรรมสำหรับวันนี้และวันอื่น ๆ ได้หากคุณต้องการ เมื่อทำกิจกรรมวันนี้เสร็จ ให้แตะ",
            "description2": "ในหน้าจอถัดไป เมื่อคุณไม่มีอะไรให้ติดตามอีกต่อไป"
        },
        "listTitle": "กิจกรรมที่ติดตามใน",
        "dots": {
            "tracked": "กิจกรรมที่ติดตามในวันนี้",
            "added": "เพิ่มกิจกรรมแล้ว และการส่งกำลังรอดำเนินการ"
        },
        "trackedActivitiesFor": "กิจกรรมที่ติดตามสำหรับ %{date}",
        "activityTracking": "กิจกรรมที่กำลังติดตาม",
        "addedPending": "เพิ่มแล้ว (การส่งกำลังรอดำเนินการ)",
        "search": {
            "description1": "แตะ",
            "description2": "เพื่อดูกิจกรรมที่มีอยู่หรือค้นหากิจกรรมเฉพาะ"
        },
        "addActivity": "เพิ่มกิจกรรม",
        "addAnotherActivity": "เพิ่มกิจกรรมอื่น"
    },
    "rewardsBalance": "ยอดคงเหลือ %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "ตัวระบุการเป็นสมาชิกของคุณจำเป็นต้องเชื่อมโยง",
    "incorrectValueInRange": "กรุณากรอกค่าระหว่าง %{min} และ %{max}",
    "joinTeam": {
        "title": "เข้าร่วมทีม",
        "createInsteadText": "เข้าร่วมหรือสร้างทีมเพื่อเข้าร่วมในชาเลนจ์นี้"
    },
    "teamRank": "อันดับทีม",
    "teamScore": "คะแนนทีม",
    "appsDevices": {
        "infoText": "ระบบจะขอให้คุณให้สิทธิ์แก่ Sprout Wellness Solutions, Inc. ซึ่งเป็นพันธมิตรด้านเทคโนโลยีของเราในการเข้าถึงข้อมูลสุขภาพของคุณเมื่อเพิ่มแอปหรืออุปกรณ์",
        "connectModal": {
            "title": "การอนุญาต",
            "paragraph1Part1": "ระบบจะขอให้คุณให้สิทธิแก่พันธมิตรเทคโนโลยีของเรา",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "ในการเข้าถึงข้อมูลด้านสุขภาพของคุณ",
            "paragraph2Desc1": "การอนุญาตของคุณช่วยให้",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "ซิงค์ข้อมูลของคุณ",
            "paragraph2Desc4": "อย่างปลอดภัย",
            "paragraph2Desc5": "และช่วยให้คุณได้รับ %{pointsName} มากขึ้น!"
        },
        "statusAlert": {
            "connectMessage": "เชื่อมต่อแอปหรืออุปกรณ์ติดตามกิจกรรม และทำให้การซิงค์และติดตามกิจกรรมเป็นเรื่องง่าย",
            "connectAction": "เชื่อมต่อแอปหรืออุปกรณ์",
            "errorMessage": "แอปหรืออุปกรณ์ที่เชื่อมต่อของคุณบางรายการไม่สามารถซิงค์ได้",
            "warningMessage": "แอปหรืออุปกรณ์ที่เชื่อมต่อบางรายการของคุณอาจมีปัญหาการเชื่อมต่อ",
            "errorAction": "แก้ไขข้อผิดพลาด",
            "warningAction": "แก้ไขคำเตือน",
            "syncingError": "ข้อผิดพลาดในการซิงค์",
            "syncingIssue": "ปัญหาการซิงค์"
        },
        "deviceDetails": {
            "warningMessage": "แอปหรืออุปกรณ์นี้มีปัญหาในการซิงค์",
            "errorMessage": "แอปหรืออุปกรณ์นี้ไม่สามารถซิงค์ได้",
            "warningAction": "ปิดคำเตือน",
            "noActivities": "ไม่มีกิจกรรม %{deviceName} ที่ซิงค์กับ %{programName} ในช่วง 7 วันที่ผ่านมา \n\nอาจใช้เวลาถึงหนึ่งชั่วโมงกว่ากิจกรรมจะปรากฏที่นี่หลังจากมีการติดตามด้วย %{deviceName}\n\nหากคุณมีแอปหรืออุปกรณ์อื่นเชื่อมต่ออยู่ และมีการติดตามจำนวนก้าวเพิ่มเติมด้วยแอปหรืออุปกรณ์อื่น คุณจะเห็นกิจกรรมที่นั่น มิฉะนั้น ให้ลองยกเลิกการเชื่อมต่อและเชื่อมต่อ %{deviceName} ใหม่ หากระบบขอให้คุณตรวจสอบสิทธิ์หรือให้สิทธิ์ ตรวจสอบให้แน่ใจว่าคุณกำลังเปิดใช้งานข้อมูลกิจกรรม และใช้บัญชีเดียวกันเพื่อตรวจสอบสิทธิ์เหมือนกับบัญชีที่ใช้ในการติดตามกิจกรรม ตรวจสอบขั้นตอนการแก้ไขปัญหาเพื่อดูข้อมูลเพิ่มเติม  "
        },
        "troubleshooting": "การแก้ไขปัญหา",
        "deviceItem": {
            "error": "ข้อผิดพลาดการเชื่อมต่อ",
            "warning": "คำเตือนการเชื่อมต่อ",
            "unableToSync": "ไม่สามารถซิงค์ได้"
        },
        "platformDevice": {
            "defaultApp": "แอปสุขภาพเริ่มต้นของอุปกรณ์คุณ คือ",
            "continueMore": "ไปที่แอปและอุปกรณ์เพิ่มเติม"
        }
    },
    "friendsAndFamily": {
        "learnMore": "เรียนรู้เพิ่มเติมเกี่ยวกับเพื่อนและครอบครัว",
        "learnModal": {
            "title": "เกี่ยวกับเพื่อนและครอบครัว",
            "description": "หลังจากคุณเพิ่มใครสักคนเป็นเพื่อนและครอบครัวของคุณ คุณสามารถเลือกที่จะแชร์โพสต์ของคุณใน %{programName} กับพวกเขาเท่านั้น\n\nคุณยังสามารถกรองโพสต์ที่คุณเห็นใน %{programName} ให้เฉพาะคนในรายชื่อเพื่อนและครอบครัวของคุณ หากพวกเขาโพสต์ถึงทุกคนหรือถึงคุณ",
            "description_line1": "หลังจากคุณเพิ่มใครสักคนเป็นเพื่อนและครอบครัวของคุณ คุณสามารถเลือกที่จะแชร์โพสต์ของคุณใน %{programName} กับพวกเขาเท่านั้น",
            "description_line2": "คุณยังสามารถกรองโพสต์ที่คุณเห็นใน %{programName} ให้เฉพาะคนในรายชื่อเพื่อนและครอบครัวของคุณ หากพวกเขาโพสต์ถึงทุกคนหรือถึงคุณ",
            "whatIconsMean": "ไอคอนหมายถึงอะไร",
            "canAdd": "เพิ่ม",
            "added": "เพิ่มแล้ว"
        },
        "searchDescription1": "ค้นหาบุคคลที่จะเพิ่มเป็นเพื่อนและครอบครัวของคุณ",
        "searchDescription2": "ไม่เห็นว่าคุณกำลังมองหาใคร? เชิญชวนพวกเขาให้เข้าร่วมทางอีเมล",
        "friends&Family": "เพื่อนและครอบครัว",
        "managingTour": {
            "title": "การจัดการเพื่อนและครอบครัว",
            "body": "หากคุณต้องการลบใครสักคนออกจากเพื่อนและครอบครัวของคุณ ให้แตะไอคอน"
        },
        "removeOption": "ลบออกจากเพื่อนและครอบครัว",
        "inviteDescription1": "ค้นหาเพื่อนและครอบครัวของคุณ",
        "inviteDescription2": "ไม่เห็นว่าคุณกำลังมองหาใคร?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "โพสต์ที่คุณแชร์กับเพื่อนและครอบครัวเท่านั้นจะไม่ปรากฏแก่ %{userFirstName} อีกต่อไป"
        }
    },
    "skipAll": "ข้ามทั้งหมด",
    "smallMin": "ต่ำสุด",
    "eap": {
        "skipModal": {
            "title": "คุณแน่ใจหรือไม่?",
            "description": "คุณสามารถติดต่อโครงการให้ความช่วยเหลือพนักงานและครอบครัวได้จากโปรไฟล์ของคุณเมื่อคุณต้องการ"
        },
        "contact": {
            "whatIsBestNumber": "หมายเลขใดเหมาะสมที่สุดที่จะติดต่อคุณ?",
            "whatIsBestTime": "เวลาใดเหมาะสมที่สุดในการติดต่อคุณ?",
            "morning": "เช้า",
            "afternoon": "บ่าย",
            "evening": "เย็น",
            "additionalDetails": "รายละเอียดเพิ่มเติมเกี่ยวกับเวลา\/วันที่ที่คุณต้องการให้ติดต่อ",
            "message": "ติดต่อฉันใน %{weekDay} ที่ %{phone Number} ข้อมูลเพิ่มเติม: %{additional}",
            "description": "หมายเหตุ: เราขอแนะนำให้คุณเลือกเวลานอกเวลาทำงานและเลือกสถานที่ที่คุณจะสามารถสนทนาส่วนตัวได้ กรุณาระบุเขตเวลาของคุณ"
        },
        "phoneNumber": {
            "empty": "ช่องนี้ไม่สามารถเว้นว่างไว้",
            "missingDigits": "หมายเลขโทรศัพท์ต้องมีอย่างน้อย 4 หลัก"
        },
        "myEAP": "โครงการให้ความช่วยเหลือพนักงานและครอบครัวของฉัน"
    },
    "healthSurveySkipAllTitle": "ข้ามแบบสำรวจสุขภาพ",
    "healthSurveySkipAllAlert": "คุณแน่ใจหรือไม่ว่าต้องการข้ามคำถามที่เหลือทั้งหมดของแบบสำรวจสุขภาพ?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "โครงการให้ความช่วยเหลือพนักงานและครอบครัว",
            "message": "กรุณาระบุหมายเลขโทรศัพท์และเวลาติดต่อที่เหมาะสมที่สุด"
        }
    },
    "allMyChallenges": "ชาเลนจ์ของฉัน",
    "invitedChallenges": "คำเชิญ",
    "companyChallenges": "ชาเลนจ์ของบริษัท",
    "completedChallengesEmpty": "ดูเหมือนว่าคุณยังทำชาเลนจ์ใด ๆ ไม่เสร็จเลย",
    "myChallengesEmpty": "ดูเหมือนว่าคุณยังไม่ได้เข้าร่วมชาเลนจ์ใด ๆ เลย",
    "allChallengesEmpty": "ไม่มีชาเลนจ์",
    "startsToday": "เริ่มวันนี้",
    "startedDaysAgo": "เริ่มแล้ว %{dayCount} วันที่ผ่านมา",
    "startsInDays": "เริ่มใน %{dayCount} วัน",
    "privacyOn": "ปิด",
    "privacyOff": "เมื่อ",
    "dashboard": {
        "viewLeaderboard": "ดูกระดานผู้นำ",
        "timePeriodProgress": "ความคืบหน้าของคุณใน %{period} นี้",
        "howToEarn": "วิธีการรับคะแนน"
    },
    "privacyChangeConfirmationMessage": "เปลี่ยนความเป็นส่วนตัว?",
    "privacySettingsTitle": "ความเป็นส่วนตัว",
    "privacySettingsDescription": "คุณสามารถควบคุมการมองเห็นรูปภาพ ชื่อ และโปรไฟล์ของคุณแก่ผู้ใช้รายอื่น ",
    "mainLeaderBoardSettingsTitle": "?กระดานผู้นำภาพรวม",
    "challengeLeaderBoardSettingsTitle": "?กระดานผู้นำชาเลนจ์",
    "managePrivacySettingUrlTitle": "จัดการการตั้งค่าความเป็นส่วนตัว",
    "onboardingFamilyPrivacySettingsMessageOn": "คุณจะปรากฏในผลลัพธ์การค้นหาเพื่อนและครอบครัว คุณสามารถเลือกที่จะซ่อนตัวคุณเองจากผลการค้นหาได้",
    "onboardingFamilyPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณในผลลัพธ์การค้นหาเพื่อนและครอบครัว",
    "challengeInvitationPrivacySettingsMessageOn": "คุณจะปรากฏในผลลัพธ์การค้นหาคำเชิญชาเลนจ์ คุณสามารถเลือกที่จะซ่อนตัวคุณเองจากผลการค้นหาได้",
    "challengeInvitationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากผลลัพธ์การค้นหาคำเชิญชาเลนจ์",
    "challengeParticipationPrivacySettingsMessageOn": "คุณถูกระบุว่าเป็นผู้เข้าร่วมในชาเลนจ์นี้ คุณสามารถเลือกที่จะซ่อนตัวเองในฐานะผู้เข้าร่วมจากชาเลนจ์ของคุณ",
    "challengeParticipationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากรายชื่อผู้มีส่วนร่วม",
    "communityInvitationPrivacySettingsMessageOn": "คุณจะปรากฏในผลลัพธ์การค้นหาคำเชิญชุมชน คุณสามารถเลือกที่จะซ่อนตัวคุณเองจากผลการค้นหาได้",
    "communityInvitationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากผลลัพธ์การค้นหาคำเชิญชุมชน",
    "communityParticipationPrivacySettingsMessageOn": "คุณถูกระบุว่าเป็นสมาชิกของชุมชนนี้ คุณสามารถเลือกที่จะซ่อนตัวเองในฐานะสมาชิกของชุมชนของคุณ",
    "communityParticipationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากรายชื่อสมาชิก",
    "eventInvitationPrivacySettingsMessageOn": "คุณจะปรากฏในผลลัพธ์การค้นหาคำเชิญอีเวนต์ คุณสามารถเลือกที่จะซ่อนตัวคุณเองจากผลการค้นหาได้",
    "eventInvitationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากผลลัพธ์การค้นหาคำเชิญอีเวนต์",
    "eventParticipationPrivacySettingsMessageOn": "คุณถูกระบุว่าเป็นผู้เข้าร่วมของอีเวนต์นี้ คุณสามารถเลือกที่จะซ่อนตัวเองในฐานะผู้เข้าร่วมจากอีเวนต์ของคุณ",
    "eventParticipationPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณจากรายชื่อผู้เข้าร่วม",
    "mainLeaderboardPrivacySettingsMessageOn": "คุณจะแสดงบนกระดานผู้นำโดยรวม คุณสามารถเลือกที่จะซ่อนตัวเอง ซึ่งจะเป็นการลบอันดับ รูปภาพ และชื่อของคุณเมื่อผู้อื่นดูกระดานผู้นำโดยรวม",
    "mainLeaderboardPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณเมื่อผู้อื่นดูกระดานผู้นำโดยรวม",
    "challengeLeaderboardPrivacySettingsMessageOn": "คุณจะปรากฏบนกระดานผู้นำชาเลนจ์ คุณสามารถเลือกที่จะซ่อนตัวเอง ซึ่งจะเป็นการลบอันดับ รูปภาพ และชื่อของคุณเมื่อผู้อื่นดูกระดานผู้นำชาเลนจ์",
    "challengeLeaderboardPrivacySettingsMessageOff": "ในปัจจุบัน การตั้งค่าความเป็นส่วนตัวของคุณซ่อนคุณเมื่อผู้อื่นดูกระดานผู้นำชาเลนจ์",
    "thumbsUpConfirmationTitle": "การยกนิ้วให้",
    "thumbsUpConfirmationDescriptionline1": "ขอแสดงความยินดี คุณกำลังจะยกนิ้วโป้งให้คนแรกและให้กำลังใจผู้อื่น!",
    "thumbsUpConfirmationDescriptionline2": "คุณจะรวมอยู่ในรายชื่อผู้ที่ยกนิ้วให้โพสต์นี้ และคนอื่น ๆ จะสามารถเห็นรูปภาพ ชื่อ และสามารถดูโปรไฟล์ของคุณได้",
    "thumbsUpConfirmationButtonOk": "การยกนิ้วให้",
    "commentToActionInfoTitle": "คนอื่นเห็นอะไร?",
    "commentToActionMessage": "เมื่อคุณแสดงความคิดเห็น คนอื่นจะมองเห็นรูปภาพ ชื่อ และดูโปรไฟล์ของคุณได้",
    "postToActionTitle": "ใครเห็นโพสต์นี้บ้าง?",
    "postToActionMessageLine1": "เมื่อคุณสร้างโพสต์ คุณสามารถควบคุมได้ว่าใครบ้างที่สามารถเห็นโพสต์นั้นและแม้แต่โพสต์ถึงตัวคุณเอง",
    "postToActionMessageLine2": "โพสต์ที่คุณแชร์กับผู้อื่นจะแสดงรูปภาพ ชื่อ และคนอื่น ๆ สามารถดูโปรไฟล์ของคุณได้",
    "privateUsersDescriptionChallenge": "ผู้มีส่วนร่วมเหล่านี้ได้ซ่อนตัวจากรายชื่อ",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} ส่วนตัว",
    "privateUsersLastNamePlaceHolderChallenge": "ผู้เข้าร่วม",
    "privateUsersDescriptionEvent": "ผู้เข้าร่วมเหล่านี้ได้ซ่อนตัวจากรายชื่อ",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} ส่วนตัว",
    "privateUsersLastNamePlaceHolderEvent": "ผู้เข้าร่วม",
    "privateUsersDescriptionCommunity": "สมาชิกเหล่านี้ได้ซ่อนตัวจากรายชื่อ",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} ส่วนตัว",
    "privateUsersLastNamePlaceHolderCommunity": "สมาชิก",
    "noPrivacySettings": "ไม่มีการตั้งค่าความเป็นส่วนตัว",
    "linkToPartnerNameWebsite": "ลิงก์ผ่านเว็บไซต์ %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL เว็บไซต์พันธมิตร",
    "start_end_time": "เวลาเริ่มต้นและสิ้นสุด:",
    "joinCreateTeamPrivacyDisclaimer": "รูปภาพ ชื่อ และโปรไฟล์ของคุณจะปรากฏแก่ทุกคนเสมอเมื่อดูทีมของคุณในการแข่งขัน แม้ว่าคุณจะเปลี่ยนการตั้งค่าความเป็นส่วนตัวเป็นส่วนตัวแล้วก็ตาม",
    "carouselInstructions": {
        "swipe": "ปัดการ์ดเพื่อดูเป้าหมายและชาเลนจ์ทั้งหมดของคุณ",
        "click": "คลิกการ์ดเพื่อดูเป้าหมายและชาเลนจ์ทั้งหมดของคุณ"
    },
    "achieved": "บรรลุผล",
    "hours": "ชั่วโมง",
    "createCommunityFlow": {
        "navigatorTitle": "สร้างชุมชน",
        "stepType": {
            "title": "การมองเห็นของชุมชน",
            "subTitle": "ใครจะสามารถดูและเข้าร่วมชุมชนได้บ้าง?",
            "privateName": "ส่วนตัว",
            "publicName": "สาธารณะ",
            "privateDescription": "เฉพาะคนที่คุณเชิญเท่านั้นที่สามารถดูหรือเข้าร่วมชุมชนได้",
            "publicDescription": "ทุกคนสามารถดูและเข้าร่วมชุมชนนี้ได้"
        },
        "stepName": {
            "title": "ตั้งชื่อชุมชนของคุณ",
            "subTitle": "ตั้งชื่อชุมชนของคุณให้เป็นชื่อที่ทำให้คนอื่นรู้ว่าเกี่ยวกับอะไร",
            "namePlaceholder": "ชื่อชุมชน",
            "noFieldsTitle": "ชื่อ",
            "noFieldsMessage": "ไม่ระบุชื่อ"
        },
        "stepDescription": {
            "title": "เกี่ยวกับชุมชนของคุณ",
            "subTitle": "บอกคนอื่นว่าชุมชนของคุณเกี่ยวกับอะไร",
            "descriptionPlaceholder": "คำอธิบาย (ไม่บังคับ)",
            "noFieldsTitle": "คำอธิบาย",
            "noFieldsMessage": "ไม่มีคำบรรยาย"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "เพิ่มภาพถ่าย"
        },
        "stepJoin": {
            "title": "เราพบชุมชนที่คล้ายกัน",
            "subTitle": "คุณต้องการเข้าร่วมชุมชนเหล่านี้แทนหรือไม่?"
        },
        "createNew": "สร้างชุมชนใหม่"
    },
    "challengeCard": {
        "allActivities": "กิจกรรมทั้งหมดใน",
        "category": "หมวดหมู่"
    },
    "myLinkedPartners": "พันธมิตรที่เชื่อมโยงของฉัน",
    "leaderboardPosition": "ตำแหน่งกระดานผู้นำโดยรวม",
    "remainingInChallenge": "อยู่ในชาเลนจ์",
    "todays_progress": "ความคืบหน้าวันนี้",
    "this_weeks_progress": "ความคืบหน้าสัปดาห์นี้",
    "this_months_progress": "ความคืบหน้าเดือนนี้",
    "achievement": "ความสำเร็จ",
    "challengeCardHeader": {
        "challenge": "ชาเลนจ์",
        "recommended_personal_goals": "เป้าหมายส่วนบุคคลที่แนะนำ",
        "personal_goal": "เป้าหมายส่วนบุคคล",
        "competition": "การแข่งขัน",
        "recommended_goals": "เป้าหมายที่แนะนำ",
        "team_competition": "การแข่งขันของทีม",
        "team": "ทีม"
    },
    "MyMedibank": "Medibank ของฉัน",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "เวลาสิ้นสุดต้องไม่มาก่อนเวลาเริ่มต้น",
    "company": "บริษัท",
    "lessThan1DayRemain": "น้อยกว่า 1 วัน",
    "lessThan1HourRemain": "น้อยกว่า 1 ชั่วโมง",
    "remainingToday": "เหลือวันนี้",
    "periodEndsDateAndTime": "ระยะเวลาสิ้นสุด %{date}, %{time}",
    "moreToGo": "%{n} อีก %{unit} จะไปจาก",
    "reachedYourGoal": "คุณบรรลุเป้าหมาย %{period}!",
    "reachedYourGoalToday": "คุณบรรลุเป้าหมายในวันนี้ของคุณแล้ว!",
    "editProfileItemCorrectRange": "กรุณาระบุค่า %{itemName} ที่ถูกต้องระหว่างค่าต่ำสุด %{min} และค่าสูงสุด %{max}",
    "invalidUrl": "URL ไม่ถูกต้อง",
    "activityLogChanged": {
        "success": "บันทึกการเปลี่ยนแปลงกิจกรรมแล้ว",
        "info": "เกิดข้อผิดพลาด... กรุณาลองอีกครั้ง",
        "danger": "เกิดข้อผิดพลาด... กรุณาลองอีกครั้ง"
    },
    "discardAlert": {
        "createChallenge": "คุณแน่ใจหรือไม่ว่าต้องการละทิ้ง %{challengeType} นี้?",
        "inviteByEmail": "คุณแน่ใจหรือไม่ว่าต้องการละทิ้งการเปลี่ยนแปลง?",
        "createTeam": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการสร้างทีมนี้?",
        "cancel": "ยกเลิก",
        "confirm": "ใช่ ละทิ้ง"
    },
    "entityInvalidNameError": "ชื่อของ %{entity} ควรมีเฉพาะตัวเลขหรือค่าสตริง และต้องไม่เว้นว่างไว้",
    "accept": "ยอมรับ",
    "sync_now": "ซิงค์ตอนนี้",
    "reconnect_device": "เชื่อมต่ออีกครั้ง",
    "supported_activities": "กิจกรรมที่รองรับ",
    "recentlySynced_activity": "กิจกรรมที่ซิงค์ล่าสุด",
    "noSyncedActivity_sevenDays": "ไม่มีการซิงค์กิจกรรมในช่วง 7 วันที่ผ่านมา",
    "recentActivityLog": {
        "convertingActivityPoints": "กำลังซิงค์กิจกรรม...",
        "activityMinuteOrTwo": "อาจใช้เวลาหนึ่งหรือสองนาที...",
        "noNewActivities": "ไม่ได้เพิ่มกิจกรรมใหม่... อาจใช้เวลาถึงหนึ่งชั่วโมงในการซิงค์กิจกรรมใหม่"
    },
    "deleteCommunityCheckbox": "ฉันเข้าใจว่าสิ่งนี้ไม่สามารถยกเลิกได้",
    "createEvent": {
        "type": {
            "company": "อีเวนต์บริษัท",
            "user": "อีเวนต์ผู้ใช้",
            "title": "ประเภทอีเวนต์"
        },
        "privacy": "ความเป็นส่วนตัว (แสดงผู้เข้าร่วมหรือไม่)",
        "cost": "ค่าใช้จ่าย",
        "associated": {
            "location": "ตำแหน่งที่เกี่ยวข้อง",
            "department": "แผนกที่เกี่ยวข้อง"
        },
        "maxParticipants": "ผู้เข้าร่วมสูงสุด (ไม่บังคับ)",
        "errorMessage": {
            "limit": "ไม่สามารถมากกว่า %{maxValue}",
            "negative": "ไม่สามารถเป็นค่าลบได้",
            "selectedLocations": "โปรดเลือกตำแหน่งอย่างน้อยหนึ่งแห่ง"
        },
        "selectLocations": "ตำแหน่งที่เลือก",
        "createNew": "สร้างอีเวนต์ใหม่"
    },
    "selected": "เลือกแล้ว",
    "deleteEventButton": "ลบอีเวนต์นี้",
    "notification": {
        "priorityNotification": {
            "title": "คุณมีการอัปเดตสำคัญที่ยังไม่ได้อ่าน",
            "subtitle": "แตะเพื่ออ่านเลย",
            "subtitleWeb": "คลิกเพื่ออ่านตอนนี้"
        },
        "sectionTitle": {
            "priorityUnread": "การอัปเดตสำคัญที่ยังไม่ได้อ่าน",
            "all": "การแจ้งเตือนทั้งหมด"
        },
        "modalTitle": "คุณมีการอัปเดตสำคัญ %{count} ",
        "priorityModalTitle": {
            "defaultTitle": "ดูการอัปเดตทั้งหมด"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "ยกเลิก %{entity} %{actionType}",
            "message": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิก %{entity} %{actionType}?"
        },
        "action": {
            "creating": "กำลังสร้าง",
            "editing": "กำลังแก้ไข"
        },
        "type": {
            "team": "ทีม",
            "community": "ชุมชน",
            "event": "อีเวนต์",
            "challenge": "ชาเลนจ์",
            "goal": "เป้าหมาย"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "ทำให้เป็นสาธารณะ?",
            "private": "ทำให้เป็นส่วนตัว?"
        },
        "modalSubtitle": {
            "public": "การทำให้ %{entityType} นี้เป็นสาธารณะจะเป็นการเปิดให้ทุกคนค้นพบและเข้าร่วม คุณแน่ใจหรือไม่ว่าต้องการทำให้ %{entityType} นี้เป็นสาธารณะ?",
            "private": "การทำให้ %{entityType} นี้เป็นส่วนตัวจะเป็นการปิดไม่ให้ใครก็ตามค้นพบและเข้าร่วม คุณแน่ใจหรือไม่ว่าต้องการทำให้ %{entityType} นี้เป็นสาธารณะ?"
        },
        "footerButton": {
            "makePublic": "ใช่ ทำให้เป็นสาธารณะ",
            "makePrivate": "ใช่ ทำให้เป็นส่วนตัว",
            "keepPrivate": "เก็บเป็นส่วนตัว",
            "keepPublic": "เก็บเป็นสาธารณะ"
        },
        "label": {
            "title": "ทำให้เป็น %{entityType} สาธารณะ",
            "subtitle": "ทุกคนสามารถดูและทุกคนสามารถเข้าร่วม"
        }
    },
    "imageUploader": {
        "changeImageButton": "เปลี่ยนรูปภาพ"
    },
    "copyright": "ลิขสิทธิ์ © Sprout 2019",
    "samsunghealth_not_available": "ไม่สามารถเชื่อมต่อกับ Samsung Health ในแอป Health ด้านล่างการอนุญาตข้อมูล ตรวจสอบให้แน่ใจว่าคุณมีสิทธิ์เปิดใช้งานขั้นตอนขั้นต่ำและมีการติดตามอย่างน้อย 1 ขั้นตอน",
    "rewardsHowDoIEarn": "ฉันจะได้รับ %{currencyName} ได้อย่างไร?",
    "unlockAchievements": "ปลดล็อกความสำเร็จ",
    "unlockAchievementsDescription": "ติดตามกิจกรรม รับ %{pointsName} ปลดล็อกระดับ และรับอีก %{currencyName} แตะที่ความสำเร็จแต่ละรายการเพื่อดูว่าคุณต้องทำอะไร",
    "myDay": "วันของฉัน",
    "myGoalsChallengesTasks": "เป้าหมาย ชาเลนจ์ และงานของฉัน",
    "yourGoalsChallenges": "เป้าหมายและชาเลนจ์ของคุณ",
    "mySocialStream": "โพสต์ชุมชน",
    "viewAllAchievements": "ดูความสำเร็จทั้งหมด",
    "viewAllBonusChallenges": "ดูชาเลนจ์โบนัสทั้งหมด",
    "newVersionOfAppAvailable": "มีเวอร์ชันใหม่! กรุณาโหลดหน้านี้ใหม่",
    "noBonusChallengesToDisplay": "ในปัจจุบัน ไม่มีชาเลนจ์โบนัสที่ใช้ได้",
    "bonusChallenges": "ชาเลนจ์โบนัส",
    "reloadAppVersion": "โหลดอีกครั้ง",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการลบการติดตาม %{activity_name}?",
    "activity_tracker_instruction_header": "แตะที่วันเพื่อติดตามกิจกรรม หรือดูสิ่งที่ถูกติดตามไปแล้ว",
    "alertDashboardFunctionalityToBeAdded": "ระบบจะเพิ่มข้อความที่นี่เพื่ออธิบายว่าระยะเวลาในการติดตามเป็นอย่างไร คล้ายกับการดำเนินการกับโปรแกรมสมาชิกของสายการบินที่ผู้ใช้จำเป็นต้องสะสม \"ไมล์\" ในปีปฏิทินเพื่อรับสถานะสำหรับปีหน้า",
    "noNumberEntered": "กรอกจำนวนของกิจกรรม",
    "feed": "สตรีม",
    "home": "หน้าหลัก",
    "challenges": "ชาเลนจ์",
    "explore": "สำรวจ",
    "rewards": "รางวัล",
    "reward": "รางวัล",
    "balance": "ยอดคงเหลือรางวัล %{programName} ของฉัน",
    "profile": "โปรไฟล์",
    "loading": "กำลังโหลด...",
    "me": "ฉัน",
    "back": "กลับ",
    "next": "ถัดไป",
    "skip": "ข้าม",
    "signup": "สมัคร",
    "signin": "เข้าสู่ระบบ",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "เข้าสู่ระบบ Live Better",
    "signup_with_medibank": "สมัครใช้งานเป็นสมาชิก Medibank",
    "signup_with_facebook": "สมัครใช้งานด้วย Facebook",
    "signup_with_google": "สมัครใช้งานด้วย Google",
    "signup_with_email": "สมัครใช้งานด้วยอีเมล",
    "signin_with_medibank": "เข้าสู่ระบบด้วยการใช้ Medibank ของฉัน",
    "signin_with_facebook": "เข้าสู่ระบบด้วย Facebook",
    "signin_with_google": "เข้าสู่ระบบด้วย Google",
    "signin_with_email": "เข้าสู่ระบบด้วยอีเมล",
    "signup_heading": "สร้างบัญชี",
    "not_a_medibank_member": "ไม่ใช่สมาชิก Medibank?",
    "keep_me_signed_in": "ให้ฉันอยู่ในระบบ",
    "forgotpassword": "ลืมรหัสผ่านใช่หรือไม่?",
    "emailaddress": "อีเมล",
    "password": "รหัสผ่าน",
    "enterEmailAddress": "กรอกอีเมลของคุณ",
    "enterYourPassword": "ป้อนรหัสผ่านของคุณ",
    "password_for_error": "รหัสผ่าน",
    "reset_password": "รีเซ็ตรหัสผ่าน",
    "passwordResetSuccess": "ตั้งค่ารหัสผ่านใหม่",
    "passwordResetEmailSent": "หากเรามีอีเมลที่ตรงกันในระบบของเรา คำแนะนำในการรีเซ็ตรหัสผ่านจะส่งไปให้คุณทางอีเมล",
    "loginerror": "เกิดข้อผิดพลาดขณะเข้าสู่ระบบ:",
    "logincancelled": "ยกเลิกการเข้าสู่ระบบแล้ว",
    "part_of_corporate_program": "คุณกำลังสมัครเข้าร่วมโปรแกรมองค์กรใช่หรือไม่?",
    "continue_here": "ดำเนินการต่อที่นี่",
    "program_name": "ชื่อโปรแกรม",
    "error_provide_program_name": "กรุณาระบุชื่อโปรแกรม",
    "program_not_found": "ไม่พบโปรแกรม",
    "registration_field_email": "อีเมล",
    "employeeId": "ID พนักงาน",
    "registration_field_firstName": "ชื่อจริง",
    "registration_field_lastName": "นามสกุล",
    "no_first_name": "ไม่มีชื่อจริง",
    "no_last_name": "ไม่มีนามสกุล",
    "registration_field_password": "รหัสผ่านใหม่",
    "no_disclaimer_available": "ขออภัย มีปัญหา... เราไม่สามารถเรียกคืนข้อกำหนดและเงื่อนไขขององค์กรคุณ กรุณาลองลงทะเบียนอีกครั้งในภายหลัง ",
    "registration_account_not_registered": "ดูเหมือนว่าคุณยังไม่ได้ยืนยันอีเมลของคุณ คุณต้องการให้เราส่งอีเมลอีกครั้งหรือไม่?",
    "resend_verification_email": "การยืนยันอีเมล",
    "resend_verification_email_successful": "เราได้ส่งอีเมลยืนยันของคุณอีกครั้ง",
    "resend_verification_email_unsuccessful": "ขออภัย มีปัญหา... เราไม่สามารถส่งอีเมลยืนยันอีกครั้งได้ กรุณาลองอีกครั้ง",
    "not_supported": "ไม่สามารถแสดงโพสต์นี้ได้ในขณะนี้ กรุณาลองอีกครั้งในภายหลัง",
    "policyAgreeError": "หากต้องการดำเนินการต่อ กรุณายอมรับข้อกำหนดการให้บริการและนโยบายความเป็นส่วนตัว",
    "challenge_completion_bonus": "โบนัสสำเร็จ",
    "me_tabs": {
        "activity": "กิจกรรม",
        "bookmarks": "บุ๊กมาร์ก"
    },
    "health_tab": {
        "my_health_score": "คะแนนสุขภาพของคุณ",
        "overall_health_score_description": "คะแนนสุขภาพของคุณ คือ",
        "health_score_explanation": "คะแนนสุขภาพของคุณคำนวณจากคำตอบเกี่ยวกับสุขภาพและความแอคทีฟของคุณ \n\nคะแนนของคุณจะได้รับการอัปเดตทุกเดือนตามระดับกิจกรรมของคุณ คุณสามารถกำหนดและบรรลุเป้าหมายส่วนบุคคลเพื่อปรับปรุงคะแนนสุขภาพของคุณ",
        "health_score_calculation_failed_onboarding": "มีบางอย่างผิดพลาด และเราไม่สามารถเรียกคะแนนสุขภาพของคุณได้ คุณสามารถดำเนินการต่อได้ในตอนนี้ และทันทีที่ปัญหาได้รับการแก้ไข เราจะอัปเดตคะแนนของคุณ"
    },
    "track_activity": "ติดตามกิจกรรม",
    "track_an_activity": "ติดตามกิจกรรม",
    "track": "ติดตาม",
    "unable_to_track": "ไม่สามารถติดตาม",
    "enter_before_track": "กรอกจำนวนกิจกรรมที่จะติดตาม",
    "what_to_share": "คุณต้องการแชร์ข้อมูลอัปเดตประเภทใด?",
    "remove": "ลบ",
    "activity_tracking_description": "คุณต้องการติดตามกี่ %{units} ?",
    "excessive_submission": "ว้าว! คุณกำลังจะติดตามมากกว่า 2,000 %{customPoints} สำหรับ %{activity_name} คุณอาจต้องการตรวจสอบให้แน่ใจก่อนส่ง",
    "on": "เมื่อ",
    "in": "ใน",
    "from": "จาก",
    "at": "ที่",
    "no_activities": "ไม่มีกิจกรรมที่ตรงกับการค้นหาของคุณ",
    "activity_tracking_desc": "คุณจำเป็นต้องเพิ่มหมายเลขเพื่อดำเนินการต่อ แตะ X ที่มุมซ้ายเพื่อยกเลิก",
    "activity_tracking_desc2": "แตะที่ใดก็ได้ในกิจกรรมเพื่อแก้ไข แตะ + เพื่อติดตามเป้าหมายอย่างรวดเร็ว",
    "vital_stats_title": "เกี่ยวกับคุณ",
    "invalid_numeric_response": "ไม่ถูกต้อง",
    "invalid_numeric_response_range": "ตัวเลขนี้ต้องอยู่ระหว่าง %{minimum} ถึง %{maximum}",
    "search_placeholder": "ค้นหาไลบรารี่...",
    "search_activities": "ค้นหากิจกรรม",
    "searching": "กำลังค้นหา...",
    "searchEmpty": "ไม่พบรายการที่ตรงกัน",
    "vital_stats_description": "บอกเราหน่อยเกี่ยวกับตัวคุณสักเล็กน้อย",
    "health_survey_questions": "คำถามสำรวจสุขภาพ",
    "health_survey_title": "ทำแบบสำรวจสุขภาพให้เสร็จสมบูรณ์",
    "health_survey_results": "ผลการสำรวจสุขภาพ",
    "health_survey_card_desc": "ทำแบบสำรวจเพื่อหาภาพรวมของความเป็นอยู่ที่ดีและกำหนดเป้าหมายส่วนบุคคลของคุณ",
    "apps_devices_title": "เชื่อมโยงแอปและอุปกรณ์",
    "apps_devices_card_desc": "ซิงค์แอปและอุปกรณ์ของคุณเพื่อรับ %{customPoints} อย่างง่ายดาย",
    "interests_title": "ความสนใจ",
    "interests_card_desc": "บอกเราเกี่ยวกับความสนใจของคุณ ซึ่งจะช่วยให้เราแนะนำเป้าหมายและชุมชนที่คุณอาจสนใจ",
    "interests_screen_desc": "คุณรู้สึกสนใจเรื่องอะไร?",
    "health_obj_title": "วัตถุประสงค์ความเป็นอยู่ที่ดี",
    "health_obj_card_desc": "เราคิดว่าถึงเวลาที่จะกำหนดเป้าหมายบางอย่าง เมื่อเราทราบวัตถุประสงค์ของคุณแล้ว เราจะสามารถให้คำแนะนำที่ดีขึ้นแก่คุณได้ ไม่ต้องกังวล หากคุณเปลี่ยนใจ คุณสามารถเปลี่ยนแปลงในภายหลังได้อย่างง่ายดายในโปรไฟล์ของคุณ ",
    "health_obj_screen_desc": "คุณต้องการทำงานในด้านใด?",
    "my_heatlh_obj": "วัตถุประสงค์ความเป็นอยู่ที่ดีของฉัน",
    "health_topic_title": "วัตถุประสงค์ด้านความเป็นอยู่ที่ดี",
    "health_topic_card_desc": "ปรับแต่งประสบการณ์ของคุณโดยระบุหัวข้อด้านสุขภาพของคุณ",
    "health_topic_screen_desc": "คุณสนใจเรียนรู้เกี่ยวกับอะไร?",
    "multi_select_check_error": "กรุณาเลือกอย่างน้อย 1 ตัวเลือกเพื่อดำเนินการต่อ",
    "my_health_topics": "หัวข้อความเป็นอยู่ที่ดีของฉัน",
    "build_your_profile": "สร้างโปรไฟล์ของคุณ",
    "personalize_title": "ปรับแต่ง",
    "personalize_desc": "ปรับแต่งประสบการณ์ของคุณด้วยการตอบคำถามสั้น ๆ สองสามข้อ",
    "set_goals_title": "ดูเป้าหมายที่แนะนำ",
    "set_goals_desc": "กำหนดเป้าหมายส่วนบุคคลเพื่อเริ่มต้นเส้นทางสู่สุขภาพที่ดีขึ้น",
    "set_this_goal": "กำหนดเป้าหมายนี้",
    "goal_set": "กำหนดเป้าหมายแล้ว",
    "required": "จำเป็น",
    "apps_devices_description": "เชื่อมต่อกับแพลตฟอร์มฟิตเนสเพื่อรับ %{customPoints} เพิ่มขึ้นโดยอัตโนมัติ",
    "connected": "เชื่อมต่อแล้ว",
    "num_connected": "(เชื่อมต่อแล้ว %{numDevices} อุปกรณ์)",
    "available": "ใช้ได้",
    "inProgress": "อยู่ระหว่างการดำเนินการ...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "ซิงค์ล่าสุด",
    "last_synced_lc": "ซิงค์ล่าสุด",
    "no_connected_devices": "ไม่มีอุปกรณ์เชื่อมต่อ",
    "apps_devices_confirm_disconnect": "คุณแน่ใจหรือว่าต้องการยกเลิกการเชื่อมต่อ",
    "button_delete": "ลบ",
    "button_disconnect": "ตัดการเชื่อมต่อ",
    "button_cancel": "ยกเลิก",
    "button_dismiss": "ไม่สนใจ",
    "ok": "ตกลง",
    "waist_helper_text": "ควรวัดรอบเอวให้ต่ำกว่าซี่โครง โดยปกติแล้วจะอยู่ที่ระดับสะดือในขณะยืน หากไม่แน่ใจ ให้ใช้ขนาดกางเกงยีนส์ของคุณ",
    "apps_devices_manage": "จัดการแอปและอุปกรณ์ของฉัน",
    "my_apps_devices": "แอปและอุปกรณ์ของฉัน",
    "completeRegistration": "ลงทะเบียนให้เสร็จสมบูรณ์",
    "havingTrouble": "เจอปัญหา?",
    "contactUs": "ติดต่อ support@sproutatwork.com เพื่อขอความช่วยเหลือ",
    "done": "เสร็จสิ้น",
    "brand": "Sprout",
    "cannotTrackTitle": "ไม่สามารถติดตามกิจกรรม",
    "cannotTrackPrior": "นั่นไง สามารถติดตามกิจกรรมได้หลังจากวันที่เริ่มต้นเท่านั้น",
    "cannotTrackFuture": "อย่ารีบร้อน สามารถติดตามกิจกรรมได้จนถึงวันปัจจุบันเท่านั้น",
    "cannotTrack": "ไม่สามารถติดตามกิจกรรมก่อนวันที่เริ่มต้น หรือสำหรับวันข้างหน้า",
    "disclaimer": "ข้อความปฏิเสธความรับผิดชอบ",
    "acceptTerms": "ฉันยอมรับข้อกำหนดและเงื่อนไข",
    "verificationEmailTitle": "ยืนยันอีเมลของคุณ",
    "email_not_yet_verified": "ดูเหมือนว่าคุณยังไม่ได้ยืนยันอีเมลของคุณ ",
    "email_successfully_verified_title": "ยินดีต้อนรับ",
    "email_successfully_verified": "คุณยืนยันอีเมลของคุณสำเร็จแล้ว",
    "pleaseVerifyEmailMessage1": "คุณจะต้องยืนยันอีเมลของคุณเพื่อดำเนินการต่อ",
    "pleaseVerifyEmailMessage2": "กรุณาปฏิบัติตามคำแนะนำที่ส่งไปยัง:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "ส่งอีเมลอีกครั้ง",
    "restart": "ย้อนกลับไปที่การลงชื่อเข้าใช้",
    "firstName": "ชื่อจริง",
    "firstNamePlaceholder": "ชื่อจริงของคุณ",
    "lastName": "นามสกุล",
    "lastNamePlaceholder": "นามสกุลของคุณ",
    "email": "อีเมล",
    "emailPlaceholder": "อีเมลของคุณ",
    "employeId": "ID พนักงาน",
    "employeIdPlaceholder": "ID พนักงานบริษัท",
    "passwordPlaceholder": "รหัสผ่านใหม่",
    "datePickerTitle": "เลือกวันเดือนปีเกิดของคุณ",
    "datePickerConfirm": "ยืนยัน",
    "datePickerCancel": "ยกเลิก",
    "termsOfUsePrivacyPreLinks": "ฉันยอมรับ",
    "sendMePromoCommunications": "ส่งการสื่อสารส่งเสริมการขายให้ฉัน",
    "sendMePromoCommunicationsFromPartners": "ส่งการสื่อสารส่งเสริมการขายจากพันธมิตรให้ฉัน",
    "termsOfService": "ข้อกำหนดการให้บริการ",
    "legal": "กฎหมาย",
    "privacyPolicy": "นโยบายความเป็นส่วนตัว",
    "and": "และ",
    "programDomainLabel": "ชื่อโปรแกรม",
    "programDomainPlaceholder": "ชื่อโปรแกรม",
    "findProgramName": "ค้นหาชื่อโปรแกรมของฉัน",
    "findProgramNameButton": "ค้นหาชื่อโปรแกรม",
    "findProgramNameTitle": "ค้นหาชื่อโปรแกรมของฉัน",
    "findProgramNameDescription": "อีเมลบริษัท",
    "findProgramNamePlaceholder": "อีเมล",
    "findProgramSuccessMessage": "ผลลัพธ์ของการค้นหาชื่อโปรแกรมส่งถึงคุณทางอีเมลแล้ว",
    "findProgramSuccessTitle": "ชื่อโปรแกรม",
    "findProgramErrorTitle": "ชื่อโปรแกรม",
    "findProgramErrorMessage": "ขออภัย มีปัญหา... เราพบข้อผิดพลาดขณะพยายามเรียกคืนชื่อโปรแกรมของคุณ กรุณาลองอีกครั้ง",
    "countryLabel": "เลือกประเทศ",
    "countryName": "ประเทศ",
    "regionLabel": "เลือกภูมิภาค",
    "regionName": "ภูมิภาค",
    "cityLabel": "เลือกเมือง",
    "cityName": "เมือง",
    "locationWorkLabel": "เลือกตำแหน่ง",
    "locationWorkName": "ตำแหน่ง",
    "locationLabel": "เลือกตำแหน่ง",
    "locationName": "ตำแหน่ง",
    "departmentLabel": "เลือกแผนก",
    "departmentName": "แผนก",
    "no_department": "ไม่มีแผนก",
    "enterPIN": "กรุณากรอกรหัส PIN ของบริษัทคุณ",
    "verifyEmailTitle": "การยืนยันอีเมล",
    "verifyEmailMsg": "ดูเหมือนว่าคุณยังไม่ได้ยืนยันอีเมลของคุณ",
    "resendEmailTitle": "การยืนยันอีเมล",
    "resendEmailMsg": "ส่งไปที่ %{userEmail}",
    "select_date": "เลือกวันที่",
    "changePasswordTitle": "เปลี่ยนรหัสผ่าน",
    "currentPassword": "รหัสผ่านปัจจุบัน",
    "newPassword": "รหัสผ่านใหม่",
    "confirmNewPassword": "ยืนยันรหัสผ่านใหม่",
    "passwordChangeError": {
        "currentPasswordMissing": "กรอกรหัสผ่านปัจจุบันของคุณ",
        "newPasswordMissing": "กรอกรหัสผ่านใหม่ของคุณ",
        "confirmPasswordMissing": "ยืนยันรหัสผ่านใหม่ของคุณ",
        "passwordsMatch": "รหัสผ่านไม่ตรงกัน",
        "passwordIncorrect": "รหัสผ่านไม่ถูกต้อง กรุณาลองอีกครั้ง"
    },
    "settings": "การตั้งค่า",
    "signOut": "ออกจากระบบ",
    "updateApp": "อัปเดตแอป",
    "updateAppRight": "ปัจจุบัน: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "ขอรับความช่วยเหลือ",
    "feedback": "ข้อเสนอแนะ",
    "feedback_success_title": "ส่งข้อเสนอแนะแล้ว",
    "feedback_success_msg": "ขอขอบคุณที่ส่งข้อเสนอแนะของคุณ เรายินดีเป็นอย่างยิ่ง!",
    "feedback_failure_title": "ข้อผิดพลาด",
    "feedback_failure_msg": "น่าเสียดาย! เกิดข้อผิดพลาดในการส่งความคิดเห็นของคุณ กรุณาลองอีกครั้ง",
    "submit": "ส่ง",
    "feedback_char_limit": "คุณมีจำนวนอักขระเกินขีดจำกัด",
    "feedback_char_limit_toast_title": "ข้อความยาวเกินไป",
    "feedback_char_limit_toast_msg": "ข้อความของคุณเกินขีดจำกัดสูงสุด 2,000 อักขระ",
    "feedback_char_length_msg_1": "คุณพิมพ์",
    "feedback_char_length_msg_2": "\/2000 อักขระ",
    "feedback_empty_toast_title": "ข้อความว่างเปล่า",
    "feedback_empty_toast_msg": "ดูเหมือนว่าคุณยังไม่ได้พิมพ์อะไรเลย พิมพ์ข้อความก่อนส่ง",
    "feedback_email_message": "ข้อความ:",
    "feedback_email_user_id": ", ID ผู้ใช้:",
    "feedback_email_device": ", อุปกรณ์:",
    "feedback_email_os_version": ", เวอร์ชัน OS:",
    "feedback_email_app_version": ", เวอร์ชันแอป:",
    "savingUserToast": {
        "success": {
            "title": "บันทึกการเปลี่ยนแปลง",
            "message": "บันทึกการเปลี่ยนแปลงโปรไฟล์แล้ว"
        },
        "danger": {
            "title": "พบข้อผิดพลาด",
            "message": "ขออภัย... เราพบข้อผิดพลาดขณะพยายามบันทึกการเปลี่ยนแปลงของคุณ กรุณาลองอีกครั้ง"
        }
    },
    "edit_profile_user_error_msg": "กรุณาตรวจสอบข้อผิดพลาดก่อนพยายามบันทึกการเปลี่ยนแปลงของคุณ",
    "edit_profile_location_error": "คุณจำเป็นต้องระบุตำแหน่งของคุณ",
    "edit_profile_department_error": "คุณจำเป็นต้องระบุแผนกของคุณ",
    "edit_profile_unspecified_value": "คุณจำเป็นต้องระบุค่าของคุณ",
    "edit_profile_value_too_low": "ค่าต้องมากกว่า",
    "edit_profile_value_too_high": "ค่าต้องน้อยกว่า",
    "choose_gender": "เลือกเพศ",
    "activity_tracked_successfuly": "กิจกรรมของคุณกำลังถูกติดตาม",
    "multi_activity_tracked_successfully": "กิจกรรมของคุณกำลังถูกติดตาม",
    "no_activities_tracked": "ไม่มีกิจกรรมที่ติดตาม",
    "track_activity_to_submit": "เลือกวันที่ในปฏิทินเพื่อติดตามกิจกรรม",
    "last_day": "สุดท้าย",
    "days_remaining": "วันคงเหลือ",
    "day_remaining": "วันคงเหลือ",
    "days_remaining_this_week": "วันคงเหลือในสัปดาห์นี้",
    "day_remaining_this_week": "วันคงเหลือในสัปดาห์นี้",
    "days_remaining_this_month": "วันคงเหลือในเดือนนี้",
    "day_remaining_this_month": "วันคงเหลือในเดือนนี้",
    "earned_today": "ที่ได้รับวันนี้",
    "earned_this_week": "ที่ได้รับสัปดาห์นี้",
    "earned_this_month": "ที่ได้รับเดือนนี้",
    "earned_in_total": "ที่ได้รับทั้งหมด",
    "goal_completed": "เป้าหมายที่เสร็จสมบูรณ์",
    "see_results": "ดูผลลัพธ์",
    "pts": "%{customPoints}",
    "of": "ของ",
    "daily_goal": "เป้าหมายรายวัน",
    "weekly_goal": "เป้าหมายรายสัปดาห์",
    "monthly_goal": "เป้าหมายรายเดือน",
    "total_goal": "เป้าหมายทั้งหมด",
    "weeks": "สัปดาห์",
    "today": "วันนี้",
    "this_week": "สัปดาห์นี้",
    "this_month": "เดือนนี้",
    "overall": "โดยรวม",
    "level": "ระดับ",
    "days_remaining_in_period": "%{remainingDays} วันคงเหลือ",
    "days_left_in_period": "เหลือ %{remainingDays} วันให้ติดตาม",
    "pointsToLevel": "ความคืบหน้าไปยัง %{levelName}",
    "levelCompleted": "เสร็จสมบูรณ์ %{levelName}",
    "keepTrackingUntil": "ติดตามจนถึง",
    "activityLevelTitle": "ระดับกิจกรรมของฉัน",
    "activityLevelDescription": "คุณใช้เวลาในการออกกำลังกายระดับปานกลางเป็นอย่างน้อยมากเพียงใดในสัปดาห์ปกติ กล่าวคือเมื่อคุณออกแรงมากพอที่จะเพิ่มอัตราการเต้นของหัวใจและทำให้เหงื่อออก? ",
    "activityLevelUnder60": "ต่ำกว่า 60 นาที",
    "activityLevelUnder150": "60 ถึง 150 นาที",
    "activityLevelOver150": "มากกว่า 150 นาที",
    "gender_male": "ชาย",
    "gender_female": "หญิง",
    "gender_rather_not_say": "ไม่ประสงค์ที่จะตอบ",
    "date_of_birth": "วันเดือนปีเกิด",
    "height": "ส่วนสูง",
    "Height": "ส่วนสูง",
    "weight": "น้ำหนัก",
    "waistCircumference": "รอบเอว",
    "bloodPressureHg": "ความดันโลหิตขณะหัวใจบีบตัว",
    "bloodPressureMm": "ความดันโลหิตขณะหัวใจคลายตัว",
    "bloodCholesterol": "คอเลสเตอรอลในเลือดทั้งหมด",
    "ldl": "ไลโพโปรตีนความหนาแน่นต่ำ (LDL)",
    "hdl": "ไลโพโปรตีนความหนาแน่นสูง (HDL)",
    "restingHeartRate": "อัตราการเต้นของหัวใจขณะพัก",
    "percentageBodyFat": "ร้อยละไขมันในร่างกาย",
    "hipCircumference": "รอบสะโพก",
    "bloodGlucose": "กลูโคสในเลือด",
    "triglycerides": "ไตรกลีเซอไรด์",
    "error_401_signed_out_message": "หมดเวลาการใช้งาน กรุณาเข้าสู่ระบบอีกครั้ง",
    "first_name": "ชื่อจริง",
    "last_name": "นามสกุล",
    "preferred_name": "ชื่อที่ต้องการ",
    "notifications": "การแจ้งเตือน",
    "notificationsMarkAllReadButton": "ทำเครื่องหมายการแจ้งเตือนทั้งหมดว่าอ่านแล้ว",
    "notificationsSettingsButton": "การตั้งค่า",
    "notificationsSettingsTitle": "การแจ้งเตือนและอีเมล",
    "notificationEmptyMessage": "การแจ้งเตือนของคุณเป็นปัจจุบันแล้ว",
    "priorityModalTitle": "การแจ้งเตือนสำคัญของฉัน",
    "remindMeLater": "เตือนฉันภายหลัง",
    "priorityAdminTitle": "การแจ้งเตือนจากผู้ดูแลระบบของคุณ",
    "markAsRead": "ทำเครื่องหมายว่าอ่านแล้ว",
    "expand": "แตะเพื่อขยาย",
    "collapse": "แตะเพื่อยุบ",
    "takePhoto": "ถ่ายภาพใหม่",
    "choosePhoto": "เลือกภาพถ่าย",
    "deletePhoto": "ลบภาพถ่าย",
    "profileImageChangeErrorTitle": "พบข้อผิดพลาด",
    "profileImageChangeErrorMessage": "ขออภัย... เกิดข้อผิดพลาดในการแก้ไขภาพถ่ายของคุณ กรุณาลองอีกครั้ง",
    "editProfile": "แก้ไขโปรไฟล์",
    "postButton": "โพสต์",
    "shareYourDayName": "คุณกำลังทำอะไร?",
    "greeting": "สวัสดี %{firstNameDisplay}!",
    "shareAnUpdate": "คุณกำลังทำอะไร?",
    "shareYourDaySubtitle": "คุณกำลังทำอะไร?",
    "shareAPost": "แชร์โพสต์",
    "postVisibleTo": "มองเห็นได้กับ",
    "link": "เชื่อมโยง",
    "photo": "ภาพถ่าย",
    "insertLink": "เพิ่มลิงก์ไปยังโพสต์ของคุณ",
    "save": "บันทึก",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "คุณจำเป็นต้องเพิ่มเนื้อหาในโพสต์ของคุณก่อนส่ง",
    "generalErrorTitle": "โพสต์ว่างเปล่า",
    "generalSuccessTitle": "ความสำเร็จ",
    "simplePlaceholder": "คุณกำลังทำอะไร?",
    "likesCountLabel": "การยกนิ้วให้",
    "likesReceivedLabel": "การยกนิ้วให้ที่ได้รับ",
    "commentsCountLabel": "ความคิดเห็น",
    "commentsCountLabelSingular": "ความคิดเห็น",
    "likeButton": "การยกนิ้วให้",
    "commentButton": "ความคิดเห็น",
    "seePreviousComments": "ดูความคิดเห็นก่อนหน้า",
    "addCommentPlaceholder": "เพิ่มความคิดเห็น",
    "postCommentButton": "โพสต์",
    "seeMoreLongComment": "ดูเพิ่มเติม",
    "activityPoints": "%{customPoints}",
    "activityLog": "บันทึกกิจกรรม",
    "discardPost": "ละทิ้ง",
    "discardPostMessage": "คุณแน่ใจหรือไม่ว่าต้องการละทิ้งโพสต์ของคุณ?",
    "stream_filter_title": "สตรีม",
    "stream_filter_screen_desc": "เลือกโพสต์ที่คุณต้องการดูในสตรีม",
    "stream_filter_selection": "กำลังแสดง:",
    "moderate": "ทำเครื่องหมายว่าไม่เหมาะสม",
    "moderateDescription": "การทำเครื่องหมายว่ารายการนี้ว่าไม่เหมาะสมจะเป็นการลบออกและจะแจ้งให้ผู้ดูแลระบบทราบ",
    "editPost": "แก้ไขโพสต์",
    "deletePost": "ลบโพสต์",
    "deleteComment": "ลบความคิดเห็น",
    "editComment": "แก้ไขความคิดเห็น",
    "visibleOnlyToMe": "มองเห็นได้เฉพาะฉัน",
    "joinEvent": "RSVP สำหรับอีเวนต์",
    "joinEventDetail": "เข้าร่วมอีเวนต์",
    "joinedEvent": "ฉันกำลังไป",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "คุณได้เข้าร่วมอีเวนต์",
            "message": "คุณเข้าร่วมอีเวนต์นี้สำเร็จแล้ว"
        }
    },
    "joinChallenge": "เข้าร่วมชาเลนจ์",
    "viewChallenge": "ดูชาเลนจ์",
    "joinedChallenge": "เข้าร่วมชาเลนจ์แล้ว",
    "joinCommunity": "เข้าร่วมชุมชน",
    "joinedCommunity": "เข้าร่วมชุมชนแล้ว",
    "joinProgress": "กำลังเข้าร่วม",
    "joinSuccess": "เข้าร่วมแล้ว",
    "invitePeopleToCommunity": "เชิญคนเข้าสู่ชุมชน",
    "numberOfMembers": "สมาชิก %{num} คน",
    "joinToView": "เข้าร่วมชุมชนนี้เพื่อดูและโพสต์ให้สมาชิกคนอื่น ๆ",
    "numberOfAttendees": "ผู้เข้าร่วม %{num} คน",
    "numberOfParticipants": "ผู้มีส่วนร่วม %{num} คน",
    "numberOfMembersWithUser": "คุณและสมาชิกคนอื่น ๆ %{num} คน",
    "numberOfAttendeesWithUser": "คุณและผู้เข้าร่วมคนอื่น ๆ %{num} คน",
    "numberOfParticipantsWithUser": "คุณและผู้มีส่วนร่วมคนอื่น ๆ %{num} คน",
    "communityMembers": "สมาชิก %{numberOfMembers} คน",
    "communityEvents": "อีเวนต์ที่จะจัดขึ้น %{numberOfEvents} งาน",
    "myEvents": "อีเวนต์ของฉัน",
    "seeAll": "ดูทั้งหมด",
    "noUpcomingEvents": "ไม่มีอีเวนต์ที่จะจัดขึ้น เข้าร่วมสักหนึ่งรายการ!",
    "myCommunities": "ชุมชนของฉัน",
    "invitedCommunities": "เชิญแล้ว",
    "invitationSendingMessage": "กำลังส่งคำเชิญ...",
    "invitationReceivedMessage": "เชิญคุณเข้าร่วมแล้ว",
    "invitationMessage": "เราชอบที่คุณเข้าร่วมในชุมชนของเรา!",
    "recommendedCommunities": "แนะนำสำหรับคุณ",
    "leaveCommunity": "ออกจากชุมชนนี้",
    "leaveTeam": "คุณแน่ใจหรือไม่ว่าต้องการออกจากทีม",
    "leaveTeamLastMember": "ในชาเลนจ์นี้? ในฐานะสมาชิกคนสุดท้ายของทีม การออกจากชาเลนจ์จะเป็นการลบทีม",
    "leaveTeamChallenge": "ในชาเลนจ์นี้?",
    "Oops": "ขออภัย มีบางอย่างผิดพลาด",
    "editCommunity": "แก้ไขชุมชน",
    "deleteCommunity": "ลบชุมชนนี้",
    "leaveCommunityDescription": "คุณแน่ใจหรือไม่ว่าต้องการออกจากชุมชนนี้?",
    "inviteToCommunity": "เชิญเข้าสู่ชุมชน",
    "inviteByMembers": "เชิญตามชื่อ",
    "inviteByEmail": "เชิญตามอีเมล",
    "select_person": "กรุณาเลือกอย่างน้อยหนึ่งคนที่จะเชิญ",
    "no_users_found": "ฮืมม… ดูเหมือนเราจะไม่พบใครในชื่อนั้นเลย",
    "promptJoinCommunities": "ดูเหมือนว่าคุณยังไม่ได้เข้าร่วมชุมชนใด ๆ เข้าร่วมชุมชนเพื่อมีส่วนร่วมกับผู้อื่นและแบ่งปันการเดินทางของคุณ",
    "exploreCommunities": "สำรวจชุมชน",
    "sendInviteByMembers": "เชิญ %{num} คน",
    "sendInviteByEmail": "ส่งคำเชิญอีเมล",
    "createNewCommunity": "สร้างชุมชนใหม่",
    "createCommunity": "สร้างชุมชน",
    "uploadCover": "เพิ่มภาพถ่าย",
    "cover": "ภาพปก",
    "nameOfCommunity": "ชื่อชุมชน",
    "whatCommunityAbout": "ชุมชนนี้เกี่ยวกับอะไร?",
    "companyMembersOnly": "สมาชิกบริษัทเท่านั้น",
    "viewAllButton": "ดูทั้งหมด",
    "communities": "ชุมชน",
    "contentLibrary": "ไลบรารี่",
    "events": "อีเวนต์",
    "past_events": "อีเวนต์ที่ผ่านมา",
    "invitationCommunity": "ชุมชน",
    "searchPeople": "ค้นหาบุคคล",
    "enterEmail": "กรอกอีเมล",
    "personalMessageToNewInvitees": "ข้อความส่วนบุคคลถึงผู้ได้รับเชิญใหม่",
    "dangerToastTitle": "ข้อผิดพลาด",
    "dangerToastMessage": "ฮืมม... เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
    "successToastTitle": "ความสำเร็จ",
    "successToastMessage": "การดำเนินการเสร็จสมบูรณ์",
    "joiningToast": {
        "success": {
            "message": "คุณเข้าร่วมแล้ว"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "ลบความคิดเห็นแล้ว"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "ทำเครื่องหมายความคิดเห็นว่าไม่เหมาะสมแล้ว"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "อัปเดตความคิดเห็นแล้ว"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "อัปเดตความคิดเห็นแล้ว"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "อัปเดตภาพถ่ายโปรไฟล์แล้ว"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "ลบภาพถ่ายแล้ว"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "โพสต์ไปยังสตรีม",
            "message": "โพสต์ของคุณถูกสร้างแล้ว"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "แก้ไขโพสต์",
            "message": "โพสต์ของคุณถูกแก้ไขแล้ว"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "ลบโพสต์",
            "message": "โพสต์ของคุณถูกลบแล้ว"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "ทำเครื่องหมายว่าไม่เหมาะสม",
            "message": "ทำเครื่องหมายโพสต์ว่าไม่เหมาะสมแล้ว"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "ทำเครื่องหมายว่าอ่านแล้ว",
            "message": "ทำเครื่องหมายการแจ้งเตือนทั้งหมดว่าอ่านแล้ว"
        },
        "info": {
            "title": "ทำเครื่องหมายว่าอ่านแล้ว",
            "message": "การแจ้งเตือนทั้งหมดถูกทำเครื่องหมายว่าอ่านแล้ว"
        },
        "danger": {
            "title": "ทำเครื่องหมายว่าอ่านแล้ว"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "ไม่สามารถทำเครื่องหมายการแจ้งเตือนว่าอ่านแล้ว"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "อัปเดตรหัสผ่านแล้ว",
            "message": "เข้าสู่ระบบด้วยรหัสผ่านใหม่ของคุณ"
        },
        "danger": {
            "title": "อัปเดตรหัสผ่าน",
            "message": "ขออภัย… เกิดข้อผิดพลาดบางอย่างเมื่อเราพยายามอัปเดตรหัสผ่านของคุณ กรุณาลองอีกครั้ง"
        }
    },
    "joining": {
        "success": {
            "message": "คุณเข้าร่วม %{name} แล้ว"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "คำเชิญ",
            "message": "คำเชิญถูกส่งแล้ว"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "สร้างชุมชน",
            "message": "ชุมชนใหม่ของคุณถูกสร้างแล้ว"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "เป้าหมายของคุณถูกรีสตาร์ทแล้ว"
        },
        "danger": {
            "message": "ไม่สามารถรีสตาร์ทเป้าหมาย"
        }
    },
    "quit": "ออก",
    "wellbeing_survey_completed": "แบบสำรวจสุขภาพเสร็จสมบูรณ์แล้ว",
    "wellbeing_survey_completed_message": "ขอขอบคุณสำหรับการกรอกแบบสำรวจ เราหวังว่าสิ่งนี้จะช่วยให้คุณได้รับข้อมูลเชิงลึกเกี่ยวกับความเป็นอยู่ที่ดีของคุณ",
    "update_wellbeing_score": "อัปเดตคำตอบแบบสำรวจของฉัน",
    "get_wellbeing_score": "รับคะแนนสุขภาพของคุณ",
    "stats": "สถิติ",
    "my_wellbeing_score": "คะแนนสุขภาพของฉัน",
    "see_details": "ดูรายละเอียด",
    "how_score_calculated": "คะแนนของฉันคำนวณอย่างไร?",
    "contentTitle": "ไลบรารี่",
    "promoted": "คุณสมบัติ",
    "recommended": "แนะนำ",
    "recommendedForMe": "แนะนำสำหรับฉัน",
    "recent": "เพิ่มล่าสุด",
    "view": "ดู",
    "added": "เพิ่มแล้ว",
    "more": "มากขึ้น",
    "openLibrary": "นำฉันไปที่ไลบรารี่",
    "readToEarn": "อ่านเพื่อรับ",
    "readArticle": "เปิดลิงก์",
    "see_more": "ดู (%{num}) เพิ่มเติม",
    "see_more_activities": "%{num} เพิ่มเติม",
    "my_achievements": "ความสำเร็จของฉัน",
    "achievements": "ความสำเร็จ",
    "achievement_earned_date": "ได้รับแล้ว: %{date}",
    "achievement_start_date": "เริ่มแล้ว: %{date}",
    "achievement_end_date": "สิ้นสุด: %{date}",
    "achievement_earned": "ได้รับ",
    "achievement_start": "เริ่ม",
    "achievement_end": "สิ้นสุด",
    "achievement_earned_times": "%{num} ครั้ง",
    "achievement_earned_time": "%{num} ครั้ง",
    "in_progress": "กำลังดำเนินการ",
    "date_earned": "วันที่ได้รับ",
    "earned": "ได้รับ",
    "past_dates_earned_heading": "วันที่ได้รับในช่วงที่ผ่านมา",
    "all": "ทั้งหมด",
    "eat": "กิน",
    "move": "ขยับ",
    "feel": "รู้สึก",
    "profile_completion": "ความสมบูรณ์ของโปรไฟล์: %{percentage}%",
    "complete_my_profile": "กรอกโปรไฟล์ของคุณ",
    "do_following_tasks": "ทำงานต่อไปนี้ %{num} งานเพื่อทำให้โปรไฟล์ของคุณเสร็จสมบูรณ์",
    "improve_my_score": "ปรับปรุงคะแนนของคุณ",
    "see_which_goals": "ตรวจสอบเป้าหมายที่คุณตั้งไว้ในการกิน เคลื่อนไหว และรู้สึกดีขึ้น",
    "havent_set_goal": "คุณยังไม่ได้กำหนดเป้าหมาย",
    "set_a_goal": "กำหนดเป้าหมาย",
    "set_another_goal": "กำหนดเป้าหมายอื่น",
    "set_another_goal_here": "กำหนดเป้าหมายอื่นที่นี่",
    "my_recently_tracked_activities": "กิจกรรมล่าสุดของฉัน",
    "a_few_seconds_ago": "สองสามวินาทีที่ผ่านมา",
    "a_day_ago": "หนึ่งวันที่ผ่านมา",
    "yesterday": "เมื่อวาน",
    "earn": "ได้รับ",
    "delete_activity_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการนำกิจกรรมนี้ออก?",
    "delete_activity_title": "ลบ %{measurement} ของ %{activity_name}?",
    "reached_daily_goal": "คุณบรรลุเป้าหมายในวันนี้ของคุณ! ทำดีมาก!",
    "multiple_activity_non_daily_instruction": "แตะที่แถวกิจกรรมเพื่อเริ่มติดตามและรับ %{customPoints}!",
    "multiple_activity_daily_instruction": "แตะที่เครื่องหมายบวกเพื่อติดตามจำนวนกิจกรรมที่จำเป็นในการบรรลุเป้าหมายของคุณ แตะที่ใดก็ได้ในแถวกิจกรรมเพื่อติดตามจำนวนใด ๆ ของกิจกรรมนั้น",
    "only_automatic_activities": "กิจกรรมที่นำไปสู่เป้าหมายนี้สามารถติดตามได้โดยอัตโนมัติเท่านั้น",
    "only_automatic_activity": "กิจกรรมที่นำไปสู่เป้าหมายนี้สามารถติดตามได้โดยอัตโนมัติเท่านั้น",
    "earn_pts_and_reach_goal": "รับ %{pts} คะแนนและบรรลุเป้าหมายด้วยการติดตาม %{qty}",
    "earn_pts_for_every": "รับ %{pts} คะแนนสำหรับทุก ๆ",
    "you_track": "ที่คุณติดตาม!",
    "you_have_tracked": "คุณได้ติดตามมาแล้ว %{qty}",
    "so_far": "กิจกรรม!",
    "start_goal": "กำหนดเป้าหมายนี้",
    "about_this_goal": "เกี่ยวกับเป้าหมายนี้",
    "start_date": "วันที่เริ่มต้น",
    "end_date": "วันสิ้นสุด",
    "activities": "กิจกรรม",
    "goal": "เป้าหมาย",
    "instructions": "คำแนะนำ",
    "daily": "ทุกวัน",
    "weekly": "รายสัปดาห์",
    "monthly": "รายเดือน",
    "total": "ทั้งหมด",
    "week": "สัปดาห์",
    "day": "วัน",
    "days": "วัน",
    "month": "เดือน",
    "months": "เดือน",
    "progress": "ความคืบหน้า",
    "about": "เกี่ยวกับ",
    "days_remaining_to_track": "คุณมีเวลา %{num} วันในการติดตามกิจกรรมใด ๆ ที่พลาดไป",
    "number_days": "%{num} วัน",
    "one_day": "1 วัน",
    "points_earned_this_week": "คะแนนที่ได้รับในสัปดาห์นี้",
    "points_earned_year": "คะแนนที่ได้รับตั้งแต่ต้นปีจนถึงปัจจุบัน",
    "completed": "เสร็จสมบูรณ์",
    "what_you_need_to_do": "สิ่งที่คุณจำเป็นต้องทำ",
    "see_all_num": "ดู %{num} ทั้งหมด",
    "my_week_progress": "ความคืบหน้ารายสัปดาห์ของคุณ",
    "my_day_progress": "ความคืบหน้ารายวันของคุณ",
    "my_month_progress": "ความคืบหน้ารายเดือนของคุณ",
    "my_total_progress": "ความคืบหน้าทั้งหมดของคุณ",
    "my_overall_progress": "ความคืบหน้าโดยรวม",
    "you_earned": "คุณได้รับ",
    "of_this_week": "%{num} ในสัปดาห์นี้",
    "of_this_day": "%{Num} ในวันนี้",
    "of_this_month": "%{num} ในเดือนนี้",
    "of_this_total": "%{num} ทั้งหมด",
    "of_this_overall": "%{num} โดยรวม",
    "remaining_this_week": "คงเหลือในสัปดาห์นี้",
    "remaining_this_month": "คงเหลือในเดือนนี้",
    "remaining_this_total": "คงเหลือ",
    "remaining_this_overall": "คงเหลือโดยรวม",
    "view_history": "ดูประวัติ",
    "this_goal_is": "เป้าหมายนี้ คือ",
    "will_run_for": "จะดำเนินไปสำหรับ",
    "button_unset_goal": "ยกเลิกการกำหนดเป้าหมาย",
    "button_leave_challenge": "ออกจากชาเลนจ์",
    "leaveChallenge": {
        "menu": "ออกจาก %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "ลบ %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "คุณได้ยกเลิกการกำหนดเป้าหมายส่วนบุคคลนี้"
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "คุณได้ออกจากชาเลนจ์"
        }
    },
    "activities_tracked": "ติดตามกิจกรรมแล้ว",
    "recently_tracked_activities": "กิจกรรมที่ติดตามล่าสุด",
    "add": "เพิ่ม",
    "change_before_track": "ดูเหมือนว่าคุณไม่ได้ทำการเปลี่ยนแปลงใด ๆ แก้ไขจำนวนกิจกรรมสำหรับวันนี้ หรือออกโดยไม่ทำการเปลี่ยนแปลง",
    "havent_tracked_today": "ดูเหมือนว่าคุณยังไม่ได้ติดตามกิจกรรมใด ๆ สำหรับวันนี้ เริ่มต้นด้วยการค้นหากิจกรรม",
    "cancel_tracking_quantity": "ยกเลิกการติดตาม %{quantity} จาก %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "การออกจะเป็นการละทิ้งการแก้ไขประวัติกิจกรรมของคุณ คุณแน่ใจหรือไม่?",
    "discard_activity_edits_confirmation_date": "การออกจะเป็นการละทิ้งการแก้ไขประวัติกิจกรรมของคุณสำหรับวันที่ %{date} คุณแน่ใจหรือไม่?",
    "yes_discard_edits": "ใช่ ออกและละทิ้งการแก้ไข",
    "createGoal": {
        "navigatorTitle": "สร้างเป้าหมายส่วนบุคคล",
        "navigatorSubtitle": "ขั้นตอนที่ %{step} จาก 4"
    },
    "allCommunities": "ทุกสิ่ง",
    "deleteCommunityDescription": "คุณแน่ใจหรือไม่ว่าต้องการลบชุมชนนี้?",
    "remaining": "คงเหลือ",
    "recommended_goal": "เป้าหมายที่แนะนำ",
    "pinError": "รหัส PIN %{pin} ไม่ถูกต้อง กรุณาลองอีกครั้ง",
    "previousPersonalGoals": "เป้าหมายส่วนบุคคลที่เสร็จสมบูรณ์แล้วของฉัน",
    "previousGoalsTitle": "เป้าหมายก่อนหน้าของฉัน",
    "endedOn": "สิ้นสุดแล้วเมื่อ",
    "achievedOfGoal": "คุณบรรลุ %{num}% ของเป้าหมาย",
    "previousGoalsEmptyMessage": "คุณไม่มีเป้าหมายก่อนหน้านี้",
    "emptyListDefaultMessage": "คุณไม่มีรายการที่นี่",
    "myCommunitiesEmpty": "ดูเหมือนว่าคุณยังไม่ได้เข้าร่วมชุมชนใด ๆ เข้าร่วมชุมชนเพื่อมีส่วนร่วมกับผู้อื่นและแบ่งปันการเดินทางของคุณ",
    "discoverMoreCommunities": "สำรวจชุมชนเพิ่มเติม",
    "howLong": "ระยะเวลา",
    "frequency": "ความถี่",
    "discard": "ละทิ้ง",
    "description": "คำอธิบาย",
    "optional": "ไม่บังคับ",
    "instruction": "คำแนะนำ",
    "name": "ชื่อ",
    "create": "สร้าง",
    "categories": "หมวดหมู่",
    "uploadPhoto": "เพิ่มภาพถ่าย",
    "delete_goal": "ลบ %{name} นี้",
    "delete_goal_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการลบเป้าหมายนี้?",
    "leave_goal_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการออกจากชาเลนจ์นี้?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "เป้าหมายของคุณถูกสร้างแล้ว"
        }
    },
    "defaultSelectMessage": "กรุณาเลือกตัวเลือก",
    "search": "ค้นหา",
    "inTotal": "รวม",
    "State": "สถานะ",
    "Business unit": "หน่วยธุรกิจ",
    "Work location": "สถานที่ทำงาน",
    "whenStart": "คุณต้องการเริ่มต้นเมื่อใด?",
    "every": "ทุก",
    "acceptChallenge": "ยอมรับชาเลนจ์",
    "activity_history_challenge": "ประวัติกิจกรรมสำหรับชาเลนจ์",
    "havent_tracked_challenge": "คุณไม่ได้ติดตามกิจกรรมใด ๆ สำหรับชาเลนจ์นี้",
    "earned_lowercase": "ได้รับ",
    "noone_tracked_yet": "ยังไม่มีใครติดตามอะไรเลย เริ่มติดตามเพื่อเป็นผู้นำในการแข่งขันครั้งนี้!",
    "you": "คุณ",
    "your_team": "ทีมของฉัน",
    "congrats_first_place": "ขอแสดงความยินดี คุณอยู่อันดับหนึ่ง! ดีแล้วทำต่อไป",
    "leader": "ผู้นำ",
    "average": "เฉลี่ย",
    "show_leader": "แสดงผู้นำ",
    "show_me": "แสดงฉัน",
    "show_my_team": "แสดงทีมของฉัน",
    "leaderboard": "กระดานผู้นำ",
    "my_team": "ทีมของฉัน",
    "remaining_to_track": "คงเหลือที่จะติดตาม",
    "avg": "เฉลี่ย",
    "invite": "เชิญ",
    "team_members": "สมาชิกทีม",
    "daysLeft": "วันที่เหลือ",
    "regionNameLiveBetter": "สถานะ",
    "locationNameLiveBetter": "สถานที่ทำงาน",
    "departmentNameLiveBetter": "หน่วยธุรกิจ",
    "regionLabelLiveBetter": "เลือกรัฐ",
    "locationLabelLiveBetter": "เลือกสถานที่ทำงาน",
    "departmentLabelLiveBetter": "เลือกหน่วยธุรกิจ",
    "companyLocation": "สถานที่ทำงาน",
    "no_location": "ไม่มีตำแหน่ง",
    "connect": "เชื่อมต่อ",
    "syncing": "กำลังซิงค์",
    "sync": "ซิงค์",
    "havent_tracked_in_a_while": "ไม่มีกิจกรรมที่ติดตามล่าสุด",
    "contact": "การติดต่อ",
    "manage": "จัดการ",
    "creator": "ผู้สร้าง",
    "allow_notifications": "จัดการการแจ้งเตือน",
    "enable_notifications": "เปิดการแจ้งเตือน",
    "appload": "รอสักครู่ขณะอัปเดต {app_name}...",
    "sendResetEmail": "ส่งอีเมลรีเซ็ต",
    "min": "ต่ำสุด",
    "max": "สูงสุด",
    "error_joining_team": "ไม่สามารถเข้าร่วมทีมได้",
    "cannot_add_to_team": "ขออภัย… เกิดข้อผิดพลาดบางอย่างเมื่อเราพยายามเพิ่มคุณในทีมนี้ อาจเป็นไปได้ว่าทีมมีสมาชิกถึงจำนวนสูงสุดแล้วหรือไม่มีอยู่แล้ว หากมีข้อผิดพลาดอื่นเกิดขึ้นอีก กรุณาลองอีกครั้ง",
    "members_needed": "ต้องการสมาชิก %{num} คน",
    "member_needed": "ต้องการสมาชิก %{num} คน",
    "spots_left": "เหลือ %{num} สปอต",
    "join": "เข้าร่วม",
    "no_teams_create": "ขณะนี้ไม่มีทีมใด ๆ ให้คุณเข้าร่วม ทำไมคุณไม่สร้างขึ้นมาล่ะ?",
    "number_teams": "%{num} ทีม",
    "youLowercase": "คุณ",
    "joined_challenge_on_team": "คุณได้เข้าร่วมชาเลนจ์ในทีม %{team_name}",
    "join_team": "เข้าร่วมทีม",
    "former_members": "สมาชิกคนก่อน",
    "letsGo": "ไปกันเลย",
    "invite_to_team": "เชิญเข้าทีม",
    "connectingDeviceToast": {
        "success": {
            "title": "เชื่อมต่อแอปหรืออุปกรณ์",
            "message": "สำเร็จ! แอปหรืออุปกรณ์ของคุณเชื่อมต่อแล้ว"
        },
        "danger": {
            "title": "เชื่อมต่อแอปหรืออุปกรณ์",
            "message": "ขออภัย… เราพบปัญหาในการเชื่อมต่อบริการนี้ กรุณาลองอีกครั้ง"
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "ยกเลิกการเชื่อมต่อแอปหรืออุปกรณ์",
            "message": "คุณยกเลิกการเชื่อมต่อ %{name} สำเร็จแล้ว"
        },
        "danger": {
            "title": "ยกเลิกการเชื่อมต่อแอปหรืออุปกรณ์",
            "message": "ขออภัย... เรามีปัญหาในการยกเลิกการเชื่อมต่อ %{name} กรุณาลองอีกครั้ง"
        }
    },
    "leave_entity_question": "ออกจาก %{name}?",
    "delete_entity_question": "ลบ %{name}?",
    "leave_team_challenge_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการออกจาก %{name} ในชาเลนจ์นี้",
    "leave_last_team_member": "ในฐานะสมาชิกคนสุดท้ายของทีม การออกจากชาเลนจ์นี้จะเป็นการลบทีม",
    "oops_msg": "ขออภัย... เกิดข้อผิดพลาดขณะพยายามดำเนินการนี้ให้เสร็จสมบูรณ์ กรุณาลองอีกครั้ง",
    "has_been_created": "คุณได้เข้าร่วมชาเลนจ์ในทีม %{name}",
    "specify_team_name": "กรุณาระบุชื่อทีม",
    "invite_members": "เชิญสมาชิก",
    "upload_photo_no_question": "เพิ่มภาพถ่าย",
    "my_progress": "ความคืบหน้าของฉัน",
    "rewardsPointsAdditionalInfo": "รับ %{reward_currency} สำหรับทุก ๆ ระดับที่ไปถึง %{period} %{customPoints} และระดับของคุณเริ่มต้นใหม่ทุก ๆ %{period} ดังนั้นคุณจึงมีโอกาสได้รับ %{reward_currency} ต่อไป แม้ว่าคุณจะไปถึงระดับสูงสุดในช่วงที่แล้วก็ตาม",
    "rewardsPointsInfo": "%{customPoints} และความคืบหน้าจะรีเซ็ตในแต่ละ %{period}",
    "departments": "แผนก",
    "regions": "ภูมิภาค",
    "noItemsSelected": "ไม่ได้เลือกรายการ",
    "pleaseSelectOne": "กรุณาเลือกอย่างน้อยหนึ่งรายการจากรายชื่อ",
    "tracked": "ติดตามแล้ว",
    "starts": "เริ่ม",
    "duration": "ระยะเวลา",
    "bonus": "โบนัส",
    "invited_by": "เชิญโดย",
    "create_team": "สร้างทีม",
    "discardConfirmation": "คุณแน่ใจหรือไม่ว่าต้องการออก?",
    "discardYes": "ใช่",
    "discardStay": "ย้อนกลับ",
    "create_team_toast_title": "สร้างทีม",
    "edit_team": "แก้ไขทีม",
    "team_edits_submitted": "ทีมของคุณได้รับการอัปเดตแล้ว",
    "challenge_ended_still_trackable": "%{type} นี้สิ้นสุดแล้ว นับว่าโชคดีที่คุณเหลืออีก %{num} วันในการติดตาม!",
    "tracking_period_ended": "ระยะเวลาการติดตามสำหรับ %{type} นี้สิ้นสุดลงแล้ว",
    "unlimited": "ไม่จำกัด",
    "ends_in": "สิ้นสุดใน",
    "challenge_toast": {
        "success": {
            "join": "สำเร็จ!",
            "message": "คุณเข้าร่วมชาเลนจ์สำเร็จแล้ว"
        },
        "danger": {
            "error": "ข้อผิดพลาด",
            "message": "เกิดข้อผิดพลาด ลองเข้าร่วมชาเลนจ์อีกครั้งในอีกสักครู่"
        }
    },
    "members_to_invite": "สมาชิกที่เชิญ",
    "members_to_remove": "สมาชิกที่ลบ",
    "myChallenges": "การแข่งขัน",
    "upcoming": "ที่กำลังจะมาถึง",
    "myPersonalGoals": "เป้าหมาย",
    "companyCompetitions": "การแข่งขันบริษัท",
    "communityCompetitions": "การแข่งขันชุมชน",
    "edit_your_team": "แก้ไขทีมของคุณ",
    "emails": "อีเมล",
    "CompletedOverall": "ภาพรวมที่เสร็จสมบูรณ์",
    "TotalEarned": "ได้รับทั้งหมด",
    "notify_header": "ฉันต้องการรับการแจ้งเตือน:",
    "AdditionalBonus": "โบนัสเพิ่มเติม",
    "goalEndedNotification": "เป้าหมายสิ้นสุดแล้ว ผลักดันตัวเองต่อไป!",
    "compEndedNotification": "การแข่งขันสิ้นสุดแล้ว ผลักดันตัวเองต่อไป!",
    "congrats_tracking_first": "ขอแสดงความยินดีกับการติดตามกิจกรรมแรกของคุณ!",
    "keep_tracking": "ติดตามกิจกรรมของคุณเพื่อบรรลุเป้าหมายและเพิ่มระดับ",
    "understanding_tracking": "ทำความเข้าใจการติดตาม",
    "cannot_track_this_day": "คุณไม่สามารถติดตามได้ในวันนี้",
    "nothing_tracked_this_day": "คุณยังไม่ได้ติดตามวันนี้",
    "tracked_something_this_day": "คุณได้ติดตามบางสิ่งบางอย่างสำหรับวันนี้",
    "reached_goal_this_day": "คุณบรรลุเป้าหมายสำหรับวันนี้แล้ว (สำหรับเป้าหมายรายวันเท่านั้น)",
    "got_it": "เข้าใจแล้ว!",
    "notDismissedMultiTitle": "สรุปชาเลนจ์",
    "notDismissedMultiSubtitle": "ชาเลนจ์บางชาเลนจ์ได้สิ้นสุดลงแล้ว ดูรายละเอียดในแต่ละส่วนเพื่อดูว่าคุณทำอย่างไร ",
    "daySummary": "%{userName} นี่คือสรุปของวันนี้ของคุณ",
    "goals": "เป้าหมาย",
    "competitions": "การแข่งขัน",
    "totalAccumulated": "สะสมทั้งหมด",
    "tracking_for_date": "การติดตามสำหรับ %{date}",
    "activity_tracker_instruction": "แตะเพื่อแก้ไขหรือลบกิจกรรมที่ติดตามด้วยตนเอง",
    "ended": "สิ้นสุด",
    "notYetAvailableBeta": "ยังไม่มีให้บริการในรุ่นเบต้า",
    "suggestedGoal": "เป้าหมายที่แนะนำ",
    "singleFor": "สำหรับ",
    "seeLessLongComment": "ดูน้อยลง",
    "synced_data": "ข้อมูลที่ซิงค์:",
    "doThisLater": "ฉันจะทำในภายหลัง",
    "inviteUsers": "เชิญคนอื่นเข้าร่วม",
    "cannotTrackAfterDeadline": "คุณกำลังพยายามติดตามกิจกรรมสำหรับวันที่หลังจากเดดไลน์ชาเลนจ์",
    "potentialBonusPoints": {
        "section": {
            "title": "โบนัส %{potentialBonusPoints} %{customPoints} พร้อมสำหรับเป้าหมายนี้!",
            "titleNotCompleted": "คุณพลาดโบนัส %{potentialBonusPoints} %{customPoints} โดย %{activitytCompletedPercentage}%",
            "titleCompleted": "ขอแสดงความยินดี! คุณได้รับ",
            "titleCompletedBold": "โบนัส %{potentialBonusPoints} %{customPoints}!",
            "subtitle": "เรียนรู้เพิ่มเติมเกี่ยวกับโบนัส %{customPoints}"
        },
        "modal": {
            "title": "โบนัส %{customPoints}",
            "desc1": "เรารู้ว่าไม่มีใครสมบูรณ์แบบและไม่สามารถบรรลุเป้าหมายได้ 100% ตลอดเวลา",
            "desc2": "นั่นจึงเป็นเหตุผลที่เราให้โบนัส %{customPoints} เมื่อความคืบหน้าโดยรวมของคุณคือ 85% หรือสูงกว่า",
            "desc3": "โบนัส %{customPoints} ทั้งหมดจะมอบให้หลังจากเป้าหมายสิ้นสุดลง และหากการติดตามทั้งหมดของคุณมาจากแอปหรืออุปกรณ์ที่เชื่อมต่อ คุณจะได้รับโบนัสสองเท่า %{customPoints}!",
            "desc4": "คุณจะไม่ได้รับโบนัส %{customPoints} สำหรับเป้าหมายที่คุณออกก่อนกำหนด"
        },
        "msg": {
            "title": "เป้าหมายนี้สิ้นสุดแล้ว",
            "subtitle": "เป้าหมายสิ้นสุดแล้วเมื่อ %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "หมดเวลา! เป้าหมายของคุณสิ้นสุดแล้ว",
            "subtitle": "คุณมีเวลา %{daysNum} %{daysOrDay} ในการติดตามกิจกรรม"
        }
    },
    "finish": "เสร็จสิ้น",
    "personalGoal": {
        "all_goals": {
            "selected": "กำหนดเป้าหมาย %{maxGoals} ทั้งหมดแล้ว!",
            "description": "นี้เป็นที่ชื่นชอบของคุณหรือไม่? คุณสามารถเปลี่ยนเป้าหมายใด ๆ ได้หากคุณเปลี่ยนใจ ไม่ต้องกังวล คุณจะสามารถยกเลิกการกำหนดเป้าหมายได้ในภายหลัง",
            "set": "กำหนดเป้าหมายทั้งหมดแล้ว!",
            "action": "พร้อมแล้ว ลุยได้เลย!",
            "error": "อย่าหลงทาง! การมุ่งเน้นเป้าหมายที่มีโครงสร้างไม่เกิน 3 เป้าหมายในแต่ละครั้งจะเพิ่มโอกาสที่คุณจะประสบความสำเร็จ",
            "errorHeading": "การกำหนดเป้าหมาย"
        },
        "set_more": "คุณสามารถกำหนด %{maxGoals} ให้เป็นเป้าหมายที่แอกทีฟมากขึ้น",
        "select_goal": {
            "heading": "กำหนดเป้าหมายที่แนะนำหรือสร้างของคุณเอง"
        },
        "set_more_1": "คุณสามารถตั้งเป้าหมายแอกทีฟได้อีก 1 เป้าหมาย"
    },
    "restartPersonalGoal": "รีสตาร์ทเป้าหมายด้วยเป้าหมายใหม่",
    "delete_challenge_confirmation": "คุณแน่ใจหรือไม่ว่าต้องการลบชาเลนจ์นี้?",
    "personal_goal_unit": "เป้าหมาย",
    "personal_goal_units": "เป้าหมาย",
    "day_summary": {
        "steps_taken": "จำนวนก้าวที่เดิน",
        "calories_in": "แคลอรี่เข้า",
        "calories_out": "แคลอรี่ออก",
        "avg_daily": "เฉลี่ยรายวัน",
        "most_earned_daily": "ได้รับมากที่สุดต่อวัน"
    },
    "invitedBy": "เชิญโดย %{person}",
    "resetPasswordMissingField": "กรุณากรอกอีเมล",
    "resetPasswordInvalidValue": "กรุณาป้อนอีเมลที่ถูกต้อง",
    "resetPasswordNotFound": "ไม่พบอีเมลของคุณ",
    "resetPasswordNotCompleted": "คำขอของคุณไม่เสร็จสมบูรณ์",
    "resetGoalInstructions": {
        "start": "ทำ %{quantity} %{units} จาก %{activity}",
        "additional": "%{quantity} %{units} จาก %{activity}",
        "end": "%{frequency} และรับ %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "กำหนดเป้าหมายหนึ่งเป้าหมายแล้ว ดู",
        "two": "กำหนดเป้าหมายสองเป้าหมายแล้ว ดู",
        "three": "กำหนดเป้าหมายสามเป้าหมายแล้ว ดู",
        "none": "ไม่ได้กำหนดเป้าหมาย กำหนดเป้าหมาย"
    },
    "searchCommunitiesEmpty": "ไม่พบชุมชน",
    "searchCommunitiesPlaceholder": "ค้นหาชุมชน",
    "updating": "กำลังอัปเดต...",
    "pts_tracked": "%{activityName} ที่ติดตาม - %{num} %{customPoints}",
    "improving_wellbeing_score": "ดีแล้วทำต่อไป คุณกำลังอยู่ในเส้นทางที่จะปรับปรุงคะแนนสุขภาพของคุณ",
    "progressHistory": "ประวัติความคืบหน้า",
    "privateCommunity": "นี่คือชุมชนส่วนตัว",
    "do_combo_of_activities": "ทำการผสมผสานใด ๆ ดังต่อไปนี้",
    "noActivitiesTracked": "ไม่มีกิจกรรมที่ติดตาม",
    "trackingWithFollowingApps": "กำลังติดตามด้วยแอป\/อุปกรณ์ต่อไปนี้",
    "recommendedApps": "แอป\/อุปกรณ์ที่แนะนำสำหรับ %{challengeType} นี้",
    "collapseWord": "ยุบ",
    "started": "เริ่มแล้ว",
    "ends": "สิ้นสุด ",
    "do_activities": "ทำกิจกรรม",
    "rewards_placeholder": "ตัวอย่างรางวัลจากร้านค้า ข้อความตัวอย่าง ผู้ใช้จะเห็นผลิตภัณฑ์ต่าง ๆ ที่พวกเขาสามารถซื้อได้และค่าใช้จ่ายใน %{rewardName}",
    "personalGoals": {
        "top": {
            "label": "สูงสุด"
        },
        "allGoals": "เป้าหมายทั้งหมด",
        "seeMoreCard": {
            "heading": "ไม่เห็นสิ่งที่คุณกำลังมองหาใช่หรือไม่?",
            "description": "ดูเป้าหมายที่แนะนำทั้งหมด",
            "button": "สำรวจเป้าหมาย"
        }
    },
    "rewardsNotAvailable": "ขณะนี้รางวัลยังไม่มีให้บริการในรุ่นเบต้านี้ เมื่อมีให้บริการ คุณจะสามารถดูแค็ตตาล็อกและแลกของรางวัลได้",
    "editProfileProvideRestingHeartRate": "กรุณาระบุค่าอัตราการเต้นของหัวใจขณะพักที่ถูกต้องอย่างน้อย 40",
    "liveBetterHealthInfo": "เราดำเนินโครงการมากมายและมีเนื้อหาด้านสุขภาพที่หลากหลายซึ่งออกแบบมาเพื่อรองรับความต้องการด้านสุขภาพที่หลากหลายและช่วยให้คุณมีสุขภาพที่ดีขึ้น เรายังไม่มีแผนงานสำหรับภาวะสุขภาพและความต้องการ โดยเรากำลังดำเนินการแก้ไขในส่วนนี้ อย่างไรก็ตาม หากคุณตอบคำถามต่อไปนี้ เราจะติดต่อคุณหากเราระบุโปรแกรมหรือบริการด้านสุขภาพที่คุณอาจได้รับประโยชน์จากการเข้าร่วม และ\/หรือส่งข้อมูลตามหลักฐานที่จะช่วยให้คุณเข้าใจและจัดการความต้องการด้านสุขภาพของคุณได้ดียิ่งขึ้น โปรดทราบว่าเราจะไม่ใช้ข้อมูลนี้เพื่อประเมินความเหมาะสมของนโยบายของคุณ หากคุณต้องการค้นหาสิ่งที่คุณได้รับการคุ้มครองหรือมีข้อสงสัยใด ๆ เกี่ยวกับนโยบายของคุณ คุณสามารถโทรติดต่อทีม Customer Connect ของเราได้ที่ 132 331",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "คุณได้ลบเป้าหมายแล้ว"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "คุณได้ลบชาเลนจ์แล้ว"
        }
    },
    "invitations": "คำเชิญ",
    "learnMorePeriods": "เรียนรู้เพิ่มเติมเกี่ยวกับระยะเวลา",
    "tracked_by_app_name": "ติดตามโดย %{app_name}",
    "device_required": {
        "text": "%{challengeType} นี้ต้องใช้แอปหรืออุปกรณ์",
        "button": "เชื่อมต่อแอปหรืออุปกรณ์"
    },
    "editingCommunityToast": {
        "success": {
            "title": "แก้ไขชุมชน",
            "message": "ชุมชนได้รับการแก้ไข"
        }
    },
    "competition": "การแข่งขัน",
    "close": "ปิด",
    "only_automatic_activities_with_device": "กิจกรรมของ %{goal_or_competition} นี้จะถูกติดตามโดยอัตโนมัติด้วยแอป\/อุปกรณ์ที่เชื่อมต่อของคุณ",
    "only_automatic_activity_with_device": "กิจกรรมของ %{goal_or_competition} นี้จะถูกติดตามโดยอัตโนมัติด้วยแอป\/อุปกรณ์ที่เชื่อมต่อของคุณ",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "ลบชุมชนแล้ว"
        }
    },
    "teamSizeMessage": "ทีมของคุณต้องการคนอย่างน้อย %{min} คนเพื่อรับ %{customPoints} สำหรับชาเลนจ์",
    "captain": "กัปตัน",
    "inviteOthersToTeam": "เชิญผู้อื่นเข้าร่วมทีมของฉัน",
    "loadingMetrics": "กำลังเชื่อมต่อกับแหล่งที่มาเพื่ออัปเดตวันของคุณ...",
    "aboutTeamSize": {
        "title": "ขนาดทีม",
        "text": "%{min} ถึง %{max}"
    },
    "pointsOverview": "ภาพรวม %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "คำขอของคุณไม่เสร็จสมบูรณ์",
        "error": "ข้อผิดพลาด"
    },
    "required_lc": "จำเป็น",
    "personal": "รายละเอียดส่วนบุคคล",
    "biometrics": "ไบโอเมตริกซ์",
    "makeSelection": "ทำการเลือก",
    "ask_question_success_msg": "ขอบคุณ เราจะตอบโดยเร็วที่สุด",
    "report_issue_success_msg": "ขอบคุณ เราจะตอบโดยเร็วที่สุด",
    "ask_question_success_title": "ส่งคำถามแล้ว",
    "report_issue_success_title": "ส่งปัญหาทางเทคนิคแล้ว",
    "ask_question_failure_msg": "น่าเสียดาย! เกิดข้อผิดพลาดในการส่งคำถามของคุณ กรุณาลองอีกครั้ง",
    "report_issue_failure_msg": "น่าเสียดาย! เกิดข้อผิดพลาดในการรายงานปัญหาของคุณ กรุณาลองอีกครั้ง",
    "notTrackedActivities": "คุณไม่ได้ติดตามกิจกรรมใด ๆ สำหรับระยะเวลานี้",
    "learn": "เรียนรู้",
    "Balance": "ยอดเงิน",
    "details": "รายละเอียด",
    "Reward": "รางวัล",
    "levelsReset": "ระดับจะรีเซ็ตใน %{remainingDays} วัน",
    "redeem": "แลกรางวัล",
    "redeemAt": "แลกรางวัลที่ %{points}",
    "needPointsToRedeem": "คุณต้องการอีก %{points} คะแนน %{rewardName}",
    "learnEarnMore": "เรียนรู้วิธีรับเพิ่มเติม",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "เข้าร่วมทีม",
            "message": "คุณเข้าร่วมทีมสำเร็จแล้ว!"
        },
        "danger": {
            "message": "เราพบข้อผิดพลาดและไม่พบทีม อาจจะไม่มีอยู่แล้ว"
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "ไม่มีการดำเนินการ",
            "message": "ไม่สามารถดำเนินการตามคำขอของคุณได้"
        }
    },
    "transactionLog": "การทำธุรกรรม",
    "orderHistory": "ลำดับ",
    "pointsAvailableToEarn": "%{points} สามารถรับได้",
    "missedYTD": "%{missed} ที่พลาดไปตั้งแต่ต้นปีจนถึงปัจจุบัน",
    "rewardsDetails": "รางวัล",
    "successfullyRedeemedItem": "คุณได้แลกรายการนี้สำเร็จแล้ว",
    "orderNumber": "หมายเลขคำสั่งซื้อ",
    "amountSpent": "ยอดเงินที่ใช้จ่าย",
    "status": "สถานะ",
    "dateRedeemed": "วันที่แลกรางวัล",
    "additionalInformation": "ข้อมูลเพิ่มเติม",
    "shipToAddress": "จัดส่งตามที่อยู่นี้",
    "pointMissedYearToDate": "%{rewardCurrencyName} ที่พลาดในปีนี้",
    "pointMissedYearToDateDescription": "เมื่อคุณไม่ได้บรรลุระดับก่อนที่ระยะเวลาจะสิ้นสุด จะถือว่าคุณพลาด %{rewardCurrencyName} ที่เกี่ยวข้อง",
    "NoLibraryContentToast": {
        "info": {
            "title": "ไม่พบบทความ",
            "message": "ไม่สามารถค้นหาบทความ อาจถูกลบออกหรือไม่สามารถใช้ได้อีกต่อไป"
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "ไม่พบชุมชน",
            "message": "ไม่สามารถค้นหาชุมชน อาจถูกลบออกหรือไม่สามารถใช้ได้อีกต่อไป"
        }
    },
    "shippingAddress": "ที่อยู่การจัดส่ง\/การเรียกเก็บเงิน",
    "enterShippingAddress": "กรอกที่อยู่การจัดส่ง\/การเรียกเก็บเงินของคุณ",
    "streetLine": "ถนน %{num}",
    "stateProvince": "รัฐ\/จังหวัด",
    "postcodePostalcodeZip": "รหัสไปรษณีย์",
    "phoneNumber": "หมายเลขโทรศัพท์",
    "order": "ลำดับ",
    "redemptionConfirmation": "การยืนยันการแลก",
    "edit": "แก้ไข",
    "processing": "กำลังดำเนินการ",
    "checkIsYouFirst": "เราแค่ต้องตรวจสอบก่อนว่าใช่คุณหรือไม่",
    "discardSomeGoals": "คุณได้กำหนดเป้าหมายบางอย่าง เป้าหมายเหล่านี้จะถูกยกเลิก หากคุณดำเนินการต่อ",
    "settingGoalsToast": {
        "success": {
            "message": "กำหนดเป้าหมายใหม่ของคุณแล้ว!"
        }
    },
    "one_team": "1 ทีม",
    "noAchievementsToEarnMessage": "ดูเหมือนว่าไม่มีเหรียญตราอีกต่อไปที่จะได้รับ %{rewardCurrencyName} ในระยะเวลานี้",
    "shopRewards": "รางวัลร้านค้า",
    "validateShippingAddressToast": {
        "danger": {
            "title": "ที่อยู่การจัดส่ง\/การเรียกเก็บเงิน",
            "message": "กรุณากรอกข้อมูลให้ครบทุกช่องก่อนดำเนินการต่อ"
        }
    },
    "viewDetails": "ดูรายละเอียด",
    "potential": "ศักยภาพ",
    "missed": "ไม่ได้รับ",
    "rewardsStoreNotAvailable": "ร้านค้ารางวัลไม่พร้อมให้บริการสำหรับคุณในขณะนั้น",
    "havent_tracked_in_a_while_date": "ไม่มีกิจกรรมที่ติดตามสำหรับ %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "ไม่พบชาเลนจ์",
            "message": "ไม่สามารถค้นหาชาเลนจ์ อาจถูกลบออกหรือไม่สามารถใช้ได้อีกต่อไป"
        }
    },
    "shareYourDaySubtitleActivity": "เพิ่มรูปภาพหรือพูดอะไรเกี่ยวกับกิจกรรมนี้!",
    "goal_ended": "เป้าหมายสิ้นสุดแล้ว",
    "challenge_ended": "ชาเลนจ์สิ้นสุดแล้ว",
    "day_remaining_to_track": "คุณมีเวลา 1 วันในการติดตามกิจกรรมใด ๆ ที่พลาดไป",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} สิ้นสุดแล้วเมื่อ %{endDate}",
    "goalEndedModal": {
        "title": "ติดตามกิจกรรมที่ถูกลืม",
        "message": "หลังจากเป้าหมายส่วนบุคคลหรือชาเลนจ์สิ้นสุดลง คุณมีเวลาสามวันนับจากวันที่สิ้นสุดในการติดตามกิจกรรมที่คุณอาจลืมไป หลังจากช่วงเวลาผ่อนผันนี้ คุณจะไม่สามารถติดตามกิจกรรมเพิ่มเติมใด ๆ ที่นำไปสู่เป้าหมายหรือชาเลนจ์ได้"
    },
    "summary": "สรุป",
    "placedRank": "คุณอยู่ในตำแหน่ง %{rank} จาก %{total}",
    "rank": {
        "first": "อันดับ 1",
        "second": "อันดับ 2",
        "third": "อันดับ 3",
        "n": "อันดับ %{rank}"
    },
    "event_name": "ชื่ออีเวนต์",
    "this_is": "นี่คือ  ",
    "location_info": "ตำแหน่งและข้อมูล",
    "what_event": "อีเวนต์นี้เกี่ยวกับอะไร",
    "event_is": "อีเวนต์นี้คือ",
    "start_on": "เริ่มต้นเมื่อ:",
    "end_on": "สิ้นสุดเมื่อ:",
    "location": "ตำแหน่ง",
    "chooseLeaderboard": "เลือกกระดานผู้นำ",
    "filterOneOfFollowing": "กรองอย่างใดอย่างหนึ่งต่อไปนี้",
    "showChallengeInstead": "แสดงชาเลนจ์แทน",
    "showActivityInstead": "แสดงกิจกรรมแทน",
    "showAll": "แสดงทั้งหมด",
    "activitiesShowSame": "กิจกรรม: %{activityName}",
    "challengeShowSame": "ชาเลนจ์: %{challengeName}",
    "chooseTimePeriod": "เลือกระยะเวลา",
    "youCanFilterOneAtTime": "สามารถเลือกตัวกรองได้ครั้งละหนึ่งตัวกรอง",
    "saveHealthTopicsToast": {
        "success": {
            "message": "บันทึกหัวข้อสุขภาพแล้ว",
            "title": "สำเร็จ!"
        },
        "info": {
            "message": "ไม่สามารถบันทึก"
        },
        "danger": {
            "title": "ข้อผิดพลาด!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "บันทึกวัตถุประสงค์สุขภาพแล้ว",
            "title": "สำเร็จ!"
        },
        "info": {
            "message": "ไม่สามารถบันทึก"
        },
        "danger": {
            "title": "ข้อผิดพลาด!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "บันทึกความสนใจแล้ว",
            "title": "สำเร็จ!"
        },
        "info": {
            "message": "ไม่สามารถบันทึก"
        },
        "danger": {
            "title": "ข้อผิดพลาด!"
        }
    },
    "edit_event": "แก้ไขอีเวนต์",
    "leave": "ออก",
    "delete_event": "ลบอีเวนต์",
    "no_events": "ไม่มีอีเวนต์",
    "no_events_placeholder": "ขณะนี้คุณไม่ได้วางแผนที่จะเข้าร่วมกิจกรรมใด ๆ ในอนาคต ทำไมคุณไม่เข้าร่วมสักหนึ่งอีเวนต์ล่ะ?",
    "event": "อีเวนต์  ",
    "challenge": "ชาเลนจ์",
    "invited_you": "เชิญคุณแล้ว",
    "public": "สาธารณะ",
    "private": "ส่วนตัว",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "ลบอีเวนต์สำเร็จ"
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "คุณออกจากอีเวนต์แล้ว"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "อัปเดตอีเวนต์สำเร็จ"
        }
    },
    "createEventToast": {
        "success": {
            "message": "สร้างอีเวนต์สำเร็จ",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "เนื้อหาที่คุณกำลังพยายามดูไม่สามารถใช้งานได้ ผู้เขียนอาจลบหรือทำเครื่องหมายว่าไม่เหมาะสม",
    "start_time": "เวลาเริ่มต้น",
    "end_time": "เวลาสิ้นสุด",
    "event_type": "อีเวนต์ %{eventType}",
    "leave_event_modal": {
        "title": "หากคุณออกจากอีเวนต์",
        "message": "จะเป็นการลบ"
    },
    "leave_event ": "คุณแน่ใจหรือไม่ว่าต้องการออกจากอีเวนต์นี้?",
    "create_event": "สร้างอีเวนต์",
    "created_by": "สร้างโดย",
    "eventActionToast": {
        "danger": {
            "title": "ข้อผิดพลาด",
            "message": "เกิดข้อผิดพลาด "
        }
    },
    "continue": "ดำเนินการต่อ",
    "wantExitTour": "คุณแน่ใจหรือไม่ว่าต้องการออกจากทัวร์?",
    "exitTour": "ออกจากทัวร์",
    "deleveEventPopup": "คุณแน่ใจหรือไม่ว่าต้องการลบเหตุการณ์นี้?",
    "attendeesTitle": "ผู้เข้าร่วม",
    "userEvents": "อีเวนต์ของ %{name}",
    "createEventIndicator": "การสร้างอีเวนต์",
    "inviteToEvent": "เชิญไปยังอีเวนต์",
    "noDescription": "ไม่มีคำอธิบาย",
    "leaderboardIsEmpty": "กระดานผู้นำนี้ว่างเปล่าหรือคุณอาจต้องติดตามกิจกรรมภายในระยะเวลาที่เลือกเพื่อดู",
    "notParticipantingInAnyChallenges": "คุณไม่ได้เข้าร่วมในการชาเลนจ์ใด ๆ",
    "buttonLeaveEvent": "ออกจากอีเวนต์",
    "leaveEvent ": "ออกจาก %{name}?",
    "canceledCreatingChallenge": "การสร้าง %{challengeType} ถูกยกเลิกสำเร็จ",
    "swipeReadNotification": "อ่าน",
    "productTour": {
        "initialScreen": {
            "title": "ยินดีต้อนรับสู่ %{programName}!",
            "body": "มาทัวร์กัน และอีกสักครู่คุณจะเข้าใจพื้นฐาน"
        },
        "dashboard": {
            "title": "แดชบอร์ด",
            "body": "ดูจำนวน %{pointsName} ที่คุณมีและความคืบหน้าไปสู่ระดับต่าง ๆ จากนั้นตรวจสอบกระดานผู้นำเพื่อดูว่าคุณจัดกลุ่มได้อย่างไร"
        },
        "rewards": {
            "title": "รางวัล",
            "body": "ดูจำนวน %{rewardPointName} ที่คุณมีและแลกรางวัลในร้าน"
        },
        "goals": {
            "title": "เป้าหมายและชาเลนจ์",
            "body": "เป้าหมายแอกทีฟส่วนบุคคลของคุณ ชาเลนจ์กับผู้อื่น และงานพิเศษสามารถพบได้ที่นี่"
        },
        "explore": {
            "title": "สำรวจ",
            "body": "ค้นหาชาเลนจ์ร่วมกับผู้อื่น เข้าร่วมชุมชนเพื่ออภิปรายเกี่ยวกับความสนใจของคุณ และค้นหาบทความใหม่ในห้องสมุดด้านสุขภาพ"
        },
        "me": {
            "title": "ฉัน",
            "body": "ค้นหาคะแนนด้านสุขภาพของคุณ ตรวจสอบสถิติ และแก้ไขโปรไฟล์ รวมถึงการตั้งค่าของคุณที่นี่"
        },
        "finishScreen": {
            "title": "คุณพร้อมแล้ว",
            "body": "ขอขอบคุณสำหรับการทัวร์",
            "button": "มาเริ่มกันเลย"
        },
        "skip": {
            "title": "คุณแน่ใจหรือไม่ว่าต้องการข้ามการทัวร์?",
            "body": "การดำเนินการนี้จะสิ้นสุดทัวร์ และคุณสามารถเริ่มต้นได้ทันที"
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "การพิสูจน์ตัวตนล้มเหลว",
            "message": "ไม่สามารถดำเนินการแลกรางวัลได้ เกิดข้อผิดพลาดขณะตรวจสอบสิทธิ์กับผู้ให้บริการรางวัล"
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "การแลกรางวัลล้มเหลว",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "ก่อนคุณเริ่มต้น",
    "disclamerSectionMessage": "ตรวจสอบกับบุคลากรทางการแพทย์ของคุณก่อนเริ่มโปรแกรมการออกกำลังกายใหม่ใด ๆ หรือเปลี่ยนแปลงรูปแบบการใช้ชีวิตเพื่อให้แน่ใจว่าเหมาะสมกับคุณ",
    "noEarchedAchievements": "คุณยังไม่ได้รับความสำเร็จใด ๆ ติดตามกิจกรรมเพื่อเริ่มต้น",
    "noInProgressAchievements": "คุณไม่มีความสำเร็จที่กำลังดำเนินการอยู่",
    "discardCreatingEventMessage": "ตรวจสอบว่าได้กรอกช่องที่จำเป็นทั้งหมดแล้ว",
    "discardCreatingEventTitle": "ไม่สามารถสร้างอีเวนต์ได้",
    "discardEditedEventTitle": "ไม่สามารถแก้ไขอีเวนต์ได้",
    "errorEventNameMessage": "จำเป็นต้องกรอกชื่อ",
    "errorEventStartDateMessage": "จำเป็นต้องกรอกวันที่เริ่มต้น",
    "errorEventEndDateMessage": "จำเป็นต้องกรอกวันที่สิ้นสุด",
    "errorEventDateMessage": "วันที่สิ้นสุดต้องไม่มาก่อนวันที่เริ่มต้น",
    "noAccountsToLink": "ไม่มีบัญชีที่สามารถเชื่อมโยงกับ %{program_name}",
    "accountLinkEmailChanged": "อีเมลของคุณได้รับการอัปเดตแล้ว ต่อจากนี้ไป เข้าสู่ระบบด้วยบัญชีที่เชื่อมโยงของคุณ",
    "accountLinkSuccessful": "บัญชีของคุณเชื่อมโยงสำเร็จแล้ว",
    "edit_profile_nan_value": "ค่าต้องเป็นตัวเลข",
    "advancedLogIn": "เข้าสู่ระบบขั้นสูง",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "การแลกรางวัลล้มเหลว",
            "message": "เซสชันการสั่งซื้อหมดอายุแล้ว กรุณาลองวางคำสั่งซื้ออีกครั้ง"
        }
    },
    "left": "เหลือ",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "ดูเหมือนว่าไม่มีอีเวนต์ให้เข้าร่วมในขณะนี้ ทำไมคุณไม่สร้างขึ้นมาล่ะ?"
        }
    },
    "reachedHighestLevel": "คุณถึงระดับสูงสุดแล้ว!",
    "error": "ข้อผิดพลาด",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "การแลกรางวัล",
            "message": "ส่งคำสั่งซื้อของคุณแล้ว"
        }
    },
    "redeemRewardComplete": "การแลกเสร็จสมบูรณ์",
    "trackActivityTitle": {
        "oneUnit": "ติดตาม: 1 %{unit} ของ %{activity} ในวันที่ %{date}",
        "nUnit": "ติดตาม: %{activity} สำหรับ %{date}"
    },
    "ssoAuthenticationFailure": "การพิสูจน์ตัวตนล้มเหลว",
    "earnEvery": "รับทุก ๆ %{frequency}",
    "earnOnce": "รับครั้งเดียวเท่านั้น",
    "goalSettings": {
        "maximumSet": "ขณะนี้คุณมีเป้าหมายสูงสุด 3 เป้าหมาย",
        "learnMore": "เรียนรู้เพิ่มเติมเกี่ยวกับการกำหนดเป้าหมาย"
    },
    "allowMarketingComms": "ส่งการสื่อสารส่งเสริมการขายให้ฉัน",
    "allowPartnerMarketingComms": "ส่งการสื่อสารส่งเสริมการขายจากพันธมิตรให้ฉัน",
    "noUpcomingAchievements": "คุณไม่มีความสำเร็จที่จะเกิดขึ้น",
    "settingGoalToast": {
        "success": {
            "message": "กำหนดเป้าหมายใหม่ของคุณแล้ว!"
        }
    },
    "authentication": {
        "saml": {
            "error": "ไม่สามารถให้บริการได้ในขณะนี้",
            "signin": "การลงชื่อเข้าใช้แบบผสมผสาน",
            "signup": "การลงทะเบียนแบบผสมผสาน"
        }
    },
    "monthName": {
        "january": "มกราคม",
        "february": "กุมภาพันธ์",
        "march": "มีนาคม",
        "april": "เม.ย.",
        "may": "พ.ค.",
        "june": "มิ.ย.",
        "july": "ก.ค.",
        "august": "สิงหาคม",
        "september": "กันยายน",
        "october": "ตุลาคม",
        "november": "พฤศจิกายน",
        "december": "ธันวาคม"
    },
    "promotedForMe": "คุณสมบัติ",
    "appRating": {
        "enjoying": "เพลิดเพลินกับแอปของเรา?",
        "feedback": "คุณต้องการให้ข้อเสนอแนะหรือไม่?",
        "appStore": "ให้คะแนนเราใน App Store?",
        "googlePlay": "ให้คะแนนเราใน Google Play?",
        "notReally": "ไม่เชิง",
        "yes": "ใช่!",
        "sure": "ได้สิ",
        "noThanks": "ไม่ ขอบคุณ",
        "notNow": "ไม่ใช่ตอนนี้"
    },
    "getMobileApp": "ในการใช้ %{programName} บนสมาร์ทโฟนของคุณ ให้ดาวน์โหลด %{appStoreName} จาก App Store หรือ Google Play",
    "newAppsDevicesDesign": {
        "getMobileApp": "ดาวน์โหลดแอป %{programName}",
        "searchInAppStore": "ค้นหา %{programName} ใน App Store ของอุปกรณ์",
        "getMobileAppNoName": "รับแอปมือถือ"
    },
    "editorAlert": {
        "discardChanges": "ละทิ้งการเปลี่ยนแปลง",
        "saveAndContinue": "บันทึกและดำเนินการต่อ",
        "title": "การเปลี่ยนแปลงที่ไม่ได้บันทึก",
        "text": "คุณได้ทำการเปลี่ยนแปลงบางอย่างที่ยังไม่ได้บันทึก คุณประสงค์จะทำอะไร?"
    },
    "resources": "แหล่งข้อมูล",
    "noResources": "ไม่มีแหล่งข้อมูล",
    "viewAllResources": "ดูแหล่งข้อมูลทั้งหมด",
    "language": "ภาษา",
    "eventStarted": "อีเวนต์เริ่มต้นแล้ว ปิดรับลงทะเบียนแล้ว",
    "Gender": "เพศ",
    "show": "แสดง",
    "hide": "ซ่อน",
    "timeoutError": "ขออภัย! บางอย่างใช้เวลานานเกินไป กรุณาลองอีกครั้งในภายหลัง",
    "SOT": {
        "sample_task": "งานตัวอย่าง"
    },
    "cache": {
        "new_version": "มีเวอร์ชันใหม่แล้ว!",
        "refresh_browser": "คลิกที่นี่เพื่อรีเฟรชเบราว์เซอร์ของคุณ"
    },
    "welcomeUser": "ยินดีต้อนรับ %{userFirstName}!",
    "quarter": "ไตรมาส",
    "completionReward": "รางวัลความสำเร็จ",
    "bronzeLevel": "ระดับบรอนซ์",
    "deviceAppSyncingOk": "การซิงค์อุปกรณ์\/แอปใช้ได้",
    "deviceAppSyncingIssue": "ปัญหาการซิงค์อุปกรณ์\/แอป",
    "deviceAppSyncingError": "ข้อผิดพลาดการซิงค์อุปกรณ์\/แอป",
    "lastSync": "ซิงค์ล่าสุด",
    "period": "ระยะเวลา",
    "yourDaySummary": "วันของคุณจนถึงตอนนี้",
    "steps": "ก้าว",
    "gender_non_binary": "ไม่เป็นไปตามข้อกำหนด",
    "take_survey": "ทำแบบสำรวจ",
    "social": "สังคม",
    "finalDay": "วันสุดท้าย",
    "leaderboard_position": "ตำแหน่งกระดานผู้นำ",
    "signUp": {
        "apple": {
            "disconnectSettings": "ยกเลิกการเชื่อมต่อ %{appName} จาก 'รหัสผ่านและการรักษาควาปลอดภัย Apple ID' ในการตั้งค่าโทรศัพท์เพื่อดำเนินการลงทะเบียนต่อไป"
        }
    },
    "earnPoints": "รับ %{customPoints} เลื่อนระดับ",
    "getReward": "ได้รับ %{rewardName}",
    "buildHealthyHabits": "สร้างนิสัยที่ดีต่อสุขภาพ",
    "highestLevelIndicator": "คุณถึงระดับสูงสุดแล้ว!",
    "highestLevelIndicatorNew": "คุณทำสำเร็จทุกระดับแล้ว!",
    "trackYourActivity": "หากต้องการรับ %{customPoints} ให้ติดตามการออกกำลังกายและกิจกรรมเพื่อสุขภาพของคุณ",
    "levelUpToGetRewarded": "เมื่อระดับคุณเพิ่มขึ้น คุณจะได้รับรางวัล %{rewardName}",
    "levelUpAndEarn": "ความคืบหน้าของคุณจะรีเซ็ตทุก ๆ %{period} ดังนั้นคุณจึงสามารถเลื่อนระดับและรับรางวัลได้หลายรอบ",
    "levelUp": "ความคืบหน้าของคุณจะรีเซ็ตทุก ๆ %{period} ดังนั้นคุณจึงสามารถเลื่อนระดับได้หลายรอบ",
    "goToLibrary": "ไปที่ไลบรารี่",
    "updateEventIndicator": "การอัปเดตอีเวนต์",
    "meTour": {
        "healthSurveyDisabled": "ตรวจสอบสถิติ และแก้ไขโปรไฟล์ รวมถึงการตั้งค่าของคุณที่นี่"
    },
    "createNewGoal": "สร้างเป้าหมายใหม่",
    "later": "ภายหลัง",
    "bonusChallenge": "ชาเลนจ์โบนัส",
    "bonusChallengeInfo": {
        "withReward": "คุณจะได้รับ %{amount} โบนัส %{points} เมื่อทำสำเร็จอย่างน้อย 85% ของ %{challengeType} นี้",
        "noReward": "คุณจะได้รับโบนัสเมื่อทำชาเลนจ์นี้เสร็จสมบูรณ์อย่างน้อย 85%",
        "boldText": "%{amount} โบนัส %{points}",
        "noRewardChallengeType": "คุณจะได้รับโบนัสเมื่อทำชาเลนจ์นี้เสร็จสมบูรณ์อย่างน้อย 85% %{challengeType}"
    },
    "defaultApp": "แอปสุขภาพเริ่มต้นของคุณ",
    "bonusGoal": {
        "additionalInfo": "หากกิจกรรมทั้งหมดของคุณถูกติดตามโดยใช้แอปหรืออุปกรณ์ที่เชื่อมต่อ คุณจะได้รับโบนัสสองเท่า %{points}!",
        "additionalInfoNew": {
            "paragraph2": "โบนัส %{points} จะมอบให้หลังจากเป้าหมายสิ้นสุดลง คุณจะไม่ได้รับโบนัส %{points} สำหรับเป้าหมายที่คุณออกก่อนกำหนด"
        },
        "boldText": "โบนัส %{points} สองเท่า!",
        "markTitle": "เป้าหมายโบนัส"
    },
    "notify_me": "แจ้งเตือนฉัน",
    "bonusChallengeReward": "รางวัลชาเลนจ์โบนัส",
    "forCompletingChallenge": "สำหรับการเสร็จสมบูรณ์ %{challengeName}",
    "notifications_text": "การแจ้งเตือนช่วยให้คุณบรรลุเป้าหมายและติดตามการสนทนาได้",
    "type_here": "พิมพ์ที่นี่",
    "bonusEarned": "รับโบนัสแล้ว",
    "youEarnedBonus": "คุณได้รับโบนัสนี้!",
    "inviteOthersToChallenge": "เชิญผู้อื่นเข้าร่วมชาเลนจ์",
    "inviteOthersToYourTeam": "เชิญผู้อื่นเข้าร่วมทีมของคุณ",
    "manageTeam": "จัดการทีม",
    "ft": "ฟุต",
    "lbs": "ปอนต์",
    "cm": "ซม.",
    "kg": "กก.",
    "community": "ชุมชน",
    "chooseActivity": "เลือกกิจกรรม",
    "Recent": "ล่าสุด",
    "noActivities": "ไม่มีกิจกรรมที่ตรงกัน",
    "photoChooseText": "เลือก",
    "photoCancelText": "ยกเลิก",
    "signIn": {
        "missingEmail": "อีเมลบริษัทหายไป",
        "missingPassword": "กรุณากรอกรหัสผ่านให้เรียบร้อย",
        "invalidLogin": "เข้าสู่ระบบไม่ถูกต้อง",
        "accountLocked": "บัญชีของคุณถูกล็อก กรุณาติดต่อผู้ดูแลระบบ",
        "accountMayNotExist": "เราไม่มีบัญชีสำหรับอีเมลนี้ ลงทะเบียนเพื่อสร้างบัญชี",
        "wrongPassword": "รหัสผ่านผิด ลองอีกครั้ง หรือคลิกลืมรหัสผ่านเพื่อรีเซ็ต"
    },
    "deleteGoalBonusPoints": "หากคุณไม่ได้รับโบนัสที่เกี่ยวข้อง คุณจะไม่สามารถทำได้อีกต่อไป",
    "havent_tracked_goal": "คุณไม่ได้ติดตามกิจกรรมใด ๆ สำหรับเป้าหมายนี้",
    "trackActivity": {
        "search": "ค้นหากิจกรรม...",
        "text": "ติดตามกิจกรรม",
        "done": "เสร็จสิ้น",
        "discardChanges": "ละทิ้งการเปลี่ยนแปลง?",
        "discardMessage": "คุณแน่ใจหรือไม่ว่าต้องการออกและละทิ้งความคืบหน้าของคุณ",
        "discard": "ละทิ้ง",
        "limitMessage": "คุณสามารถติดตามได้ครั้งละเจ็ดวันเท่านั้น",
        "inputDescription": "จำนวน %{activity} สำหรับ %{date}",
        "gracePeriod": "คุณมี %{n} %{text} ในการติดตามกิจกรรมใด ๆ ที่พลาดไป"
    },
    "dates": "วันที่",
    "pickDates": "เลือกวันที่อื่น",
    "selectDates": "เลือกวันที่",
    "limitReached": "คุณถึงขีดจำกัดแล้ว",
    "activity": "กิจกรรม",
    "keepUpTheGoodWork": "ดีแล้วทำต่อไป!",
    "activityTracked": "กิจกรรมที่ติดตาม",
    "new": "ใหม่",
    "newFeatureTitle": "ติดตามกิจกรรมที่ง่ายขึ้นและเร็วขึ้น",
    "newFeatureText": "ไม่ว่าคุณจะติดตามกิจกรรมตั้งแต่วันนี้ จากอดีต หรือหลายวัน เราคิดว่าคุณจะหลงรักประสบการณ์ใหม่นี้",
    "gotIt": "เข้าใจแล้ว!",
    "frequencyViewHistory": "ดูรายละเอียด %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "ติดตามกิจกรรมใด ๆ เหล่านี้เพื่อก้าวไปสู่ %{challengeType} นี้"
    },
    "member": "สมาชิก",
    "weeklyBreakdown": "รายละเอียดรายสัปดาห์",
    "setGoals": {
        "earnPointsText": {
            "start": "ได้รับ",
            "end": "สำหรับการกำหนดเป้าหมายแรกของคุณ!"
        }
    },
    "weeklyGoalEnded": "สัปดาห์สิ้นสุดเมื่อ",
    "weekFinished": "คุณสำเร็จหนึ่งสัปดาห์จาก",
    "restartGoal": {
        "daysLeftToTrack": "คุณยังมี %{quantity} %{days} ในการติดตามความคืบหน้าที่ลืมไปจากสัปดาห์ที่ผ่านมา",
        "weekEnded": "สัปดาห์นี้สิ้นสุดแล้ว",
        "timesUp": "หมดเวลา!",
        "period": {
            "title": "ระยะเวลาเป้าหมาย",
            "text": "วันจันทร์ถึงวันเสาร์ ทุกสัปดาห์"
        }
    },
    "membersPlural": "สมาชิก",
    "startedADayAgo": "เริ่มแล้ว 1 วันที่ผ่านมา",
    "goalRestarted": "คุณรีสตาร์ทเป้าหมายนี้แล้ว",
    "weeklyGoals": "เป้าหมายรายสัปดาห์",
    "weeklyGoalsDescription": "เป้าหมายรายสัปดาห์จะต่ออายุตัวเองทุกวันจันทร์ คุณจึงรักษานิสัยที่ดีต่อสุขภาพได้เป็นระยะเวลานาน",
    "challengeEnded": "%{challengeType} นี้สิ้นสุดแล้ว",
    "goalEndedModalTitle": "หมดเวลา! %{challengeType} ของคุณสิ้นสุดแล้ว!",
    "yourProgress": "ความคืบหน้าของคุณ",
    "earn_withRewards": "ติดตามกิจกรรมเพื่อสุขภาพของคุณเพื่อรับ (%{pts}) และผ่านระดับ เมื่อคุณเลเวลอัพ คุณจะได้รับ %{currency}",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "ช่วงเวลาปัจจุบัน",
    "currentScore": "คะแนนปัจจุบัน",
    "viewActivityLog": "ดูบันทึกกิจกรรม",
    "balanceHistory": "ประวัติยอดคงเหลือของฉัน",
    "mymedibank": {
        "underAge": {
            "error": "แอป Live Better ให้บริการสำหรับผู้ใช้ที่มีอายุ 18 ปีขึ้นไปเท่านั้น กรุณาดูข้อมูลเพิ่มเติมในข้อกำหนดและเงื่อนไขของ Live Better"
        }
    },
    "enhancedHomePageInfo": "เราได้จัดเตรียมหน้าเว็บเพจหลักเรียบร้อยแล้ว! ตอนนี้มองเห็นความท้าทายและเป้าหมายของคุณได้ง่ายขึ้น ถึงเวลาติดตามแล้ว!",
    "levelUpTitle": "การเลื่อนระดับ",
    "levelUpDescription": "ผ่านระดับต่าง ๆ ด้วยการติดตามกิจกรรมและทำเป้าหมายและชาเลนจ์ให้เสร็จสมบูรณ์ เมื่อระดับคุณเพิ่มขึ้น คุณจะได้รับรางวัล %{currency}!",
    "achievementsDescription": "ปลดล็อกเหรียญตราพิเศษเหล่านี้เพื่อรับ %{currency} คลิกที่เหรียญตราเพื่อดูว่าคุณต้องทำอะไร",
    "bonusChallengesDescription": "เข้าร่วมและทำชาเลนจ์ที่มีโบนัส %{currency}",
    "earnWithPartners": {
        "title": "รับจากพันธมิตร",
        "description": "สมาชิก Medibank ที่มีโรงพยาบาลหรือความคุ้มครองพิเศษสามารถรับคะแนนจากการซื้อ\/กิจกรรมที่มีสิทธิ์กับพันธมิตร"
    },
    "browseAllPartners": "เรียกดูพันธมิตรทั้งหมด",
    "resetsIn": "รีเซ็ตใน %{daysNumber} วัน",
    "thisIsALot": "เป็นจำนวนที่มาก!",
    "areYouSure": "คุณแน่ใจหรือไม่?",
    "trackingALotMessage": {
        "days": "คุณกำลังติดตามมากกว่า 2,000 %{customPoints} ใน %{daysNum} วัน ค่อนข้างมากเลยทีเดียว!",
        "day": "คุณกำลังติดตามมากกว่า 2,000 %{customPoints} ใน 1 วัน ค่อนข้างมากเลยทีเดียว!"
    },
    "amSure": "ฉันแน่ใจ",
    "activeMinutesAndSleep": {
        "title": "การติดตามอุปกรณ์สำหรับช่วงเวลาแอกทีฟและสลีป",
        "description": "อุปกรณ์ของคุณบันทึกช่วงเวลาแอกทีฟระหว่างการออกกำลังกายที่มีความเข้มข้นปานกลางหรือสูง นั่นคือการออกกำลังกายที่มีคุณภาพดี! กำลังใช้อุปกรณ์เพื่อติดตามการนอนหลับของคุณ? คุณจะได้รับ %{points} สำหรับสิ่งนั้นเช่นกัน!"
    },
    "hourShort": "ชั่วโมง",
    "hoursShort": "ชั่วโมง",
    "secondsShort": "วินาที",
    "watchToEarn": "ดูเพื่อรับ",
    "oneParticipant": "ผู้เข้าร่วม 1 คน",
    "oneTeam": "1 ทีม",
    "numberOfTeams": "%{num} ทีม",
    "inviteToYourTeam": "เชิญเข้าร่วมทีมของคุณ",
    "inviteToThisChallenge": "เชิญเข้าร่วมชาเลนจ์นี้",
    "challengeInstructionText": "ติดตามกิจกรรมนี้เพื่อก้าวไปสู่ %{challengeType} ของคุณ",
    "showLess": "แสดงน้อยลง",
    "startsTomorrow": "เริ่มวันพรุ่งนี้",
    "deadlineDayLeft": "วันที่เหลือ",
    "deadlineDaysLeft": "วันที่เหลือ",
    "deviceBonus": "โบนัสอุปกรณ์",
    "appsAndDevices": {
        "header": "แอปและอุปกรณ์",
        "linked": "แอปและอุปกรณ์ที่เชื่อมโยงเหล่านี้กำลังติดตามไปยัง %{challengeType} นี้:",
        "noLinked": "ไม่มีแอปหรืออุปกรณ์ที่เกี่ยวข้องเชื่อมโยง",
        "link": "เชื่อมโยงโทรศัพท์ นาฬิกา หรือแอปของคุณเพื่อติดตามโดยอัตโนมัติ"
    },
    "yourGoals": "เป้าหมายของคุณ",
    "yourChallenges": "ชาเลนจ์ของคุณ",
    "position": "ตำแหน่ง",
    "team_success": "ความสำเร็จของทีม",
    "starts_in": "เริ่มใน",
    "team_challenge": "ชาเลนจ์ทีม",
    "your_progress_today": "ความคืบหน้าของคุณวันนี้",
    "your_daily_avarage": "ค่าเฉลี่ยรายวันของคุณ คือ",
    "this_week_progress": "ความคืบหน้าสัปดาห์นี้",
    "this_month_progress": "ความคืบหน้าเดือนนี้",
    "overall_progress": "ความคืบหน้าโดยรวม",
    "complete": "เสร็จสิ้น",
    "overallSuccess": "ความสำเร็จโดยรวม",
    "teamSuccessAverage": "ค่าเฉลี่ยความสำเร็จของทีม",
    "progressDetails": "รายละเอียดความคืบหน้า",
    "dayStreak": "%{n} วันติดต่อกัน!",
    "weekStreak": "%{n} สัปดาห์ติดต่อกัน!",
    "dailyProgress": "ความคืบหน้ารายวัน",
    "participantsSuccessCount": {
        "overall": "%{amount} จาก %{total} ผู้เข้าร่วมบรรลุเป้าหมาย",
        "day": "%{amount} จาก %{total} ผู้เข้าร่วมบรรลุเป้าหมายในวันนี้",
        "week": "%{amount} จาก %{total} ผู้เข้าร่วมบรรลุเป้าหมายในสัปดาห์นี้",
        "month": "%{amount} จาก %{total} ผู้เข้าร่วมบรรลุเป้าหมายในเดือนนี้"
    },
    "doubleBonusShort": "โบนัสสองเท่า!",
    "doubleBonusLong": "คุณได้รับโบนัสสองเท่า!",
    "recommendedGoalDescription": "เป้าหมายช่วยให้คุณติดตามความคืบหน้าและมีแรงจูงใจอยู่เสมอ!",
    "noParticipation": "ไม่มีการเข้าร่วม",
    "nothingToShow": "ดูเหมือนไม่มีอะไรจะแสดงในขณะนี้",
    "yourTeam": "ทีมของคุณ",
    "no_activity_title": "ไม่มีกิจกรรม",
    "brandSupport": {
        "description": "เราได้เพิ่มการรองรับการซิงค์กิจกรรมกับสมาร์ตวอตช์ส Polar และ Withings ถึงเวลาเคลื่อนไหว!"
    },
    "no_tracked_activities": "คุณยังไม่ได้ติดตามกิจกรรมใด ๆ",
    "button_leave_community": "ออกจากชุมชน",
    "button_delete_challenge": "ลบ %{challengeType}",
    "button_delete_community": "ลบชุมชน",
    "button_delete_activity": "ลบกิจกรรม",
    "library_header_description": "เนื้อหาต้นฉบับเพื่อให้ความรู้ มีส่วนร่วม และสร้างแรงบันดาลใจให้คุณในการเดินทางเพื่อสุขภาพที่ดีของคุณ",
    "library_searchbar": "ค้นหาไลบรารี่…",
    "library_page_header": "เนื้อหาต้นฉบับเพื่อให้ความรู้ มีส่วนร่วม และสร้างแรงบันดาลใจให้คุณในการเดินทางเพื่อสุขภาพที่ดีของคุณ",
    "onboarding_button_title": "เสร็จแล้ว",
    "refresh_bar": "คลิกที่นี่เพื่ออัปเดต",
    "content": {
        "min_read": "%{readingTime} นาทีในการอ่าน"
    },
    "noMembers": "ไม่มีสมาชิก",
    "saved": "บันทึกแล้ว",
    "forYou": "สำหรับคุณ",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} โดย",
    "youCanEarnThisBadge": "รับตรานี้ทุก ๆ ครั้ง %{period}",
    "emailPreferences": "",
    "unsubscribeText": "",
    "savingText": "",
    "wrongTryLater": "",
    "preferencesSaved": "",
    "recommendedForYou": "แนะนำสำหรับคุณ",
    "formerMember": {
        "label": "อดีตสมาชิก"
    },
    "selectionsFromLibrary": "ผลงานจากไลบรารี่ของเราที่คัดสรรมาเพื่อคุณ",
    "goalsInfo": {
        "desc1": "เพื่อมุ่งเน้นการปรับปรุงคุณภาพชีวิตของคุณ",
        "desc2": "คุณมีจำนวนเป้าหมายที่กำหนดไว้สูงสุดแล้ว"
    },
    "createMyOwn": "สร้างของฉันเอง",
    "isAllSet": "พร้อมแล้ว!",
    "undoLabel": "เลิกทำ",
    "terms": "ข้อกำหนด",
    "placeOrder": "ส่งคำสั่งซื้อ",
    "item": "รายการ",
    "redeemFor": "แลกรางวัลสำหรับ",
    "confirmYourOrder": "ยืนยันคำสั่งซื้อของคุณ",
    "orderComplete": "คำสั่งซื้อเสร็จสมบูรณ์",
    "redeemedFor": "แลกรางวัลแล้วสำหรับ",
    "orderDetails": "รายละเอียดคำสั่งซื้อ",
    "bonusGoalReward": "รางวัลเป้าหมายโบนัส",
    "orderSummary": "สรุปคำสั่งซื้อ",
    "logoutSSO": {
        "title": "คุณลงชื่อออกจาก %{programName} แล้ว",
        "description": "แล้วพบกันใหม่เร็วๆ นี้!",
        "signinAgain": "คลิกที่นี่เพื่อลงชื่อเข้าใช้อีกครั้ง"
    },
    "nothing_to_show": "ไม่มีอะไรจะแสดงในตอนนี้",
    "no_saved_content": "คุณไม่มีเนื้อหาใด ๆ ที่บันทึกไว้",
    "restarts_every_week": "เริ่มใหม่ทุกสัปดาห์",
    "myGoals": "เป้าหมายของฉัน",
    "goalGallery": "แกลเลอรีเป้าหมาย",
    "share_smth": "แชร์อะไรสักอย่าง…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "เป้าหมายก้าวของเราจะดูดีขึ้น!",
            "description": "สัปดาห์ของคุณแตกต่างกันเสมอ ตอนนี้เป้าหมายของคุณก็เช่นกัน! \n ด้วยโหมดอัจฉริยะ เป้าหมายจำนวนก้าวของคุณจะปรับเปลี่ยนตามกิจกรรมในชีวิตจริงของคุณ\n มีการกำหนดโดยคำนึงถึงความสำเร็จและความเป็นอยู่ที่ดีของคุณ",
            "action": "ลองตรวจสอบดู!"
        },
        "mePage": {
            "title": "ฉันคนใหม่",
            "description": "เราได้ออกแบบส่วนฉันใหม่เพื่อให้ค้นหาสิ่งที่คุณสนใจได้ง่ายขึ้น ลองดูสิ!",
            "letsSeeBtn": "มาดูกัน!",
            "llaterBtn": "อาจจะในภายหลัง"
        },
        "bellEAP": {
            "title": "ยินดีต้อนรับสู่แพลตฟอร์มออนไลน์ของโปรแกรมช่วยเหลือพนักงานและครอบครัวของคุณ!",
            "description": "สำรวจเครื่องมือและบริการเพื่อสนับสนุนความเป็นอยู่ที่ดีและความท้าทายในชีวิตที่คุณและสมาชิกครอบครัวที่มีคุณสมบัติเหมาะสม",
            "button": "เชื่อมต่อตอนนี้หรือไปที่หน้าลิงก์ด่วนได้ตลอดเวลา"
        },
        "quickActivityLogView": {
            "title": " วิธีที่รวดเร็วยิ่งขึ้นในการดูกิจกรรมล่าสุดของคุณ",
            "description": "ตอนนี้คุณสามารถคลิกที่แถบความคืบหน้าเพื่อดูบันทึกกิจกรรมของคุณได้แล้ว"
        }
    },
    "goalSmartMode": {
        "title": "โหมดอัจฉริยะ",
        "description": "รับเป้าหมายรายสัปดาห์ส่วนบุคคลตามระดับกิจกรรมล่าสุดของคุณ",
        "status": "โหมดอัจฉริยะอยู่ที่ระดับ %{status} สำหรับเป้าหมายนี้",
        "infoModal": {
            "descriptionOne": "เมื่อเปิดโหมดอัจฉริยะ เป้าหมายนี้จะเปลี่ยนทุกสัปดาห์ตามระดับกิจกรรมล่าสุดของคุณ",
            "descriptionTwo": "เราจะชาเลนจ์คุณในระดับที่เหมาะสมเพื่อเตรียมคุณให้พร้อมสำหรับความสำเร็จ",
            "instructions": ""
        },
        "settings": {
            "switch": "เปิดใช้งานโหมดอัจฉริยะสำหรับเป้าหมายจำนวนก้าวของฉัน",
            "description": "เมื่อเปิดโหมดอัจฉริยะ คุณจะได้รับเป้าหมายจำนวนก้าวใหม่ทุกต้นสัปดาห์"
        },
        "enableSmartMode": "เปิดใช้งานโหมดอัจฉริยะ",
        "settingsModal": {
            "descriptionTurnOn": "เป้าหมายจำนวนก้าวของคุณจะเปลี่ยนไปทุกสัปดาห์ตามกิจกรรมของคุณ",
            "descriptionTurnOff": "เป้าหมายจำนวนก้าวของคุณจะไม่ปรับให้เป็นแบบส่วนตัวทุกสัปดาห์อีกต่อไป"
        }
    },
    "On": "เมื่อ",
    "Off": "ปิด",
    "top_posts": "โพสต์ยอดนิยม",
    "most_recent": "ล่าสุด",
    "browseByTopic": "เรียกดูตามหัวข้อ",
    "video": "วิดีโอ",
    "enable": "เปิดใช้งาน",
    "turnOff": "ปิด",
    "new_post": "โพสต์ใหม่",
    "new_post_in": "โพสต์ใหม่ใน",
    "dailyTarget": "เป้าหมายรายวัน",
    "dailyTargetForWeek": "เป้าหมายรายวันสำหรับสัปดาห์",
    "showMyActivityLog": "แสดงบันทึกกิจกรรมของฉัน",
    "usersReacted": {
        "oneOther": "%{userName} และอีก 1 คน",
        "multipleOthers": "%{userName} และอีก %{count} คน"
    },
    "reactionsModal": {
        "title": "ช่องทางการเฉลิมฉลองเพิ่มเติม",
        "description": "เชียร์เพื่อนร่วมงานของคุณด้วยปฏิกิริยาโพสต์โซเชียลใหม่!"
    },
    "account": "บัญชี",
    "myWellbeingProfile": "โปรไฟล์ความเป็นอยู่ที่ดีของฉัน",
    "physicalDetailsDescription": "ข้อมูลนี้จำเป็นสำหรับการคำนวณคะแนนความเป็นอยู่ที่ดีของคุณ",
    "wellbeingInterests": "ความสนใจเรื่องความเป็นอยู่ที่ดี",
    "myWellbeingInterests": "ความสนใจด้านสุขภาพของฉัน",
    "preferredNameOptional": "ชื่อที่ต้องการ (ไม่บังคับ)",
    "basicPhysicalDetails": "รายละเอียดทางกายภาพเบื้องต้น",
    "notRegistered": {
        "infoModal": {
            "title": "เราไม่พบคุณ",
            "notInSystem": "ไม่ใช่ในระบบของเรา",
            "correctEmail": "ตรวจสอบให้แน่ใจว่าใช้บัญชีที่ถูกต้อง (โดยปกติแล้วจะเป็นอีเมลบริษัท) และตรวจสอบว่าพิมพ์ผิดหรือไม่",
            "emailHelp": "หากต้องการความช่วยเหลือเพิ่มเติม กรุณาส่งอีเมลถึงทีมสนับสนุนของเราที่"
        }
    },
    "dontHaveAccount": "ไม่มีบัญชี?",
    "wasThisHelpful": "ข้อมูลนี้มีประโยชน์หรือไม่",
    "healthScoreFeedbackModal": {
        "emojiSection": "หน้านี้และคะแนนความเป็นอยู่ที่ดีของคุณมีประโยชน์เพียงใด",
        "commentSectionText": "ควรมีการปรับปรุงอย่างไรอีกบ้าง",
        "commentSectionPlaceholder": "เพิ่มความคิดเห็น...",
        "thankYouModal": "ขอบคุณสำหรับข้อเสนอแนะของคุณ!"
    },
    "number_connected": "%{numDevices} เชื่อมต่อแล้ว",
    "searchPlaceHolder": "ค้นหา...",
    "noTeamsFound": "ไม่พบทีม",
    "join_a_challenge": "เข้าร่วมชาเลนจ์",
    "me_page_titles": {
        "goal": {
            "singular": "เป้าหมาย",
            "plural": "เป้าหมาย"
        },
        "challenge": {
            "singular": "ชาเลนจ์",
            "plural": "ชาเลนจ์"
        }
    },
    "seeMoreText": "…ดูเพิ่มเติม",
    "adjust_entry": "กรุณาปรับรายการ",
    "overTracking": {
        "title": "คำเตือนการติดตามมากเกินไป",
        "desc1": {
            "singular": "รายการนี้จะถูกตรวจสอบ",
            "plural": "รายการเหล่านี้จะถูกตรวจสอบ"
        },
        "desc2": "การติดตามมากเกินไปโดยเจตนาอาจส่งผลให้บัญชีถูกระงับ",
        "button_edit": "แก้ไขรายการของฉัน",
        "button_confirm": "ส่งตามที่เป็นอยู่"
    },
    "oneEventAttendee": "1 ผู้เข้าร่วม",
    "multipleEventAttendees": "%{num} ผู้เข้าร่วม",
    "to": "ถึง",
    "eventBonusFull": "คุณจะได้รับ %{number} bonus %{points} จากการเข้าร่วมอีเวนต์นี้",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "คุณชอบบทความนี้หรือไม่",
    "didYouLikeVideo": "คุณชอบวิดีโอนี้หรือไม่",
    "tellUsMore": "บอกเราเพิ่มเติม...",
    "thanksForFeedback": "ขอบคุณสำหรับข้อเสนอแนะของคุณ!",
    "challengesSubtitle": "บรรลุเป้าหมายไปพร้อมกับผู้เข้าร่วมคนอื่น ๆ หรือเล่นเพื่อชัยชนะ!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "รหัสผ่านของคุณได้รับการจัดการผ่านบัญชี %{telusVC} ของคุณ",
            "button": "เปลี่ยนรหัสผ่าน %{virtualCare} ของฉัน"
        }
    },
    "actions": "การดำเนินการ",
    "onAndUpcoming": "ที่ดำเนินการอยู่และที่จะมาถึง",
    "termsAndPrivacyPolicyNew": "เมื่อดำเนินการต่อ จะถือว่าคุณตกลงที่จะ",
    "invitedToTeam": "ได้เชิญทีมของ %{firstName} %{lastName}",
    "decline": "ปฏิเสธ",
    "invitedToChallenge": "เชิญโดย %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "คุณไม่ได้กำหนดเป้าหมายใด ๆ"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "คุณไม่ได้อยู่ในชาเลนจ์ใด ๆ",
        "buttonLabel": "สำรวจชาเลนจ์"
    },
    "menu": "เมนู",
    "everyone": "ทุกคน",
    "confirmEmployeeID": "ยืนยันรหัสพนักงาน",
    "employeeIDNoMatch": "รหัสเหล่านี้ยังไม่ตรงกัน",
    "hidePost": "ซ่อนโพสต์โดย %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "ผู้ใช้ที่ถูกซ่อน",
            "message": "คุณจะไม่เห็นโพสต์จากผู้ใช้รายนี้อีกต่อไป"
        }
    },
    "moderateHideUserDescription": "การซ่อนโพสต์สำหรับผู้ใช้รายนี้จะลบเนื้อหาเฉพาะของผู้ใช้ออกจากสตรีม",
    "startsInOneDay": "เริ่มต้นในอีก 1 วัน",
    "endsInOneDay": "สิ้นสุดในอีก 1 วัน",
    "endsToday": "สิ้นสุดวันนี้",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "ไม่ใช่ในระบบของเรา คุณกรอกถูกต้องหรือไม่",
            "administrator": "หากคุณเป็นพนักงานใหม่ เราอาจยังไม่มีรหัสพนักงานของคุณ กรุณาสอบถามผู้ดูแลระบบของคุณว่าควรลองอีกครั้งเมื่อใด",
            "emailNotInSystem": "หากคุณเป็นพนักงานใหม่ อีเมลของคุณอาจยังไม่ได้เพิ่มเข้าสู่ระบบของเรา กรุณาสอบถามผู้ดูแลระบบของคุณว่าควรลองอีกครั้งเมื่อใด",
            "eligibleEmail": "ไม่ใช่อีเมลที่มีคุณสมบัติเหมาะสม คุณกรอกถูกต้องหรือไม่"
        }
    },
    "oneMember": "1 สมาชิก",
    "programCode": {
        "infoModal": {
            "unique": "บริษัทของคุณมีรหัสโปรแกรมเฉพาะ ซึ่งโดยปกติแล้วจะแจ้งให้คุณทราบทางอีเมล",
            "support": "หากคุณไม่พบรหัสของคุณ ให้ติดต่อผู้ดูแลระบบโปรแกรมสุขภาพของคุณ หรือส่งอีเมลไปที่ support@sproutatwork.com พร้อมระบุชื่อบริษัทของคุณ"
        },
        "instructions": "กรอกรหัสโปรแกรมที่นายจ้างของคุณให้ไว้เพื่อเริ่มต้น"
    },
    "whatsMyProgramCode": "รหัสโปรแกรมของฉันคืออะไร",
    "enjoyApp": "เพลิดเพลินกับแอปมือถือของเรา",
    "programCodeLabel": "รหัสโปรแกรม",
    "createdByMembersChallenges": "สร้างโดยสมาชิก",
    "invites": "เชิญ",
    "recommendedContentTitle": "ไลบรารี่ที่คัดสรรมาเพื่อคุณ",
    "amountExchanged": "จำนวนที่แลกเปลี่ยน",
    "orderStatus": "สถานะคำสั่งซื้อ",
    "orderSuccessfulyyItemForConfirmation": "คำสั่งซื้อสำเร็จ! ส่งการยืนยันไปที่ %{email}",
    "orderedOnDateText": "สั่งซื้อแล้วใน %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "เข้าร่วมชุมชน",
            "description": "ชุมชนเชื่อมโยงผู้คนที่มีความสนใจเหมือนกัน คุณสามารถเข้าร่วมหรือออกจากชุมชนได้ตลอดเวลา"
        },
        "objectives": {
            "title": "วัตถุประสงค์ของฉัน",
            "description": "เราจะสามารถช่วยคุณเริ่มต้นหรือทำสิ่งใดต่อไปได้บ้าง เราจะใช้ข้อมูลนี้เพื่อปรับปรุงคำแนะนำของเรา"
        },
        "topics": {
            "title": "หัวข้อความเป็นอยู่ที่ดีของฉัน",
            "description": "คุณจะเห็นเคล็ดลับเพิ่มเติมและเนื้อหาวิธีใช้เกี่ยวกับตัวเลือกเหล่านี้"
        }
    },
    "recommendedCardDesc": "กำหนดเป้าหมายสูงสุด 3 เป้าหมายเพื่อมุ่งเน้นที่การปรับปรุงความเป็นอยู่ที่ดีของคุณ",
    "accessibility": {
        "track_activity": "ติดตามกิจกรรม",
        "cardbody": "เนื้อความของบัตร",
        "cardcontainer": "อุปกรณ์ใส่บัตร",
        "cardfooter": "ส่วนท้ายของบัตร",
        "unstartedChallengeHeader": "ชาเลนจ์ที่ยังไม่เริ่ม",
        "activeOrEndedChallengeWrapper": "ตัวสรุปชาเลนจ์",
        "activeOrEndedChallengeHeader": "ส่วนหัวชาเลนจ์",
        "goalHeader": "ส่วนหัวเป้าหมาย",
        "openOptions": "เปิดตัวเลือก"
    },
    "teams": {
        "teamInvites": "คำเชิญทีม",
        "findTeam": "หาทีม",
        "teamFull": "ทีมเต็มแล้ว"
    },
    "deleteAccountText": "ลบบัญชี Sprout At Work ของคุณและข้อมูลทั้งหมดอย่างถาวร",
    "deleteAccountButtonTitle": "ลบบัญชีของฉัน",
    "joinTeamActionSheetText": "เข้าร่วมหรือสร้างทีมเพื่อเข้าร่วมในชาเลนจ์นี้",
    "frequencyNone": "ไม่มี",
    "quickLinkTitle": "ลิงก์ด่วน",
    "moreTab": "มากขึ้น",
    "addedBy": "เพิ่มโดย%{companyName}",
    "teamsTitle": "ทีม",
    "helpAndSupport": "การช่วยเหลือและการสนับสนุนแอป",
    "feedbackTitle": "ให้ข้อเสนอแนะ",
    "feedbackDescription": "บอกเราว่าคุณชอบอะไรเกี่ยวกับแอปนี้ และเราควรปรับปรุงส่วนใดบ้าง",
    "leaveTeamAction": "ออกจากทีม",
    "teamActions": "การดำเนินการทีม",
    "leaveTeamLeaveChallenge": "การออกจากทีมนี้หมายความว่าคุณกำลังออกจากชาเลนจ์ คุณจะต้องเข้าร่วมทีมเพื่อเข้าร่วมต่อไป",
    "familyMembers": "สมาชิกครอบครัว",
    "familyMembersDescription": "สมาชิกครอบครัวจะต้องมีอายุมากกว่า 16 ปี สมาชิกเหล่านั้นจะสามารถเข้าถึงและมองเห็นทั่วทั้งแพลตฟอร์มได้อย่างครบถ้วน",
    "learnMoreButton": "เรียนรู้เพิ่มเติม",
    "thvcSelection": {
        "signUpUsingTelus": "สมัครโดยใช้บัญชี TELUS Health Virtual Care ของคุณ",
        "loginGetStarted": "เข้าสู่ระบบ Virtual Care เพื่อเริ่มต้น",
        "haveAccount": "คุณมีบัญชี Virtual Care หรือไม่",
        "emailHelp": "ต้องการความช่วยเหลือหรือไม่ ติดต่อทีมสนับสนุนของเราได้ที่",
        "yes": "ใช่",
        "signMeUp": "ไม่ใช่ สมัครให้ฉันเลย"
    },
    "inviteFamilyMember": {
        "label": "เชิญสมาชิกครอบครัว",
        "btn": "ส่งคำเชิญ",
        "email": "อีเมล*",
        "firstName": "ชื่อจริง*",
        "lastName": "นามสกุล*",
        "approval": "ฉันยืนยันว่าฉันได้รับการอนุมัติให้เชิญสมาชิกครอบครัวรายนี้ไปยัง %{company}",
        "multiSelect1": "สมาชิกครอบครัวรายนี้เป็นผู้บรรลุนิติภาวะในภูมิภาคของคุณหรือไม่",
        "multiSelect2": "สมาชิกครอบครัวรายนี้มีอายุอย่างน้อย 16 ปีใช่หรือไม่",
        "confirmTermsPolicy": "ฉันยืนยันว่าฉันเป็นผู้ปกครองตามกฎหมายของบุคคลนี้ ในความเห็นของฉัน ผู้อยู่ในอุปการะมีความเป็นผู้ใหญ่เพียงพอที่จะยอมรับการใช้แพลตฟอร์ม และฉันยินยอมให้พวกเขาเข้าร่วม ฉันจะอธิบายให้ผู้อยู่ในอุปการะทราบถึงความจำเป็นในการดำเนินการอย่างรับผิดชอบบนแพลตฟอร์ม และวิธีการที่แพลตฟอร์มเก็บรวบรวมและใช้ข้อมูลของพวกเขา",
        "onTheirBehalf": "ในนามของพวกเขา",
        "confirm": "ใช่ ฉันยืนยันตามข้างต้น",
        "warning": "สมาชิกในครอบครัวต้องมีอายุอย่างน้อย 16 ปีจึงจะสมัครได้",
        "errorMsg": "กรุณาตรวจสอบข้อผิดพลาดก่อนที่จะพยายามดำเนินการต่อ"
    },
    "deleteFamilyMember": {
        "desc": "การลบบัญชีของสมาชิกครอบครัวจะมีผลถาวร",
        "btn": "ลบสมาชิกครอบครัว",
        "confirmation": {
            "title": "ลบสมาชิกครอบครัวแล้ว",
            "desc": "บัญชีของ %{fullName} ถูกลบแล้ว"
        },
        "areYouSure": "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีของ %{fullName}"
    },
    "familyInvitationStatus": {
        "active": "ใช้งานอยู่",
        "sent": "ส่งคำเชิญแล้ว"
    },
    "familyInvitationSent": {
        "title": "ส่งอีเมลคำเชิญแล้ว",
        "desc": "ส่งคำเชิญไปยัง % แล้ว{fullName}"
    },
    "programCodeSignup": "กรุณาใช้ %{programCodeLabel} %{programCode} หลังจากคลิก '%{signUpLabel}'",
    "notJoinedCommunityLabel": "เข้าร่วมชุมชนนี้เพื่อดูว่าสมาชิกกำลังแบ่งปันอะไร",
    "moda": {
        "installApp": {
            "title": "โปรดทราบ: สมาชิก Moda Health สามารถเข้าถึง Sprout at Work ได้ผ่านทางแดชบอร์ดสมาชิกเท่านั้น",
            "subtitle": "หากต้องการใช้ Sprout at Work ในสมาร์ทโฟนของคุณ:",
            "stepOneA": "1. ติดตั้งแอปมือถือ Sprout at Work",
            "stepOneB": "อย่าลงทะเบียนหรือเข้าสู่ระบบบนแอปพลิเคชันมือถือ",
            "stepTwo": "2. เข้าสู่ระบบ Member Dashboard บนโทรศัพท์มือถือของคุณ",
            "stepThree": "3. เรียกดูโปรแกรมสุขภาพ Sprout และทำตามลิงก์นั้น ซึ่งควรจะเปิดแอปมือถือ Sprout at Work"
        }
    },
    "HRISLocationSelection": {
        "title": "คุณทำงานจากประเทศไหน?"
    },
    "visibilitySettings": {
        "title": "การตั้งค่าการมองเห็น",
        "desc1": "เป็นไปได้หรือไม่ที่สมาชิกแอป Wellbeing คนอื่นๆ ในบริษัทของคุณจะมองเห็นได้",
        "desc2": "คุณสามารถเปลี่ยนแปลงได้ในภายหลัง",
        "moreTextQ1": "คนอื่นสามารถเห็นอะไรได้บ้าง?",
        "moreTextAnswer1": "ชื่อ รูปโปรไฟล์ และรายละเอียดโปรไฟล์พื้นฐานของคุณ (เช่น แผนกและที่ตั้ง) จะปรากฏแก่คนในบริษัทของคุณ ทำให้แอปมีสังคมและสนุกสนานมากขึ้น",
        "moreTextQ2": "ฉันจะปรากฏที่ไหน?",
        "moreTextAnswer2": "คุณจะถูกแสดงเป็นผู้เข้าร่วมในการท้าทาย ชุมชน และกิจกรรมที่คุณเข้าร่วม ในลีดเดอร์บอร์ด และในผลการค้นหา คุณสามารถปรับเปลี่ยนได้ในภายหลัง",
        "moreTextAnswer3": "เราไม่แชร์หรือแสดงข้อมูลสุขภาพส่วนบุคคลของคุณ เช่น ส่วนสูง น้ำหนัก หรือกิจกรรมที่คุณติดตาม",
        "btnAgree": "มันโอเคที่จะแสดงให้ฉันดู",
        "btnDisagree": "อย่าให้สมาชิกคนอื่นเห็นฉัน"
    },
    "privacyPolicyReadMore": "หากต้องการเรียนรู้เพิ่มเติม โปรดอ่านนโยบายความเป็นส่วนตัวของเรา",
    "tellMeMore": "บอกฉันเพิ่มเติม",
    "helpUsImprove": {
        "title": "ช่วยเราปรับปรุง",
        "desc1": "เราใช้เครื่องมือที่บันทึกข้อมูลการใช้งานที่ไม่ระบุชื่อ การเห็นแนวโน้มของสิ่งที่ผู้คนดูและคลิกช่วยให้เราปรับปรุงแอปได้ดีขึ้น",
        "desc2": "คุณสามารถปิดการตั้งค่านี้ได้ตลอดเวลา",
        "moreTextQ1": "สิ่งที่เรามอง",
        "moreTextAnswer1": "เราสนใจแนวโน้มและสถิติโดยรวม ดังนั้นเราจึงไม่ดูข้อมูลในระดับบุคคล",
        "moreTextQ2": "เราไม่เปิดเผยข้อมูลของคุณ",
        "moreTextAnswer2": "ข้อมูลนี้มีให้เฉพาะผู้ที่สร้างแอปนี้เพื่อช่วยปรับปรุงให้ดีขึ้นเท่านั้น เราไม่แบ่งปันข้อมูลนี้กับบริษัทอื่น รวมถึงนายจ้างของคุณด้วย",
        "moreTextQ3": "ข้อมูลของคุณไม่ระบุชื่อ",
        "moreTextAnswer3": "เครื่องมือของเราจะไม่บันทึกชื่อ ตำแหน่งที่แน่นอน หรือข้อมูลสุขภาพส่วนบุคคลของคุณ",
        "btnAgree": "ติดตามการใช้งานของฉันโดยไม่เปิดเผยตัวตน",
        "btnDisagree": "ฉันไม่ยินยอมให้ติดตาม"
    },
    "deleteAccountTextAppName": "ลบบัญชี %{appName} และข้อมูลทั้งหมดของคุณอย่างถาวร",
    "anonymousMember": "สมาชิกที่ไม่ระบุชื่อ",
    "activitiesToTrack": {
        "title": "กิจกรรมที่น่าติดตาม"
    },
    "includedInMembership": "รวมอยู่ในการเป็นสมาชิกของคุณ",
    "invalidDate": "วันที่ไม่ถูกต้อง",
    "discardsStreamPost": {
        "discardTitle": "ทิ้งโพสต์ใช่ไหม",
        "discardChangesTitle": "ยกเลิกการเปลี่ยนแปลงใช่ไหม",
        "discardPostText": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกโพสต์ของคุณ?",
        "discardPostChangesText": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเปลี่ยนแปลงของคุณ"
    },
    "trackActivityModalTitle": "ติดตามสำหรับ %{date}",
    "noPosts": "ไม่มีโพสต์ให้ดู",
    "goalIcon": "ไอคอนเป้าหมาย",
    "resetsOn": "รีเซ็ตเมื่อ %{date}",
    "clickForHelp": "คลิกที่นี่เพื่อขอความช่วยเหลือ",
    "trackActivityInputLabel": "ป้อน %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "รายการที่พบ",
    "tagState": {
        "active": "คล่องแคล่ว",
        "notActive": "ไม่ใช้งาน"
    },
    "bonusCheckmarkLabel": "ได้รับคะแนนโบนัส %{bonusLabel} คะแนนเมื่อทำสำเร็จ",
    "searchBar": {
        "searching": "กำลังค้นหา %{term}",
        "result": "ผลการค้นหา"
    },
    "activityProgress": "ความคืบหน้าของกิจกรรม - %{levelName} %{percentFilled}% - รีเซ็ตใน %{daysLeft} วัน",
    "bookmark": {
        "remove": "ลบออกจากรายการที่บันทึกไว้",
        "save": "บันทึกรายการนี้"
    },
    "bonusMark": {
        "earn": "รับ %{qty} %{points}",
        "earned": "คุณได้รับ %{qty} %{points}"
    },
    "tabToTrackActivity": "แตะเพื่อติดตามกิจกรรม",
    "videoElementLabel": "%{title} ระยะเวลา %{duration} แตะสองครั้งเพื่อเล่นวิดีโอ",
    "updatedPoliciesPopup": {
        "title": "เราได้อัปเดตข้อกำหนดของเราแล้ว",
        "details": "เราขอแนะนำให้คุณอ่านนโยบายที่อัปเดตของเราด้านล่าง:",
        "disclaimer": "การคลิกปุ่มด้านล่างแสดงว่าคุณยอมรับและรับทราบนโยบายที่อัปเดต",
        "agree": "ฉันเห็นด้วย"
    },
    "editActivityLog": {
        "canNotEditItem": "คุณไม่สามารถแก้ไขรายการนี้ได้",
        "canNotEditItemDescription": "ไม่สามารถแก้ไขกิจกรรมที่ซิงค์จากอุปกรณ์หรือแอพได้",
        "updatedItem": "อัปเดตกิจกรรมแล้ว",
        "updatedItemDescription": "บันทึกการเปลี่ยนแปลงของคุณแล้ว"
    },
    "login_with_email": "เข้าสู่ระบบด้วยอีเมล",
    "healthconnect_not_available": "ไม่สามารถเชื่อมต่อกับ Health Connect ได้ ในแอป Health Connect โปรดตรวจสอบให้แน่ใจว่าได้เปิดใช้งานการอนุญาตแล้ว",
    "registrationField": {
        "required": {
            "firstName": "กรุณากรอกชื่อของคุณ",
            "lastName": "กรุณากรอกนามสกุลของคุณ",
            "email": "กรุณากรอกอีเมลที่ถูกต้อง",
            "password": "กรุณาใส่รหัสผ่านที่ถูกต้อง"
        }
    },
    "settingsErrorMessage": {
        "firstName": "กรุณากรอกชื่อของคุณ",
        "lastName": "กรุณากรอกนามสกุลของคุณ"
    },
    "requiredValidValue": "โปรดป้อนค่าที่ถูกต้องสำหรับ %{value} ของคุณ",
    "passwordHidden": "ซ่อนรหัสผ่าน แตะเพื่อแสดงรหัสผ่าน",
    "passwordShown": "รหัสผ่านที่แสดง แตะเพื่อซ่อนรหัสผ่าน",
    "libraryHeaderContent": {
        "category": "",
        "points": "รับ %{points} คะแนน"
    },
    "scoreCurrentPeriod": "%{text} มาจาก %{startDate} ถึง %{endDate}",
    "scoreCurrent": "%{text} คือ %{points} คะแนน",
    "abbotResetPasswordModal": {
        "title": "คุณกำลังพยายามเข้าถึงบัญชีจากปีที่แล้วหรือไม่?",
        "text": " หากคุณสมัครเข้าร่วมการแข่งขันเมื่อปีที่แล้ว บัญชีนั้นจะใช้งานไม่ได้อีกต่อไป คุณต้องลงทะเบียนสำหรับปีนี้",
        "goToResetPasswordBtn": "ฉันลงทะเบียนใน %{currentYear}",
        "goToSignupBtn": "ฉันไม่ได้ลงทะเบียนใน %{currentYear}"
    },
    "challengeRegistrationClosed": "การลงทะเบียนปิดแล้ว - การท้าทายได้เริ่มต้นแล้ว"
};